
const sharedVoiceReasons = {
  "not_granted": "Váš účet nemá oprávnění k hlasu.",
  "disabled": "Hlasový režim je vypnutý.",
  "spend_limit": "Byl dosažen měsíční limit útraty.",
  "provider_error": "Hlasová služba selhala. Zkuste to znovu.",
};

export const cs = {
  // Browser mirror of src/push/messages.ts; tests/contract/pushCopy.test.ts pins the server copy.
  pushFailure: {"title":"Konverzace selhala","provider":"Chyba poskytovatele AI","chetty":"Chyba Chettyho"},
  totp: {
    qrTitle: "QR kód",
    title: "Dvoufázové ověření",
    description: "Přihlášení heslem ochráníte šestimístným kódem z ověřovací aplikace. Přihlášení přes Microsoft se řídí pravidly Vaší organizace.",
    code: "Kód z ověřovací aplikace",
    codeValidFor: "Kód je platný ještě {seconds} s",
    codeSecondsLeft: "{seconds} s",
    verify: "Ověřit",
    loginTitle: "Ověřte přihlášení",
    lost: "Ztratili jste ověřovací aplikaci? Obraťte se na jiného správce. Záložní kódy ani obejití heslem nejsou k dispozici.",
    invalid: "Kód se nepodařilo ověřit. Vyčkejte na nový kód nebo začněte přihlášení znovu.",
    expired: "Ověření vypršelo. Začněte znovu.",
    enable: "Zapnout dvoufázové ověření",
    confirm: "Potvrdit a zapnout",
    disable: "Vypnout dvoufázové ověření",
    disabled: "Vypnuto",
    enabled: "Zapnuto",
    enabledAt: "Zapnuto {date}",
    trusted: "Tato relace je důvěryhodná do {date}.",
    untrusted: "U této relace není zaznamenáno ověření druhým faktorem.",
    trustWarning: "Důvěra platí po nastavenou dobu relace, nikoli podle samostatného nastavení zařízení. Kdo získá soubor cookie této relace, má přístup k účtu až do vypršení nebo odvolání.",
    adminWarning: "Před zapnutím zajistěte dalšího správce nebo funkční přihlášení přes Microsoft. Jediný správce, který ztratí ověřovací aplikaci, nemá možnost obnovy. Záložní kódy, skrytý reset ani obnova přes CLI neexistují.",
    password: "Současné heslo",
    passwordRefused: "Současné heslo se nepodařilo ověřit.",
    setup: "Naskenujte QR kód v ověřovací aplikaci nebo zadejte nastavovací klíč ručně.",
    manualKey: "Nastavovací klíč",
    copyKey: "Kopírovat nastavovací klíč",
    copied: "Nastavovací klíč zkopírován",
    qrAlt: "QR kód pro ověřovací aplikaci",
    qrFailed: "QR kód se nepodařilo vytvořit. Zadejte nastavovací klíč ručně.",
    expires: "Nastavení vyprší {date}.",
    pending: "Existuje nedokončené nastavení, ale jeho klíč již nelze zobrazit. Zrušte je a začněte znovu.",
    cancelSetup: "Zrušit nastavení",
    disableWarning: "Použijte nový, dosud nepoužitý kód. Vypnutí odhlásí všechny relace včetně této. API tokeny a spárovaná zařízení zůstanou beze změny.",
    loadError: "Bezpečnostní údaje se nepodařilo načíst.",
    actionError: "Akci se nepodařilo dokončit. Před opakováním ověřte aktuální stav.",
    cleanupUnverified: "Změna byla uložena, ale uzavření relací se nepodařilo ověřit.",
    stale: "Bezpečnostní nastavení se změnilo nebo nastavení vypršelo. Načtěte aktuální stav.",
    sessions: "Přihlášené relace",
    sessionsHint: "Název vychází z údajů prohlížeče při přihlášení. Odvolání relace krátce znovu připojí ostatní spojení tohoto účtu v prohlížeči.",
    unknownDevice: "Neznámé zařízení",
    current: "Současná relace",
    started: "Začátek {date}",
    expiresSession: "Vyprší {date}",
    methodPassword: "Heslo",
    methodTotp: "Heslo a ověřovací aplikace",
    methodSso: "Microsoft",
    revoke: "Odvolat relaci",
    revokeTitle: "Odvolat tuto relaci?",
    revokeBody: "Tato relace bude odhlášena. Ostatní spojení účtu v prohlížeči se krátce znovu připojí. API tokeny a spárovaná zařízení zůstanou beze změny.",
    emptySessions: "Žádné přihlašovací relace.",
    loadMore: "Načíst další",
    reset: "Resetovat dvoufázové ověření",
    resetTitle: "Resetovat ověření účtu {name}?",
    resetBody: "Nejprve nezávisle ověřte totožnost uživatele. Reset vypne jeho ověření a odhlásí všechny jeho relace v prohlížeči. Uživatel musí ověření znovu nastavit. Nejde o samoobslužnou obnovu.",
    proofPassword: "Použít mé heslo",
    proofSso: "Použít mé nedávné přihlášení přes Microsoft",
    proofSsoHint: "Vyžaduje přihlášení přes Microsoft za posledních pět minut. Jinak se odhlaste a znovu přihlaste přes Microsoft.",
    resetSuccess: "Dvoufázové ověření resetováno.",
    resetError: "Reset byl odmítnut nebo jej nelze potvrdit. Před opakováním znovu načtěte účet.",
    rateRetry: "Příliš mnoho pokusů. Zkuste to znovu za {seconds} sekund.",
  },
  connectionStatus: {
    computerOffline: 'Počítač {computer} je offline; práce zůstává zachována',
    unknown: 'Stav připojení není znám',
    connected: 'Připojeno',
    connecting: 'Připojování',
    disconnected: 'Odpojeno',
    pending: 'Čeká se na dokončení přípravy',
    stale: 'Poslední známý stav; aktuální stav není znám',
    freshnessUnknown: 'Aktuálnost údaje není známa',
    transport: 'Připojení',
    model: 'Požadavek na model',
    waitingForComputer: 'Čeká se na počítač projektu; práce zůstává zachována',
    remoteRetryUnknown: 'Průběh opakování na vzdálené straně není znám',
  },
  connectionFailure: {
    startFailed: 'Konverzaci se nepodařilo otevřít',
    policyUnavailable: 'Nastavení opakování připojení není dostupné',
    streamFailed: 'Připojení selhalo',
  },
  /** Labels of the closed menu-action vocabulary (`components/ui/menuActions.ts`). */
  menuActions: {
    delete: 'Smazat',
    remove: 'Odebrat',
    edit: 'Upravit',
    replace: 'Nahradit',
    rename: 'Přejmenovat',
    duplicate: 'Duplikovat',
    copy: 'Kopírovat',
    enable: 'Zapnout',
    disable: 'Vypnout',
    archive: 'Archivovat',
    restore: 'Obnovit',
    reset: 'Obnovit výchozí',
    open: 'Otevřít',
    view: 'Detail',
    move: 'Přesunout',
    pin: 'Připnout',
    unpin: 'Odepnout',
    mute: 'Ztlumit',
    unmute: 'Zrušit ztlumení',
    download: 'Stáhnout',
    select: 'Vybrat',
    add: 'Přidat',
    settings: 'Nastavení',
    update: 'Aktualizovat',
    invite: 'Pozvat',
    leave: 'Opustit',
    connect: 'Připojit',
    disconnect: 'Odpojit',
  },
  conversationIcon: { title: 'Ikona konverzace', change: 'Změnit ikonu: {title}' },
  identityIcons: {
    Briefcase: 'Aktovka',
    Server: 'Server',
    Database: 'Databáze',
    Heart: 'Srdce',
    Code: 'Kód',
    Home: 'Dům',
    Star: 'Hvězda',
    Folder: 'Složka',
    Globe: 'Zeměkoule',
    Book: 'Kniha',
    Cpu: 'Procesor',
    Terminal: 'Terminál',
    Rocket: 'Raketa',
    Lightbulb: 'Žárovka',
    Target: 'Terč',
    Calendar: 'Kalendář',
    DollarSign: 'Dolar',
    ShoppingCart: 'Nákupní košík',
    Music: 'Hudba',
    Camera: 'Fotoaparát',
    MapPin: 'Místo na mapě',
    Zap: 'Blesk',
    Flag: 'Vlajka',
    Bookmark: 'Záložka',
    MessageCircle: 'Chatová bublina',
  },
  voice: {
    "settingsSection": "Hlasový režim",
    "accountSection": "Hlas",
    "settingsHint": "Poskytovatel, modely a délka hovorů.",
    "accountHint": "Váš hlas, jazyk a zpětné volání.",
    "settings": {
      "title": "Hlasový režim",
      "enabled": "Zapnuto",
      "enabledHint": "Hovory a hlasové zprávy používají poskytovatele nastaveného pro tuto instanci. Každý účet musí mít také oprávnění k hlasu.",
      "provider": "Poskytovatel",
      "providerHint": "Podporováni jsou poskytovatelé OpenAI nebo Azure OpenAI s API klíčem. Azure vyžaduje adresu .../openai/v1 a nasazení Global Standard se stejným názvem jako každý model.",
      "chooseProvider": "Vyberte poskytovatele",
      "callModel": "Model pro hovory",
      "callModelHint": "Hovory s GPT-Live 1 stojí 0,05 USD za minutu a účtují se po sekundách, včetně čekání. Práce pro konverzaci se účtuje samostatně.",
      "transcriptionModel": "Model pro přepis",
      "dictationModel": "Model pro diktování",
      "dictationModelHint": "Přepisuje Vaši řeč do pole zprávy, zatímco mluvíte. Účtuje se po minutách zvuku.",
      "speechModel": "Model pro řeč",
      "maxCallSeconds": "Maximální délka hovoru",
      "ringSeconds": "Doba vyzvánění",
      "seconds": "{n} s",
      "holdSeconds": "Čekání na lince",
      "holdSecondsHint": "Jak dlouho Chetty čeká na lince na výsledek úkolu. Čekání je součástí placeného hovoru. Po této době se rozloučí a po dokončení zavolá zpět, pokud máte v účtu zapnuté zpětné volání. Při hodnotě 0 se rozloučí hned.",
      "holdSecondsNever": "Bez čekání",
      "contextMessages": "Zprávy, které Chetty v hovoru zná",
      "contextMessagesHint": "Kolik posledních psaných zpráv si Chetty před hovorem přečte. Výsledky nástrojů se nezapočítávají. Více zpráv znamená lepší přehled bez změny sazby hovoru.",
      "noProvider": "Žádný vhodný poskytovatel",
      "noProviderHint": "Přidejte v nastavení AI poskytovatele OpenAI nebo Azure OpenAI s API klíčem. Azure vyžaduje adresu .../openai/v1 a nasazení Global Standard se stejným názvem jako každý model.",
      "chooseModels": "Před zapnutím hlasu vyberte podporovaného poskytovatele a nabízené modely.",
      "loadError": "Nastavení hlasu se nepodařilo načíst."
    },
    "account": {
      "title": "Hlas",
      "voice": "Hlas",
      "voiceHint": "Hlas, kterým s Vámi Chettym mluví při hovorech. Ukázku si přehrajete ikonou reproduktoru.",
      "playSample": "Přehrát ukázku hlasu {voice}",
      "stopSample": "Zastavit ukázku hlasu {voice}",
      "presentation": {
        "feminine": "Ženský",
        "masculine": "Mužský"
      },
      "accent": {
        "australian": "australská angličtina",
        "british": "britská angličtina",
        "irish": "irská angličtina",
        "northAmerican": "americká angličtina",
        "brazilian": "brazilská portugalština",
        "filipino": "filipínská angličtina",
        "southernUs": "angličtina z jihu USA"
      },
      "language": "Jazyk",
      "languageHint": "Jazyk účtu používá jazyk nastavený ve Vašem účtu. Lze zadat i jiný kód jazyka.",
      "accountLanguage": "Jazyk účtu",
      "czech": "Čeština",
      "slovak": "Slovenština",
      "english": "Angličtina",
      "customLanguage": "Jiný jazyk",
      "languageCode": "Kód jazyka",
      "callback": "Zavolat mi zpět",
      "callbackHint": "Po hlasovém zadání Vám Chetty může zavolat, když potřebuje odpověď nebo když má hotový výsledek.",
      "dictationPause": "Ukončit diktování po pauze",
      "dictationPauseHint": "Když tak dlouho nemluvíte, diktování se samo ukončí a text zůstane v poli. Odeslat ho můžete kdykoli i během diktování.",
      "dictationPauseNever": "Nikdy",
      "unavailable": "Hlas není dostupný",
      "unavailableHint": "Správce musí nastavit podporovaného poskytovatele a modely. Jazyk a zpětné volání můžete měnit i nyní.",
      "loadError": "Hlasové předvolby se nepodařilo načíst."
    },
    "permission": {
      "title": "Přístup k hlasu",
      "allow": "Povolit hlas",
      "hint": "Umožňuje hovory, zpětné volání a hlasové zprávy. Oprávnění potřebují i správci."
    },
    operations: {
      "kind": "Operace",
      "reason": "Důvod",
      "status": {
        "submitted": "Předáno do konverzace",
        "started": "Zahájeno",
        "succeeded": "Dokončeno",
        "failed": "Selhalo",
        "cancelled": "Zrušeno"
      },
      "kinds": {
        "interpretation": "Zpracování zadání",
        "work": "Práce",
        "answers": "Odpovědi",
        "clarify": "Upřesnění",
        "end": "Ukončení hovoru",
        "callback": "Zpětné volání"
      },
      "reasons": {
        "policy_refusal": "Odmítnuto kvůli zásadám používání poskytovatele",
        "refusal": "Požadavek odmítnut",
        "quota": "Vyčerpaná kvóta",
        "rate_limit": "Dosažen limit požadavků",
        "unavailable": "Služba není dostupná",
        "timeout": "Vypršel časový limit",
        "tool_error": "Nástroj selhal",
        "invalid_response": "Neplatná odpověď",
        "cancelled": "Zrušeno",
        "unknown": "Neznámá chyba"
      }
    },
    "transcript": {
      "title": "Přepis hovoru",
      "call": "Hovor",
      "user": "Vy",
      "assistant": "Chetty",
      "empty": "Přepis není k dispozici"
    },
    actionsGroup: "Hlas",
    dictation: {
      "start": "Diktovat",
      "hint": "Psát hlasem do pole pro zprávu",
      "stop": "Hotovo",
      "cancel": "Zrušit diktování",
      "recording": "Nahrávám",
      "transcribing": "Přepisuji…",
      "errors": {
        ...sharedVoiceReasons,
        "mic_denied": "Přístup k mikrofonu byl zamítnut. Povolte jej a zkuste to znovu.",
        "dictation_active": "Na Vašem účtu již probíhá diktování. Před dalším spuštěním jej ukončete v jiné kartě.",
        "mic_failed": "Mikrofon se nepodařilo použít.",
        "network": "Diktování ztratilo spojení. Zkontrolujte připojení a zkuste to znovu.",
      }
    },
    call: {
      "start": "Hovor",
      "hint": "Zadat úkol hlasem a slyšet výsledek",
      "hangup": "Zavěsit",
      "close": "Zavřít",
      "states": {
        "connecting": "Připojování…",
        "listening": "Naslouchání",
        "speaking": "Chetty mluví",
        "on_hold": "Chetty pracuje",
        "ending": "Ukončování hovoru…"
      },
      "reasons": {
        ...sharedVoiceReasons,
        "unknown_session": "Konverzace již neexistuje.",
        "call_active": "Již probíhá jiný hlasový hovor.",
        "callback_unavailable": "Toto zpětné volání již není dostupné.",
        "question_not_pending": "Otázka již nečeká na odpověď.",
        "voice_unavailable": "Hlasová služba není dostupná.",
        "provider_unavailable": "Není dostupný vhodný poskytovatel ani podporovaný model se známou cenou.",
        "mic_denied": "Přístup k mikrofonu byl zamítnut. Povolte jej a zkuste to znovu.",
        "disconnected": "Spojení bylo přerušeno.",
        "daemon_restart": "Služba se restartovala.",
        "hangup": "Hovor skončil.",
        "completed": "Vaše zadání bylo odesláno.",
        "max_duration": "Byla dosažena maximální délka hovoru.",
        "silence": "Hovor skončil kvůli neaktivitě."
      }
    },
    ring: {
      "acceptUnavailable": "Hlasové hovory nyní nejsou dostupné.",
      "title": "Příchozí hovor",
      "doneTitle": "Chetty má výsledek",
      "accept": "Přijmout",
      "decline": "Odmítnout",
      "close": "Zavřít",
      "loading": "Ověřování hovoru…",
      "stale": "Tento hovor již není dostupný.",
      "error": "Hovor se nepodařilo ověřit. Zkuste to znovu.",
      "declineError": "Hovor se nepodařilo odmítnout. Zkuste to znovu.",
      "timeout": "Platnost hovoru vypršela.",
      "declined": "Hovor byl odmítnut.",
      "accepted": "Hovor byl přijat.",
      "unavailable": "Tento účet již nemůže přijmout tento hovor.",
      "settled": "Otázka již byla zodpovězena.",
      "restart": "Služba se restartovala."
    },
  },
  spendLimit: {
    section: "Limit a útrata",
    unlimited: "Bez omezení",
    limit: "Měsíční limit",
    spent: "Útrata",
    reset: "Obnovení limitu",
    resetUsage: "Vynulovat limit",
    limitHint: "Po dosažení této částky účet do obnovení limitu nespustí další práci.",
    resetHint: "Kdy se měsíční limit obnoví.",
    resetUsageHint: "Útrata se do limitu tohoto měsíce začne počítat znovu od nuly, statistiky a konverzace zůstanou zachované.",
    spentHint: "Kolik se za tento měsíc na účtu spotřebovalo.",
    resetTitle: "Vynulovat měsíční limit?",
    resetDescription: "Měsíční limit účtu {user} bude do konce tohoto měsíce počítat útratu znovu od nuly. Statistiky, útrata účtů poskytovatelů a konverzace zůstanou beze změny.",
    resetError: "Měsíční limit se nepodařilo vynulovat.",
    readError: "Útratu účtu se nepodařilo načíst.",
    monthlyLimit: "Měsíční limit útraty byl dosažen. Obnoví se {date}.",
    unpricedModel: "Model nemá známou cenu a účet s limitem útraty jej nemůže používat. Měsíční limit se obnoví {date}.",
    accountLimit: "Účet {account} je omezen svým měsíčním limitem útraty. Obnoví se {date}.",
  },
  updateStatus: {
    prepareCoreTitle: "Připravit společnou aktualizaci?",
    prepareCoreIntro: "Tento plugin potřebuje novější Chetty. Příprava zahrne aktualizaci systému a ověří pluginy cílovou verzí. Nová oprávnění budete schvalovat samostatně; dosavadní souhlasy se nemění.",
    prepareCore: "Připravit systém i pluginy",
    consentTitle: "Souhlas s připravenou aktualizací",
    consentIntro: "Pluginy vyžadující nová oprávnění zatím nebyly aktivovány. Ostatní kompatibilní aktualizace mohly mezitím proběhnout. Potvrzení schválí jen uvedené balíčky a rovnou obnoví jejich ověřenou aktualizaci.",
    reviewConsent: "Zobrazit oprávnění",
    approveConsent: "Schválit a pokračovat",
    declineConsent: "Odmítnout",
    consentError: "Rozhodnutí se nepodařilo uložit. Obnovte stav a zkontrolujte aktuální otázku.",
    consentChanged: "Balíček nebo souhlas se změnil. Obnovte stav. Pokud se změnil balíček, před schválením připravte aktualizaci znovu.",
    consentQueued: "Schválená aktualizace je ve frontě.",
    consentDeclined: "Aktualizace byla odmítnuta.",
    noNewGrants: "Bez nových oprávnění",
    notInstalled: "Nenainstalováno",
    "updatesHeld": "Vydavatel pozastavil nová vydání pro tuto licenci. Dříve dostupné verze lze nadále instalovat a opravovat.",
    "title": "Stav aktualizací",
    "error": "Stav aktualizací se nepodařilo načíst.",
    "queued": "Ve frontě",
    "downloading": "Stahování balíčku",
    "prepared": "Příprava",
    "quiescing": "Zastavování služeb",
    "applying": "Provádění změn",
    "verifying": "Ověřování spuštění",
    "committing": "Dokončování",
    "committed": "Dokončeno",
    "rollingBack": "Obnovování předchozí verze",
    "blocked": "Zablokováno před aktivací",
    "rolledBack": "Vráceno na předchozí verzi",
    "needsOperator": "Vyžaduje zásah správce",
    "applied": "Provedeno",
    "needsConsent": "Vyžaduje souhlas",
    "notLicensed": "Chybí licence",
    "superseded": "Zrušeno před spuštěním",
    "failed": "Nezdařilo se",
    "skipped": "Přeskočeno",
    "noUpdate": "Již aktuální",
    "repair": "Opravit",
    "repairError": "O opravu se nepodařilo požádat.",
    "degraded": "Nenačteno",
  },
  problemReporting: {
    delivery: { idle: "Připraveno", sent: "Doručeno", retry: "Opakování", credentials: "Neplatná licence", unavailable: "Server nedostupný", storage: "Chyba úložiště" },
    label: "Hlášení problémů",
    notice: "Odesílání varování a chyb démona provozovateli licenčního serveru Chettyho. Hlášení obsahují kódy problémů, počty, úroveň varování či chyby, skutečné názvy všech pluginů včetně soukromých a nelicencovaných, verze produktu a pluginů a u každého problému až tři ukázky textu chybové zprávy. Hlášení zpoždění démona navíc obsahují poslední vzorek prostředků hostitele: CPU, RAM, kapacitu disku, rychlost diskového I/O a sítě a čas měření. Před uložením a odesláním se text zkrátí na 500 znaků a odstraní se z něj klíče, tokeny, hesla, cookies, parametry URL, e-mailové adresy, IP adresy, identifikátory a cesty k adresářům. Zbylý text může obsahovat názvy poskytovatelů, modelů, částí pluginů, hostitelů nebo jména osob. Chybové zprávy jsou diagnostické, nejde o konverzace ani vzpomínky a každé hlášení odesílá redigovaný text zprávy, kterou popisuje, včetně zpráv, které mohou nést obsah zpráv nebo obchodní údaje zákazníků. Hlášení identifikují tuto licencovanou instanci a uchovávají se nejvýše 14 dní. Vypnutí smaže neodeslané dávky, ale nemůže odvolat již přijaté údaje.",
    confirmTitle: "Zapnout hlášení problémů?",
    confirm: "Potvrdit a zapnout",
    loadError: "Stav hlášení problémů se nepodařilo načíst.",
  },
  guides: {
    count: { one: '{n} návod', few: '{n} návody', many: '{n} návodů' },
    enlargeImage: 'Zvětšit obrázek: {alt}',
    aiPending: 'Připravuje se odpověď z návodů…',
    "description": "Praktické postupy pro práci s Chettym.",
    "search": "Hledat v návodech",
    "clear": "Vymazat hledání",
    "categories": "Kategorie",
    "recommended": "Doporučené návody",
    "empty": "Žádné návody nenalezeny",
    "emptyDescription": "Zkuste jinou otázku nebo si prohlédněte kategorie.",
    "unavailable": "Návody se nepodařilo načíst.",
    "notFound": "Tento návod nebo kategorie neexistuje.",
    "notTranslated": "Nepřeloženo · K dispozici v angličtině",
    "admin": "Pro správce",
    "advanced": "Pro pokročilé",
    "advancedDescription": "Terminálová aplikace, API, MCP, Projekty s terminálem a Gitem, sub-agenti a oprávnění.",
    "adminDescription": "Zprovoznění Chettyho, účty a přístupy, AI modely, pluginy, kanály a provoz.",
    "developer": "Pro vývojáře",
    "developerDescription": "Tvorba pluginů: manifest, rozhraní hostitele, HTTP cesty, data, propojení pluginů a vydávání.",
    "everyday": "Návody pro každý den",
    "moreGuides": "Další návody",
    "reviewed": "Ověřeno {date}",
    "outline": "Na této stránce",
    "copyLink": "Kopírovat odkaz",
    "previous": "Předchozí návod",
    "next": "Další návod",
    "related": "Související návody",
    "updates": "Související novinky",
    "updatesError": "Související novinky se nepodařilo načíst.",
    "all": "Všechny návody",
    "results": "Nalezené návody: {count}",
    "filter": "Kategorie: {category}",
    "aiUnavailable": "Odpovědi AI nejsou dostupné. V návodech můžete dál hledat.",
    "aiDenied": "Váš účet nemá přístup k modelu pro odpovědi.",
    "aiLimited": "Byl dosažen limit odpovědí. Zkuste to později.",
    "aiFailed": "Odpověď AI se nepodařilo načíst.",
    "aiEmpty": "Dokumentace neobsahuje odpověď na tuto otázku.",
    apiReference: {
      title: 'Endpointy, které můžete volat',
      search: 'Hledat endpointy',
      clear: 'Vymazat hledání',
      count: { one: '{n} endpoint', few: '{n} endpointy', many: '{n} endpointů' },
      results: 'Zobrazeno {shown} z {total} nalezených endpointů',
      unavailable: 'Katalog API se nepodařilo načíst.',
      searchError: 'Hledání endpointů se nepodařilo dokončit.',
      empty: 'Žádné dostupné endpointy',
      emptyDescription: 'Váš účet nemůže na této instanci volat žádný endpoint.',
      noResults: 'Žádné odpovídající endpointy',
      noResultsDescription: 'Zkuste jiná slova, nebo hledání vymažte a projděte všechny endpointy.',
      core: 'Jádro Chettyho',
      coreDescription: 'Konverzace, Projekty, účty, paměť, nastavení a zbytek základní aplikace.',
      anyMethod: 'Libovolná metoda',
      detailError: 'Podrobnosti tohoto endpointu se nepodařilo načíst.',
      detailGone: 'Tento endpoint už Váš účet nemůže volat.',
      params: 'Parametry cesty',
      query: 'Parametry dotazu',
      body: 'Tělo požadavku',
      noInput: 'Tento endpoint nepřijímá žádný vstup.',
      noFields: 'Žádná pole.',
      openSchema: 'Zde je přijat libovolný JSON; endpoint svá pole neuvádí.',
      required: 'Povinné',
      optional: 'Volitelné',
      truncated: 'Schéma je rozsáhlé, proto jsou zobrazena jen pole nejvyšší úrovně.',
      adminOnly: 'Jen pro správce',
      response: { binary: 'Odpověď se souborem', stream: 'Průběžná odpověď' },
      noApiToken: 'Není dostupné s osobním API tokenem',
      noAgent: 'Není dostupné pro agenta',
      coreAdminNote: 'Endpointy jádra si oprávnění správce kontrolují samy, takže tento může účet bez role správce stále odmítnout.',
      curlExample: 'curl s osobním API tokenem',
      elowenApiExample: 'Volání nástroje ElowenApi',
      copy: 'Kopírovat',
    },
},
  nav: {
    resizeNavigation: 'Změnit šířku navigace',
    guides: 'Návody',
    workingConversations: 'Probíhající konverzace',
    pinnedConversations: 'Připnuté konverzace',
    hideEntry: 'Skrýt',
    moveUp: 'Posunout nahoru',
    moveDown: 'Posunout dolů',
    showHidden: 'Zobrazit skryté',
    hiddenCount: 'Skryté ({count})',
    collapseShortcut: 'Ctrl / ⌘ + \\',
    sectionWork: 'Práce',
    sectionInstance: 'Instance',
    instanceMenu: 'Nabídka instance',
    home: 'Domů',
    chat: 'Chat',
    system: 'Systém',
    account: 'Účet',
    dashboard: 'Přehled',
    settings: 'Nastavení',
    projects: 'Projekty',
    users: 'Uživatelé',
    memory: 'Paměť',
  },
  page: {
    guides: 'Návody',
    dashboard: 'Přehled',
    chat: 'Chat',
    settings: 'Nastavení',
    projects: 'Projekty',
    users: 'Uživatelé',
    memory: 'Paměť',
  },
  stats: {
    cardTotalCost: 'Evidované náklady',
    cardTotalTokens: 'Celkem tokenů',
    cardCache: 'Tokeny v mezipaměti',
    cardModelsUsed: 'Použité modely',
    emptyTitle: 'Zatím žádná spotřeba',
    emptyDesc: 'Tokeny a náklady se zde zobrazí, jakmile poběží agenti.',
    modalTitle: 'Spotřeba',
    model: 'Model',
    sectionConversation: 'Tato konverzace',
    sectionModels: 'Všechny modely',
    contextLabel: 'Kontext',
    sessionTokens: 'Tokeny v této relaci',
    inputTokens: 'Vstupní tokeny',
    outputTokens: 'Výstupní tokeny',
    cacheHit: 'Podíl načtený z mezipaměti',
    speed: 'Efektivní rychlost',
    arrowHint: '← → · přepínání sekcí',
    sectionContext: 'Kontext',
    contextWindow: 'Kontextové okno',
    contextReported: 'Hlášeno poskytovatelem',
    contextBreakdown: 'Co ho zaplňuje',
    contextEstimateNote: 'Rozdělení je orientační. Poskytovatel počítá tokeny vlastním způsobem.',
    contextEmptyTitle: 'Není co měřit',
    contextEmptyDesc: 'Otevřete konverzaci a napište zprávu. Pak se zobrazí její aktuální kontext.',
    contextCategory: {
      system: 'Systémový prompt',
      tools: 'Schémata nástrojů',
      user: 'Vaše zprávy',
      assistant: 'Odpovědi',
      toolResults: 'Výstupy nástrojů',
      other: 'Ostatní',
    },
    contextCategoryFree: 'Volné místo',
    compactsAt: 'Zkrácení kontextu při',
    heaviestTools: 'Nástroje s největším výstupem',
    toolColumnsHint: 'Schéma · volání · výstup.',
  },
  reasoning: {
    modalTitle: 'Uvažování',
    effortLabel: 'Úsilí',
    thoughtRows: 'Řádky úvah',
    noLevelsTitle: 'Žádné úrovně',
    noLevelsDesc: 'Tento model úroveň uvažování nenabízí.',
  },
  helpModal: {
    filterPlaceholder: 'Filtrovat příkazy',
    shortcutFilterPlaceholder: 'Filtrovat zkratky',
    shortcutCapturePlaceholder: 'Stiskněte…',
    emptyTitle: 'Žádný odpovídající příkaz',
    emptyDesc: 'Zkuste jiné slovo, nebo filtr vymažte a zobrazte všechny příkazy.',
  },
  tasksModal: {
    statusPending: 'Čeká',
    statusInProgress: 'Probíhá',
    statusCompleted: 'Dokončeno',
    taskActions: 'Akce úkolu',
  },
  aiElements: {
    waterfall: {
      title: 'Průběh',
      milliseconds: '{value} ms',
      timing: '{status}, začátek v {start} ms, trvání {duration} ms',
      status: { running: 'probíhá', completed: 'dokončeno', failed: 'selhalo' },
    },
    progressLabel: 'Průběh dotazníku',
    progress: 'Otázka {current} z {total}',
    answerRequired: 'Vyberte nebo zadejte odpověď.',
    previous: 'Zpět',
    skip: 'Přeskočit',
    next: 'Další',
    submit: 'Odeslat',
  },
  common: {
    codeDigit: 'Číslice {index} z {count}',
    copyFailed: 'Kopírování selhalo',
    copiedToast: 'Zkopírováno.',
    actionFailed: 'Akci se nepodařilo dokončit.',
    daemonReconnecting: 'Probíhá restartování služeb, počkejte prosím.',
    saveUnconfirmed: 'Spojení bylo přerušeno. Před opakováním ověřte změnu.',
    savedToast: 'Změny byly uloženy.',
    daemon: 'Služba na pozadí',
    daemonUnreachable: 'Služba Chetty není dostupná',
    toggleSidebar: 'Přepnout menu',
    cancel: 'Zrušit',
    save: 'Uložit',
    delete: 'Smazat',
    retry: 'Zkusit znovu',
    close: 'Zavřít',
    back: 'Zpět',
    forward: 'Vpřed',
    scrollLeft: 'Posunout doleva',
    scrollRight: 'Posunout doprava',
    saving: 'Ukládání…',
    saved: 'Uloženo',
    activationPending: 'Uloženo, čeká se na aktivaci',
    saveFailed: 'Nepodařilo se uložit',
    saveConflict: 'Nastavení se mezitím změnilo',
    reloadChanges: 'Načíst aktuální nastavení',
    keepMyChanges: 'Ponechat vlastní změny',
    done: 'Hotovo',
    searchCommands: 'Hledat příkazy…',
    searchSite: 'Hledat…',
    searchNoResults: 'Nic nenalezeno',
    searchSuggestions: 'Návrhy',
    searchAskAi: 'Zeptat se umělé inteligence na „{query}“',
    searchAskInChat: 'Zeptat se v chatu',
    searchAiAnswer: 'Odpověď AI',
    imageViewerTitle: 'Náhled obrázku',
    imageGone: 'Obrázek v plné velikosti se nepodařilo načíst',
    documentPreviewFailed: 'Náhled se nepodařilo načíst',
    dismiss: 'Zavřít',
    notification: 'Oznámení',
    loading: 'Načítání…',
    help: 'Nápověda',
    actions: 'Akce',
    error: 'Chyba',
    requiredField: 'Povinné',
    primaryNav: 'Hlavní',
    collapseNav: 'Sbalit navigaci na ikony',
    expandNav: 'Rozbalit navigaci',
    openCommandPalette: 'Otevřít paletu příkazů',
    skin: 'Vzhled',
    skinCycle: 'Kliknutím změnit',
    skinNames: {
      studioLight: 'Světlý',
      studioOled: 'Tmavý',
      umberNight: 'Umbrová noc',
      studioGraphite: 'Grafit',
    },
    logout: 'Odhlásit se',
    language: 'Jazyk',
    rangeLabel: 'Období',
    rangeLastHour: 'Poslední hodina',
    rangeLast6Hours: 'Posledních 6 hodin',
    rangeLast24Hours: 'Posledních 24 hodin',
    rangeIncomplete: 'Vyplňte začátek i konec období.',
    rangeInvalidInstant: 'Zadejte platné datum a čas. Tento místní čas nemusí existovat při změně času.',
    rangeInvalidOrder: 'Začátek období musí předcházet konci.',
    rangeOutsideBounds: 'Období je mimo povolené časové meze.',
    rangeToday: 'Dnes',
    rangeLast7: 'Posledních 7 dní',
    rangeLast30: 'Posledních 30 dní',
    rangeLast90: 'Posledních 90 dní',
    rangeAll: 'Vše',
    rangeCustom: 'Vlastní',
    rangeFrom: 'Od',
    rangeTo: 'Do',
    filterAllProjects: 'Všechny projekty',
    filterProjectsAria: 'Filtr projektů',
    filters: 'Filtry',
    filtersWithCount: 'Filtry, aktivních: {count}',
    filterOptions: 'Možnosti',
    filterOptionsWithCount: 'Možnosti, aktivních filtrů: {count}',
    filtersActive: 'Aktivní filtry',
    filtersClear: 'Zrušit filtry',
    filterRemove: 'Odebrat filtr {name}',
  },
  pagination: {
    label: 'Stránkování',
    previous: 'Předchozí',
    next: 'Další',
    previousPage: 'Předchozí strana',
    nextPage: 'Další strana',
    range: '{from}–{to} z {total}',
    pageLabel: 'Strana {page} z {pages}',
    perPage: 'Na stránku',
  },
  operationDock: {
    history: 'Otevřít historii',
    "region": "Operace na pozadí",
    "more": "+{count}",
    "started": "{action}: zahájeno",
    "done": "{action}: hotovo",
    "failed": "{action}: selhalo",
    "dismiss": "Odebrat",
    "ackFailed": "Operaci se nepodařilo odebrat. Zkuste to znovu.",
    "updateCore": "Aktualizace Chetty",
    "updatePlugin": "Aktualizace {name}",
    "installPlugin": "Instalace {name}",
    "repairPlugin": "Oprava {name}",
    "captioned": "{action}: {caption}"
  },
  terminalSurface: {
    pasteFailed: 'Prohlížeč nemohl přečíst schránku. Použijte prosím příkaz Vložit v prohlížeči.',
    errors: {
      TERMINAL_REFUSED: 'Požadavek na terminál byl odmítnut. Ověřte přístup k tomuto projektu.',
      TERMINAL_UNSUPPORTED: 'Tento cíl nepodporuje interaktivní terminál.',
      TERMINAL_LIMIT: 'Byl dosažen maximální počet terminálů.',
      TERMINAL_UNKNOWN_SESSION: 'Tato relace terminálu již neexistuje.',
      TERMINAL_RUNNING: 'Terminál stále běží. Před odebráním jej zavřete.',
      TERMINAL_UNAVAILABLE: 'Terminál je momentálně nedostupný.',
      TERMINAL_FAILED: 'Terminál selhal. Otevřete novou relaci.',
    },
    region: 'Terminál',
    ended: 'Relace skončila.',
    endedWithCode: 'Relace skončila (návratový kód {code}).',
    openedElsewhere: 'Terminál je otevřený v jiné kartě.',
    takeOver: 'Převzít',
    refused: 'Terminál se nepodařilo otevřít.',
  },
  richTextEditor: {
    toolbar: 'Formátování',
    bold: 'Tučné',
    italic: 'Kurzíva',
    link: 'Odkaz',
    bulletList: 'Odrážkový seznam',
    orderedList: 'Číslovaný seznam',
    linkAddress: 'Adresa odkazu',
    linkInvalid: 'Zadejte webovou nebo e-mailovou adresu.',
    applyLink: 'Použít',
    removeLink: 'Odebrat odkaz',
  },
  operationProgress: {
    errors: {
      admin_required: 'Tato akce vyžaduje oprávnění administrátora instance.',
      invalid_network: 'Zadejte platný síťový režim a porty od 1 do 65535.',
      network_port_conflict: 'Port hostitele je již obsazený. Zvolte jiný port nebo jej před spuštěním prostředí uvolněte.',
      network_port_check_failed: 'Dostupnost portů hostitele se nepodařilo ověřit. Prostředí nebylo spuštěno.',
    },
    progressLabel: 'Průběh operace',
    stepOf: 'Krok {current} z {total}',
    indeterminate: 'Probíhá',
    preparing: 'Příprava…',
    succeeded: 'Hotovo',
    failed: 'Operace selhala',
    minimize: 'Minimalizovat',
    retry: 'Zkusit znovu',
    showLog: 'Zobrazit protokol',
    hideLog: 'Skrýt protokol',
    logLabel: 'Protokol prostředí',
    reopen: 'Zobrazit průběh',
    steps: {
      image: 'Příprava základního obrazu',
      storage: 'Příprava úložiště',
      container: 'Vytváření kontejneru',
      boot: 'Spouštění kontejneru',
      ready: 'Čekání na spuštění systému',
      initialize: 'Inicializace projektu',
      quiesce: 'Dokončování probíhající práce',
      stop: 'Zastavování kontejneru',
      remove: 'Odebírání starého kontejneru',
      capture: 'Pořizování snímku',
      record: 'Zaznamenávání snímku',
      import: 'Obnovuji data',
      switch: 'Přepínám na novou verzi',
      cleanup: 'Uklízím',
      apply: 'Aplikuji limity',
      containers: 'Odstraňuji kontejnery',
      records: 'Odstraňuji záznamy',
      discard: 'Odstraňuji data snímku',
    },
    actions: {
      start: 'Spouštění prostředí',
      stop: 'Zastavování prostředí',
      restart: 'Restartování prostředí',
      recreate: 'Opětovné vytváření prostředí',
      delete: 'Mazání projektu',
      snapshot: 'Vytváření snímku',
      restore: 'Obnovování ze snímku',
      deleteSnapshot: 'Mazání snímku',
      limits: 'Nastavování limitů zdrojů',
      network: 'Nastavování sítě',
      rename: 'Přesun adresáře projektu',
    },
  },
  auth: {
    loginFailed: 'Přihlášení se nepodařilo. Zkontrolujte přihlašovací údaje.',
    loginRateLimited: 'Příliš mnoho pokusů o přihlášení. Zkuste to prosím později.',
    signIn: 'Přihlásit se',
    signInDescription: 'Přihlaste se ke svému účtu Chetty.',
    orContinueWith: 'Nebo pokračujte přes',
    microsoft: 'Microsoft',
    usernamePlaceholder: 'Uživatelské jméno',
    passwordPlaceholder: 'Heslo',
    ssoErrors: {
      no_account: 'Účet Chetty pro tento účet Microsoft zatím neexistuje. Požádejte administrátora o jeho vytvoření.',
      denied: 'Přihlášení přes Microsoft bylo zamítnuto. Obraťte se na administrátora.',
      already_linked: 'Tento účet Microsoft je už propojený s jiným účtem Chettym.',
      directory_unavailable: 'Nepodařilo se ověřit vaše oprávnění v adresáři Microsoftu. Zkuste to prosím znovu později.',
      tenant_mismatch: 'Tento účet Microsoft nepatří do organizace nastavené pro tuto instanci.',
      state_expired: 'Přihlášení vypršelo. Zkuste to prosím znovu.',
      not_setup: 'Nastavení ještě není dokončené. Přihlaste se uživatelským jménem a heslem.',
      sso_failed: 'Přihlášení přes Microsoft se nezdařilo.',
    },
    setupPendingTitle: 'Nastavení není dokončené',
    setupPendingBody: 'Na tomto serveru zatím není žádný účet. Dokončete instalaci v terminálu a potom stránku znovu načtěte.',
    setupPendingHint: "Příkaz spusťte na stroji, kde je nainstalovaný produkt Chetty.",
  },
  licence: {
    starterTitle: 'Startovní pluginy',
    starterDescription: 'Nainstalujte pluginy ze startovní sady pro všechny uživatele.',
    starterAction: 'Zobrazit startovní pluginy',
    starterInstall: 'Nainstalovat pluginy',
    starterLater: 'Teď ne',
    starterInstalling: 'Instaluje se…',
    starterGrants: 'Balíčky se nejprve ověří. Případná nová oprávnění schválíte v připravené aktualizaci.',
    pageTitle: 'Vyžadována licence',
    reasonMissing: 'Na tomto serveru není nainstalována žádná licence.',
    reasonExpired: 'Licence na tomto serveru vypršela.',
    reasonOffline: 'Licenční server je příliš dlouho nedostupný.',
    reasonRefused: 'Licenční server tuto instalaci odmítl.',
    reasonWrongInstance: 'Tato licence byla vydána pro jiný server.',
    reasonInvalid: 'Licence na tomto serveru není platná.',
    instanceId: 'ID instance',
    instanceIdHint: 'Identifikuje tento server, licence je vázaná právě na něj.',
    copyInstanceId: 'Zkopírovat ID instance',
    licenceId: 'ID licence',
    licenceIdHint: 'Uveďte jej při komunikaci s podporou.',
    copyLicenceId: 'Zkopírovat ID licence',
    serverTime: 'Čas serveru',
    localTime: 'Místní čas',
    support: 'Potřebujete pomoc? Napište na {url}.',
    keyLabel: 'Aktivační klíč',
    keyPlaceholder: 'Zadejte aktivační klíč',
    activate: 'Aktivovat',
    activating: 'Aktivuje se…',
    errorBadKey: 'Tento klíč nevypadá správně. Zkontrolujte jej a zkuste to znovu.',
    errorForbidden: 'Licenční server tento klíč odmítl.',
    errorConflict: 'Tento klíč je již aktivní na jiném serveru.',
    errorServer: 'Licenční server je momentálně nedostupný. Zkuste to později.',
    restarting: 'Restartuje se…',
    cardTitle: 'Licence',
    state: 'Stav',
    stateLocked: 'Uzamčeno',
    statusHint: 'Server si platnost licence ověřuje u licenčního serveru automaticky.',
    customer: 'Zákazník',
    expires: 'Platnost do',
    expiresHint: 'Po tomto datu se služba zastaví, dokud licenci neprodloužíte.',
    pluginCount: 'Pluginy',
    lastContact: 'Poslední kontakt se serverem',
    lastContactHint: 'Kdy tento server naposledy ověřil licenci u licenčního serveru.',
    neverContacted: 'Nikdy',
    staleWarning: 'Licenční server je delší dobu nedostupný. Instalace poběží do {date}.',
    checkNow: 'Zkontrolovat teď',
    checking: 'Kontroluje se…',
    replaceKey: 'Nahradit aktivační klíč',
    replaceTitle: 'Nahradit aktivační klíč',
    replaceDesc: 'Zadejte nový klíč. Po aktivaci se služba restartuje.',
  },
  advisor: {
    dockTop: 'Ukotvit nahoru',
    dockBottom: 'Ukotvit dolů',
    dockPosition: 'Pozice panelu',
    title: 'Asistent',
    close: 'Zavřít',
    dockLeft: 'Ukotvit vlevo',
    dockRight: 'Ukotvit vpravo',
    chatsCount: 'Chaty: {count}',
  },
  conversationList: {
    archived: 'Archivováno',
    relatedItems: 'Související položky',
    relatedItemsToggle: 'Související položky konverzace {title}',
    relatedItemsError: 'Související položky se nepodařilo načíst',
    usage: 'Spotřeba',
    mine: 'Moje',
    new: 'Nová',
    groups: {
      unread: 'Nové odpovědi',
      pinned: 'Připnuté',
      today: 'Dnes',
      yesterday: 'Včera',
      thisWeek: 'Tento týden',
      older: 'Starší',
      results: 'Výsledky',
    },
    filters: {
      project: 'Projekt',
      status: 'Stav',
      model: 'Model',
      type: 'Typ',
      owner: 'Vlastník',
      noProject: 'Bez projektu',
      unavailableProject: 'Nedostupný projekt',
      unreadScope: 'Nepřečtené se vztahuje pouze na Vaše vlastní konverzace.',
      clearOne: 'Zrušit filtr {filter}',
      scope: 'Rozsah',
      selectedValues: '{filter}: vybráno {count}',
      working: 'Pracuje',
      waiting: 'Čeká na odpověď',
      unread: 'Nepřečtené',
      error: 'Chyba',
      webCli: 'Web / CLI',
      scheduled: 'Naplánovaná aktivita',
    },
    sort: {
      label: 'Řazení',
      direction: 'Směr',
      newest: 'Nejnovější',
      tokens: 'Tokeny',
      name: 'Název',
      state: 'Stav',
      model: 'Model',
      owner: 'Vlastník',
      ascending: 'Vzestupně',
      descending: 'Sestupně',
    },
    selectMode: 'Vybrat',
    selectPage: 'Vybrat konverzace na této stránce',
    contextAncestor: 'Zobrazeno pro kontext',
    hostedBy: 'Hostující účet: {name}',
    lastWriter: 'Poslední autor: {name}',
    waitingForResponse: 'Čeká na odpověď',
    runningAgents: 'Agenti: {count}',
    runningAgentsAtLeast: 'Agenti: {count}+',
    newReply: 'Nová odpověď',
    exportSelected: 'Exportovat vybrané',
    exportSeparateFiles: 'Každá konverzace se stáhne jako samostatný soubor. Prohlížeč může požádat o povolení více stahování.',
    exportPartial: 'Zahájená stahování: {started}. Neúspěšné požadavky: {failed}.',
    projectLoadError: 'Projekty se nepodařilo načíst',
    listLoadError: 'Konverzace se nepodařilo načíst',
    personalLoadError: 'Údaje Vašich konverzací se nepodařilo načíst',
    searchLoading: 'Prohledává se historie konverzací',
    searchBounded: 'Vyhledávání v přepisech vrací omezený počet nejnovějších shod.',
    resultCount: 'Odpovídající konverzace: {count}',
    deleteAllScope: 'Trvale se smažou všechny spravované konverzace všech účtů, včetně kanálů a delegovaných konverzací, bez ohledu na aktuální hledání či filtry. Tuto akci nelze vrátit.',
  },
  sessionsPanel: {
    searchLabel: 'Hledat',
    noMatches: 'Filtru neodpovídá žádná konverzace',
    untitled: 'Bez názvu',
    tok: 'tok',
    openInChat: 'Otevřít v chatu',
    viewInChat: 'Zobrazit historii chatu',
    deleteAll: 'Smazat vše',
    confirmDeleteAllTitle: 'Smazat všechny relace?',
    subAgents: 'Sub-agenti',
  },
  subagentBranch: {
    unavailable: 'Přepis již není k dispozici',
    truncated: 'Více řádků, než lze zobrazit',
    error: 'Sub-agenty se nepodařilo načíst',
  },
  dashboard: {
    greetingMorning: 'Dobré ráno',
    greetingAfternoon: 'Dobré odpoledne',
    greetingEvening: 'Dobrý večer',
    heroAsk: 'S čím vám mohu pomoci?',
    stripLabel: 'Dnešní přehled',
    quickActions: 'Rychlé akce',
    pillSummary: 'Shrnout dnešní dění',
    pillSummaryPrompt: 'Shrňte prosím, co se dnes v týmu dělo.',
    pillPlan: 'Naplánovat úkol',
    pillPlanPrompt: 'Naplánujte prosím tento úkol: ',
    pillCosts: 'Zkontrolovat náklady',
    pillAgent: 'Spustit agenta',
    pillAgentPrompt: 'Spusťte prosím agenta na tento úkol: ',
    pillFind: 'Najít v projektu',
    pillFindPrompt: 'Najděte prosím v projektu: ',
    pillCapabilities: 'Co všechno umíte?',
    pillCapabilitiesPrompt: 'Co všechno umíte?',
    showFeed: 'Zobrazit dění',
    showPulse: 'Zobrazit Puls týmu',
    showMetrics: 'Zobrazit metriky',
    closePanel: 'Zavřít',
    metricsTitle: 'Metriky',
    metricsMonthCost: 'Vaše náklady tento měsíc',
    metricsTodayCost: 'Vaše náklady dnes',
    metricsMonthTokens: 'Tokeny za 30 dní',
    composerPlaceholder: 'Co pro vás mohu udělat?',
    composerAction: 'Odeslat do nového chatu s asistentem Chetty',
    recap: {
      label: 'Včerejší práce a návrhy',
      fallback: 'Včera se pracovalo na: {sessions}.',
      continueTitle: 'Pokračovat: {title}',
      rotation: 'Varianty rekapitulace',
      prev: 'Předchozí rekapitulace',
      next: 'Další rekapitulace',
      pause: 'Pozastavit střídání rekapitulací',
      resume: 'Pokračovat ve střídání rekapitulací',
    },
    last30d: 'Posledních 30 dní',
    presence: {
      offline: 'Offline',
    },
    live: 'živě',
    eventStream: 'Dění',
    eventStreamEmpty: 'Zatím žádné události.',
    workingNow: 'Právě pracují',
    pulse: 'Puls týmu',
    pulseNobody: 'Zatím tu nikdo nebyl',
    pulseSeen: 'naposledy aktivní',
    pulseUnpriced: 'bez ceny',
    pulseSpendOff: 'spotřeba nedostupná',
    pulseTodayLabel: 'dnes',
    pulseActivePeople: 'Aktivní uživatelé',
    pulseRunningAgents: 'Běžící agenti',
    pulseMemoryHits: 'Připomenuté vzpomínky',
    pulseCacheHit: 'Průměrný podíl načtený z mezipaměti',
    pulseVsYesterday: 'oproti včerejšku',
    pulseNoBaseline: 'včera bez aktivity',
    pulseFlat: 'beze změny oproti včerejšku',
    pulseAgentsBusy: 'Sub-agenti pracují',
    pulseAgentsIdle: 'Žádná delegovaná práce',
    pulseMemoryFoot: 'dnešní připomenutí z paměti',
    pulseCacheFoot: 'podíl kontextu načtený z mezipaměti',
    pulseColChannel: 'Kanál',
    pulseColDoing: 'Co dělá',
    pulseColCost: 'Náklady',
    pulseTeamCost: 'Náklady týmu',
    pulseColTokens: 'Tokeny',
    pulseColHits: 'Paměti',
    pulseColTurns: 'Tahy',
    pulseRingPeople: 'Lidé',
    pulseRingChannels: 'Kanály',
    pulseRingContext: 'Kontext',
    pulseRingCost: 'Náklady',
    pulseRingChannelsUnit: 'kanálů',
    pulseRingContextUnit: 'načtených tokenů',
    pulseRingCostUnit: 'za 30 dní',
    pulseRingEmpty: 'Zatím žádná data',
    pulseContext: {
      cacheRead: 'Načteno z mezipaměti',
      input: 'Nový vstup',
      cacheWrite: 'Uložení do mezipaměti',
      output: 'Výstup',
    },
    pulseContextHint: {
      cacheRead: 'Část kontextu se načetla z mezipaměti, takže stála méně než nový vstup.',
      input: 'Kontext odeslaný poprvé, za plnou cenu vstupu.',
      cacheWrite: 'Cena za uložení kontextu do mezipaměti pro další odpovědi.',
      output: 'Odpověď modelu. Tokeny, které stojí nejvíc, a je jich nejméně.',
    },
    pulseColCache: 'Mezipaměť',
    surfaces: { api: 'API token', subagent: 'Sub-agent', web: 'web', cli: 'terminál', cron: 'plán', internal: 'Interní', unknown: 'neznámý klient' },
    surfaceHint: { internal: 'Tahy bez konkrétního požadavku: plánované úlohy, obnova po restartu a interní práce démona. Tahy sub-agentů se sem už neřadí, jejich náklady se účtují tomu, kdo je zadal.' },
    ev: {
      turn: 'pracuje',
      someone: 'Někdo',
      message: 'Zpráva',
      decision: 'Rozhodnutí',
      signedIn: 'Přihlášení',
      accountLinked: 'Účet propojen',
      accountProvisioned: 'Účet vytvořen',
      signInDenied: 'Přihlášení odmítnuto',
      activity: 'Aktivita',
    },
    finishSetup: {
      cta: 'Připojit poskytovatele',
    },
  },
  settings: {
    updateRequestError: 'Aktualizaci se nepodařilo spustit.',
    updateStarted: 'Aktualizace se spustila. Chetty se během ní na chvíli restartuje a celé to může trvat několik minut. Průběh uvidíte vpravo dole.',
    restartRequested: 'Požadavek na restart byl přijat.',
    restartRequestError: 'Restart se nepodařilo vyžádat.',
    brainModelsLink: 'Dostupné modely najdete v sekci Modely →',
    models: 'Modely',
    plugins: 'Pluginy',
    availablePlugins: 'Dostupné pluginy',
    brain: 'Chetty AI',
    data: 'Údaje',
    navigationLabel: 'Kategorie nastavení',
    navigationSearch: 'Hledat v nastavení',
    navigationNoMatches: 'Tomuto hledání neodpovídá žádné nastavení.',
    modelsSectionHint: 'Určete, který model bude plnit jednotlivé úlohy této instance a které modely budou dostupné.',
    brainSectionHint: 'Nastavte asistenta, připojené účty, poskytovatele a limity běhu.',
    // Settings → Models → Model roles: every instance-level answer to "which model does what", in one
    // group above the catalog that says which models exist at all.
    modelCatalog: 'Katalog modelů',
    modelCatalogRefresh: 'Obnovit katalog',
    modelCatalogRefreshing: 'Obnovuji katalog…',
    modelCatalogRefreshError: 'Obnovení katalogu se nepodařilo alespoň u jednoho poskytovatele: {error}',
    modelCatalogRequestError: 'Katalog modelů se nepodařilo obnovit.',
    modelCatalogHint: 'Které modely nastavení poskytovatelé nabízejí a s jakými limity kontextu a výstupu.',
    modelRoles: {
      title: 'Role modelů',
      hint: 'Který model plní kterou úlohu této instance.',
      instanceDefault: 'Výchozí model konverzace',
      instanceDefaultHelp: 'Vyberte model pro konverzace uživatelů, kteří nemají vlastní volbu. Osobní nastavení a oprávnění uživatelů zůstávají zachována.',
      defaultSaveError: 'Výchozí model konverzace se nepodařilo uložit.',
      defaultUnavailable: 'Nedostupné: {model}',
      providersLink: 'Poskytovatelé',
      utility: 'Pomocný model',
      utilityHelp: 'Píše názvy konverzací, zpracovává dlouhodobé vzpomínky asistenta Chetty a třídí je do kategorií.',
      utilityOff: 'Žádný model: tyto úlohy jsou vypnuté',
      digest: 'Model denního přehledu',
      digestHelp: 'Model vytváří denní shrnutí na nástěnce. Ponechte možnost dědění, pokud chcete použít pomocný model.',
      digestSaveError: 'Model denního přehledu se nepodařilo uložit.',
      promptSuggestion: 'Model návrhů další zprávy',
      promptSuggestionSameModel: 'Stejný model s cache',
      promptSuggestionHelp: 'Stejný model s cache poskytuje nejpřesnější návrhy, ale stojí jeden krok agenta navíc. Levnější model vidí pouze posledních 10 zpráv. Pro použití pomocného modelu zvolte dědění.',
      promptSuggestionSaveError: 'Model návrhů se nepodařilo uložit.',
      recapLink: 'Nastavení rekapitulace',
      inherit: 'Převzít nastavení: {model}',
      inheritUnset: 'Převzít nastavení, pomocný model není nastaven',
      inherited: 'Zděděno',
      embeddingConstraint: 'Vyhledávání podle významu vyžaduje poskytovatele s klíčem API. Účty Claude a ChatGPT tuto možnost nenabízejí.',
      personal: 'Vaše osobní modely',
      personalHelp: 'Modely pro chat, obrázky a zkrácení kontextu svého účtu nastavíte v sekci Účet → Modely.',
      openAccount: 'Otevřít účet',
    },
    dashboard: 'Rekapitulace',
    dashboardSectionHint: 'Nastavte denní přehled, pozdrav a rychlé akce asistenta.',
    dashboardSection: {
      title: 'Rekapitulace',
      recap: 'Personalizovaný přehled',
      recapDesc: 'Pod polem zprávy zobrazit každému uživateli jeho poslední konverzace a včerejší události.',
      digest: 'AI přehled',
      digestDesc: 'Model napíše krátké shrnutí včerejška a dosavadního dneška a navrhne další kroky.',
      greeting: 'Pozdrav psaný asistentem',
      greetingDesc: 'Asistent napíše nadpis nástěnky i otázku pod ním v jazyce uživatele.',
      pills: 'Rychlé akce asistenta',
      pillsDesc: 'Asistent navrhuje rychlé akce podle skutečné aktivity každého uživatele.',
      continue: 'Pokračování konverzací',
      continueDesc: 'Nabídnout každému uživateli jeho poslední konverzace k opětovnému otevření.',
      perDay: 'Kolikrát denně',
      perDayDesc: 'Nejvyšší počet přehledů, které může jeden uživatel za den vytvořit. Den se rozdělí na stejně dlouhá období a přehled se obnoví při první návštěvě v každém novém období.',
      perDayOption: '{n}\u00d7 denně',
      variants: 'Počet variant při jednom vytvoření',
      variantsDesc: 'Kolik různých shrnutí včerejška a dneška vznikne při jednom vytvoření přehledu. Nástěnka je střídá. Při hodnotě 1 se zobrazí stále stejné shrnutí.',
      variantsOption: '{n} na dávku',
      countsNote: 'Změna se projeví při dalším vytvoření přehledu. Přehled se obnoví i během dne, jakmile přibude nová aktivita, nejvýše však tolikrát, kolik dovolí nastavený denní limit.',
      providerInherit: 'Stejný jako pomocný model',
      model: 'Model přehledu',
      modelDesc: 'Model pro denní přehled. Jeho roli nastavíte v sekci Nastavení → Modely vedle rolí, ze kterých přebírá nastavení.',
      modelLink: 'Role modelů',
      regenerate: 'Vygenerovat znovu',
      regenerateError: 'Regeneraci se nepodařilo spustit.',
      statusReady: 'Dnešní přehled je připraven',
      statusGenerating: 'Generuje se\u2026',
      statusUnavailable: 'Přehled zatím není k dispozici',
    },
    pluginsSectionHint: 'Nastavujte a sledujte rozšíření, která přidávají nástroje a platformy.',
    availablePluginsSectionHint: 'Procházejte registr pluginů a instalujte rozšíření.',
    access: 'Přístupy',
    accessSectionHint: 'Klíče, tokeny a hesla, se kterými se pluginy připojují ke svým službám.',
    dataSectionHint: 'Prohlížejte soubory protokolů a potvrzujte nevratné mazání provozních dat.',
    systemSectionHint: 'Sledujte verzi, služby, aktualizace a zabezpečení relací.',
    logs: 'Protokoly',
    logsOpen: 'Otevřít protokoly',
    logsEmpty: 'Zatím tu nejsou žádné soubory protokolů.',
    logsPickFile: 'Vyberte soubor protokolu, který chcete zobrazit.',
    logsSearch: 'Filtrovat řádky…',
    logsMatches: '{n} z {total} řádků',
    logsTruncated: 'Zobrazeno posledních {n} z {total} řádků.',
    logsTruncatedCapped: 'Zobrazeno posledních {n} z {total} řádků — maximum prohlížeče logů.',
    logsLoadFull: 'Načíst celý soubor',
    logsError: 'Tento soubor protokolu se nepodařilo načíst.',
    logsErrorGone: 'Tento soubor protokolu už neexistuje.',
    logsErrorTooBig: 'Tento soubor je příliš velký na otevření v prohlížeči záznamů.',
    logsDeleteFile: 'Smazat tento soubor záznamů',
    logsDeleteAll: 'Smazat vše',
    logsDeleteFileTitle: 'Smazat tento soubor záznamů?',
    logsDeleteFileDesc: 'Nenávratně smaže {name}. Pokud jde o dnešní soubor, znovu se vytvoří při dalším zápisu.',
    logsDeleteAllTitle: 'Smazat všechny soubory záznamů?',
    logsDeleteAllDesc: 'Nenávratně smaže všechny soubory záznamů. Dnešní soubory se znovu vytvoří při dalším zápisu.',
    logsLevels: 'Úrovně záznamu',
    logsLevelsAll: 'Všechny úrovně',
    logsLevelsCount: '{n} ze {total} úrovní',
    conversationDiagnostics: {
      exactAggregate: 'Přesný součet od poskytovatele', tokenSegments: 'Části tokenů promptu',
      segmentTokens: '{role}: přibližně {n} tokenů', promptTokens: '~{n} tokenů promptu',
      title: 'Diagnostika konverzací',
      description: 'Prohlížejte si přesné požadavky modelu zaznamenané touto instancí.',
      open: 'Otevřít diagnostiku',
      captureDisabled: 'Podrobné zaznamenávání požadavků je vypnuté.',
      enableCapture: 'Zapnout zachytávání',
      captureConfirmTitle: 'Zapnout přesné zaznamenávání požadavků?',
      captureConfirmDescription: 'Pro diagnostiku se budou ukládat přesné prompty poskytovatele, obsah zpráv, definice nástrojů, data předávaná nástrojům a odpovědi modelu. Zaznamenaná data mohou obsahovat soukromé nebo citlivé informace.',
      captureEnableError: 'Přesné zaznamenávání požadavků se nepodařilo zapnout.',
      sessions: 'Relace', tools: 'Nástroje', content: 'Obsah', mobileView: 'Zobrazení diagnostiky', requests: 'Požadavky', messages: 'Zprávy', contentView: 'Obsah požadavku', displayMode: 'Režim zobrazení',
      searchSessions: 'Hledat relace…', searchMessages: 'Hledat v promptu a zprávách…', searchTools: 'Hledat nástroje…',
      filters: 'Filtry', userId: 'ID uživatele', userIdInvalid: 'Zadejte kladné celé číslo.', surface: 'Povrch', provider: 'Poskytovatel', model: 'Model', status: 'Stav', role: 'Role',
      all: 'Vše', allRoles: 'Všechny role', conversation: 'Konverzace', channel: 'Kanál', subagent: 'Sub-agent',
      pending: 'Čeká', succeeded: 'Úspěšné', captured: 'Zachyceno', legacy: 'Starší data', error: 'Chyba', interrupted: 'Přerušeno', retry: 'Opakování',
      loadMore: 'Načíst další', loadError: 'Diagnostiku konverzací se nepodařilo načíst.', noSessions: 'Žádná odpovídající relace.', noRequests: 'V této relaci nejsou zaznamenané žádné požadavky.',
      legacyWarning: 'Záznam vznikl před zapnutím přesného zaznamenávání. Přepis je pouze orientační.',
      toolCall: 'Volání nástroje', toolResult: 'Výsledek nástroje', mediaContent: 'Binární nebo mediální obsah',
      noLegacyData: 'Starší přepis není k dispozici.',
      prompt: 'Prompt', cacheRead: 'Čtení z mezipaměti', cacheWrite: 'Zápis do mezipaměti', input: 'Vstup', output: 'Výstup', reasoning: 'Uvažování', cost: 'Cena', duration: 'Doba',
      cachedPrefixEstimate: 'Odhad délky prefixu v mezipaměti', notAvailable: 'Není k dispozici',
      inspector: 'Detail', pickMessage: 'Vyberte položku promptu nebo zprávu.', pretty: 'Přehled', json: 'JSON', copy: 'Kopírovat', rawRequest: 'Surový požadavek poskytovatele', payloadTooLarge: 'Data jsou příliš velká pro zobrazení v diagnostice.',
      unnamedItem: 'Položka', unnamedTool: 'nástroj',
      noTools: 'V tomto požadavku nebyly odeslány žádné nástroje.', immediate: 'Okamžitý', deferred: 'Odložený', server: 'Server',
    },
    metric: {
      catalog: 'V katalogu',
      overrides: 'Přepsání kontextu',
      accounts: 'Účty poskytovatelů',
      connected: 'Připojené',
      aiModels: 'Modely AI',
      pluginWorlds: 'Pluginy s rozhraním',
      pluginPages: 'Stránky pluginů',
      pluginSections: 'Nastavení pluginů',
      logFiles: 'Soubory záznamů',
      logVolume: 'Objem záznamů',
      requestCapture: 'Záznam požadavků',
      conversationCleanup: 'Úklid konverzací',
    },
    adminOnly: 'Jen pro administrátory',
    adminOnlyDesc: 'Tato sekce je vyhrazena administrátorům. Svůj účet upravíte v sekci Můj účet.',
    tokenTtl: 'Platnost přihlašovacího tokenu',
    daysPolicy: {
      presets: 'Předvolby: {policy}',
      preset: '{n} dní',
      custom: 'Vlastní…',
      customFor: 'Vlastní doba pro {policy}',
      days: 'dní',
    },
    autoUpdate: 'Automatické aktualizace',
    skins: {
      label: 'Vzhledy',
      hint: 'Mezi kterými vzhledy mohou účty přepínat v horní liště. Pokud budou povoleny méně než dva, přepínač se nezobrazí.',
      none: 'Přepínání vypnuto',
      emptyHint: 'Není-li povolen žádný, vidí všichni vzhled nastavený při nasazení.',
      builtinGroup: 'Vestavěné',
      customGroup: 'Vlastní',
      unavailable: 'V této instanci není k dispozici',
      custom: {
        label: 'Vlastní vzhledy',
        hint: 'Vzhledy přidané do této instance. Vzhled může měnit jen veřejné návrhové tokeny a při přidání se ověřuje.',
        manage: 'Spravovat vlastní vzhledy',
        none: 'Žádné vlastní vzhledy',
        count: { one: '{n} vlastní vzhled', few: '{n} vlastní vzhledy', many: '{n} vlastních vzhledů' },
        remove: 'Odebrat',
        removeTitle: 'Odebrat tento vzhled?',
        removeHint: 'Složka vzhledu se z této instance smaže. Kdo ho měl zapnutý, přejde na vzhled instance.',
        refusedBadge: 'Odmítnuto',
        takesEffect: 'Přidání i odebrání vzhledu se projeví hned, na každé otevřené stránce.',
        idLabel: 'Identifikátor vzhledu',
        idHint: 'Musí začínat na custom- a odpovídat názvu složky, ve které vzhled leží.',
        idPlaceholder: 'custom-sunrise',
        nameLabel: 'Zobrazovaný název',
        namePlaceholder: 'Světlé ráno',
        baseLabel: 'Vychází z',
        baseHint: 'Vzhled, který se přebarvuje a jehož strukturu si zachovává.',
        tokensLabel: 'Soubor tokenů',
        tokensHint: 'Jedno pravidlo :root s veřejnými návrhovými tokeny, například --radius: 8px;',
        tokensPlaceholder: ':root {\n  --radius: 8px;\n}',
        submit: 'Přidat vzhled',
        refusedPrefix: 'Vzhled nebyl přidán:',
        fontFamily: 'Rodina písma',
        fontFile: 'Soubor WOFF2',
        fontHint: 'Jeden běžný variabilní font WOFF2, nejvýše 2 MiB. Rodinu použijte v --font-sans nebo --font-mono.',
        fontUpload: 'Nahrát písmo',
        fontRemove: 'Odebrat písmo',
        fontBusy: 'Ukládání písma…',
      },
    },
    pushContact: 'Kontakt pro push oznámení',
    pushContactPlaceholder: 'https://vas-web.cz nebo mailto:vy@example.cz',
    system: 'Systém',
    version: 'Verze Chetty',
    updateAvailable: 'K dispozici {v}',
    upToDate: 'Aktuální verze',
    lastUpdateSucceeded: 'Poslední aktualizace proběhla úspěšně {date}',
    updateNow: 'Aktualizovat teď',
    checkUpdates: 'Zkontrolovat aktualizace',
    updating: 'Probíhá aktualizace…',
    services: 'Služby',
    serviceDaemon: 'Služba',
    serviceWeb: 'Web',
    serviceUp: 'Běží',
    serviceDown: 'Nedostupný',
    restartDaemon: 'Restartovat službu',
    restartWeb: 'Restartovat web',
    restartDaemonTitle: 'Restartovat službu?',
    restartDaemonDesc: 'Krátce přeruší API a běžící konverzace.',
    restartWebTitle: 'Restartovat web?',
    restartWebDesc: 'Krátce přeruší webové rozhraní; API poběží dál.',
    restartConfirm: 'Restartovat',
    unreadableTitle: 'Nastavení nelze přečíst',
    unreadableDesc: 'Uložené nastavení instance je poškozené. Zůstalo beze změny, dokud ho výslovně neobnovíte. Nic se neukládá a nic z toho, co je zde vidět, není uložená konfigurace. {reason}',
    unreadableReasonJson: 'Uložený záznam není platný JSON.',
    unreadableReasonObject: 'Uložený záznam není dokument nastavení.',
    unreadableReasonValue: 'Některá uložená hodnota je neplatná.',
    unreadableAdminOnly: 'Požádejte správce o jeho obnovení.',
    unreadableReset: 'Obnovit nastavení',
    unreadableResetTitle: 'Obnovit nastavení instance?',
    unreadableResetDesc: 'Poškozené nastavení včetně klíčů poskytovatelů se nahradí výchozím a poté je nelze získat zpět. Poskytovatele a klíče bude nutné zadat znovu.',
    unreadableResetConfirm: 'Obnovit',
    unreadableResetPending: 'Obnovuji',
    restartDaemonStarted: 'Služba se restartuje…',
    restartWebStarted: 'Web se restartuje…',
    systemDiagnostics: 'Diagnostika systému',
    systemDiagnosticsHint: 'Aktuální využití procesoru, paměti, disku, I/O a sítě a doba běhu služby. Kliknutím na měřidlo otevřete jeho historii.',
    diagnosticCpu: 'CPU',
    diagnosticMemory: 'Paměť',
    diagnosticUptime: 'Doba běhu',
    diagnosticDisk: 'Disk',
    diagnosticIo: 'IO',
    diagnosticNetwork: 'Síť',
    historyTitle: 'Historie vytížení',
    historyOpen: 'Otevřít historii {metric}',
    historyMetrics: 'Prostředky',
    historyShare: 'Podíly z kapacity v %; IO v % limitu nebo v MB/s bez limitu; síť v Mb/s',
    historyEmpty: 'Pro zvolené období nejsou k dispozici žádná měření.',
    historyNotStarted: 'Zaznamenávání ještě nezačalo.',
    historyGapsHelp: 'Chybějící nebo nedostupná měření zanechávají mezery. Neznamenají nulové vytížení.',
    historyAdjusted: 'Zobrazené období bylo upraveno podle dostupné historie a času serveru.',
    historyStale: 'Poslední známé hodnoty',
    historyError: 'Historii vytížení se nepodařilo načíst.',
    error_invalid_history_query: 'Filtry historie nejsou platné.',
    error_invalid_history_range: 'Zvolte platný začátek a konec období.',
    error_range_outside_retention: 'Zvolené období je mimo uchovávanou historii posledních 30 dní.',
    error_unsupported_history_resolution: 'Tento interval nelze použít pro zvolené období.',
    error_invalid_history_response: 'Odpověď historie není platná. Zkuste to prosím znovu.',
    retention: {
      label: "Automatický úklid konverzací",
      hint: 'Každou hodinu odstraní staré nečinné konverzace. Běžící, aktivní ani kanálové relace se nemažou.',
      olderThan: "Starší než",
      days: "dní",
    },
    on: 'Zapnuto',
    off: 'Vypnuto',
    modelSearchPlaceholder: 'Hledat modely…',
    modelNoMatches: 'Tomuto hledání neodpovídá žádný model.',
    modelCatalogEmpty: "Žádné modely nejsou k dispozici.",
  },
  projects: {
    newProject: 'Nový projekt',
    registry: 'Registr projektů',
    workspaceIntro: 'Projekty, stav repozitářů a automatizace na jednom místě.',
    registryReady: 'Registr je dostupný',
    metricProjects: 'projektů',
    metricIcons: 'vlastních ikon',
    metricDocumented: 's popisem',
    searchPlaceholder: 'Hledat projekty, cesty nebo poznámky…',
    menuSearch: 'Hledat projekty…',
    menuNoMatch: 'Nic nenalezeno',
    searchLabel: 'Hledat projekty',
    searchClear: 'Zrušit hledání projektů',
    openProject: 'Otevřít projekt {slug}',
    noMatches: 'Tomuto hledání neodpovídá žádný projekt.',
    tableLabel: 'Registr projektů',
    cardOpen: 'Otevřít',
    runtimeManaged: 'Spravované',
    runtimeHost: 'Host',
    hostStateTitle: 'Projekt na hostiteli',
    hostStateHint: 'Běží v hostitelském adresáři, bez vlastního kontejneru.',
    branchLabel: 'Aktuální větev',
    teamStrip: 'Lidé s přístupem k projektu {slug}',
    membersCount: 'S přístupem: {n}',
    teamEmpty: 'Nikdo nemá přístup',
    teamMore: 'Další: {n}',
    locationHostTitle: 'Adresář hostitele',
    locationGuestRoot: 'Cesta v prostředí',
    locationAdoptedFrom: 'Převedeno z',
    detailSections: 'Sekce projektu',
    tabOverview: 'Přehled',
    tabAccess: 'Lidé',
    groupLocation: 'Umístění',
    groupDetails: 'Podrobnosti',
    accessTitle: 'Přístup uživatelů',
    accessHint: 'Vyberte účty členů, které mohou tento projekt používat. Administrátoři mají automaticky přístup ke všem projektům.',
    accessCount: '{n} z {total} uživatelů má přístup',
    accessEmpty: 'Nejsou dostupné žádné běžné účty',
    addMember: 'Přidat člena',
    removeMember: 'Odebrat přístup',
    removeMemberTitle: 'Odebrat přístup?',
    removeMemberBody: '{name} ztratí přístup k projektu {project} včetně jeho souborů, pracovních stromů a uložených přihlašovacích údajů. Vlastní konverzace a vzpomínky zůstávají.',
    memorySharedTitle: 'Sdílená paměť',
    memorySharedDesc: 'Vybraní lidé budou sdílet paměť tohoto projektu. Agent ji v projektu využívá spolu s jejich soukromými vzpomínkami.',
    memoryEveryone: 'Není-li vybrán nikdo, paměť sdílejí všichni členové projektu.',
    memoryEveryoneShort: 'Všichni',
    memorySharersTitle: 'Kdo paměť sdílí',
    memorySharersGroup: 'Kdo sdílí',
    memorySharersCount: 'Sdílející lidé: {n}',
    memoryPickTitle: 'Přístup ke sdílené paměti',
    memoryPickHint: 'Vyberte členy, kteří sdílejí fond paměti projektu. Prázdný výběr znamená sdílení se všemi přiřazenými členy.',
    loadError: 'Nepodařilo se načíst projekty',
    empty: 'Žádné projekty',
    fieldSlug: 'Slug',
    rename: 'Přejmenovat',
    renameTitle: 'Přejmenovat projekt',
    renameMovesDirectory: 'Adresář projektu v prostředí se přesune z {from} do {to}. Spuštěné prostředí se kvůli tomu restartuje: rozpracovaná práce se ukončí a jeho služby se spustí znovu.',
    slugTaken: 'Projekt s tímto názvem už existuje. Zvolte jiný název.',
    slugReserved: 'Tento název je vyhrazený pro prostředí projektu. Zvolte jiný název.',
    renameWorktreesActive: 'Před přejmenováním odeberte pracovní kopie projektu: odkazují na jeho současný adresář.',
    fieldPath: 'Cesta',
    fieldNotes: 'Poznámky k projektu',
    create: 'Vytvořit',
    removeConfirmTitle: 'Odebrat projekt',
    removeConfirmBody: 'Odebrat projekt „{slug}“, jeho prostředí a navázané prostředky? Se soubory bude naloženo podle seznamu níže. Tuto akci nelze vrátit. Soukromá historie konverzací zůstane zachována.',
    deletionDeleteFiles: 'Smazat i soubory',
    deletionDeleteFilesHint: 'Odstraní se i pracovní složka projektu na hostiteli nebo párovaném počítači, kromě složek uvedených k zachování.',
    deletionKeepFilesHint: 'Soubory v pracovní složce projektu zůstanou zachovány, s výjimkou níže uvedených úložišť vlastněných pluginy.',
    deletionManagedDisk: 'Disk spravovaného prostředí a úložiště vlastněná pluginy se odstraní vždy, i když tato volba není zaškrtnutá.',
    deletionPreservedPaths: 'Složky, jejichž soubory zůstanou zachovány:',
    deletionPreservedReasons: {
      protected: 'Soubory se nesmažou: chráněná systémová, domovská nebo aplikační složka.',
      overlap: 'Soubory se nesmažou: složka se překrývá s jiným existujícím projektem.',
    },
    deletionPreservedBody: 'Projekt a jeho navázané prostředky se přesto odstraní. Soubory v těchto složkách zůstanou beze změny.',
    deletionScopeChanged: 'Rozsah mazání se změnil. Zkontrolujte aktualizovaný seznam a znovu jej potvrďte.',
    deletionPaths: 'Složky k odstranění včetně veškerého obsahu:',
    deletionItems: 'Navázané prostředky k odstranění:',
    deletionUnavailable: 'Nedostupní správci: {owners}. Jejich prostředky nyní nelze vypsat. Mazání zůstane blokované, dokud nebudou tito správci dostupní.',
    deletionConfirmFiles: 'Potvrzením souhlasíte s trvalým smazáním složek uvedených k odstranění a veškerého jejich obsahu, včetně složek existujících před vytvořením projektu, převzatých složek hostitele a pracovních složek párovaných počítačů.',
    deletionPending: 'Projekt se maže',
    deletionBlocked: 'Mazání je blokované',
    deletionInactive: 'Během mazání je tento projekt neaktivní.',
    deletionContinue: 'Pokračovat v mazání',
    removeConfirmBtn: 'Odebrat',
    slugPlaceholder: 'muj-projekt',
    pathPlaceholder: '~/projects/muj-projekt',
    browse: 'Procházet',
    pickFolder: 'Vybrat složku projektu',
    parentFolder: 'O úroveň výš',
    selectFolder: 'Vybrat tuto složku',
    folderEmpty: 'Žádné podsložky',
    folderError: 'Složku nelze načíst',
    pathMissing: 'Složka neexistuje',
    newFolder: 'Nová složka',
    folderName: 'Název složky',
    folderNamePlaceholder: 'Název složky',
    createFolder: 'Vytvořit složku',
    folderExists: 'Složka s tímto názvem už existuje.',
    folderCreateError: 'Složku se nepodařilo vytvořit. Zkontrolujte název a oprávnění a zkuste to znovu.',
    folderCreated: 'Složka „{name}“ byla vytvořena.',
    ctxCopyPath: 'Kopírovat cestu',
    ctxPathCopied: 'Cesta ke složce zkopírována',
    ctxRemove: 'Odebrat projekt',
    adoptProject: 'Převést na spravované prostředí',
    adoptConfirm: 'Projekt bude používat spravované prostředí. Při prvním spuštění se jeho pracovní prostor přesune do projektového svazku. Převod lze vrátit jen do prvního spuštění.',
    undoAdoption: 'Vrátit převod na spravované prostředí',
    undoAdoptionConfirm: 'Vrátit dosud nespouštěný projekt do původní složky v hostitelském počítači?',
    managed: 'Spravované prostředí',
    host: 'Složka v hostitelském počítači',
    computer: 'Počítač',
    computerActivity: 'Aktivita',
    executionKind: 'Cíl spouštění',
    privateHint: 'Projekt zůstane soukromý, dokud ho výslovně nesdílíte. Administrátoři k němu mají vždy přístup. Prostředí se spustí až při prvním použití.',
    defaultBadge: 'Výchozí',
    defaultBadgeHint: 'Výchozí projekt, první v pořadí. Otevírají se v něm konverzace z chatovacích platforem, ve kterých jste žádný projekt nevybrali.',
    reorderHint: 'Pořadí změníte podržením a přetažením úchytu karty, první projekt je výchozí.',
    reorderHandle: 'Přesunout projekt {slug}',
    reorderRole: 'přesouvatelný projekt',
    reorderInstructions: 'Mezerníkem nebo klávesou Enter projekt uchopíte, šipkami ho přesunete, mezerníkem nebo klávesou Enter ho pustíte. Klávesa Escape přesun zruší.',
    reorderPickedUp: 'Projekt {name} je uchopen. Pozice {position} z {total}.',
    reorderMoved: 'Projekt {name} je na pozici {position} z {total}.',
    reorderDropped: 'Projekt {name} byl přesunut na pozici {position} z {total}.',
    reorderCancelled: 'Přesun projektu {name} byl zrušen.',
    createGrant: 'Povolit další projekty',
    createGrantHint: 'Účet smí zakládat projekty nad rámec výchozího projektu.',
    shareGrant: 'Povolit pozvání do projektů',
    shareGrantHint: 'Účet smí zvát další lidi do svých projektů.',
    limit: 'Limit spravovaných projektů',
    limitHint: 'Počítá se i výchozí projekt. Administrátoři tyto limity účtu nemají.',
    permissions: 'Oprávnění projektů',
    invite: 'Pozvat člena',
    userId: 'ID účtu',
    userIdHint: 'Požádejte danou osobu o ID účtu. Seznam účtů mohou zobrazit pouze administrátoři.',
    member: 'Účet {id}',
    accessCountMembers: { one: 'Přístup má {n} uživatel', few: 'Přístup mají {n} uživatelé', many: 'Přístup má {n} uživatelů' },
    sharingWarning: 'Každý člen získá přístup ke všem dosavadním souborům projektu, pracovním kopiím, profilům prohlížeče a přihlašovacím údajům uloženým v prostředí. Členové mohou projekt stejně spravovat i smazat. Soukromé konverzace, vzpomínky a osobní propojení se automaticky nesdílejí.',
    computerSharingWarning: 'Každý člen pracuje na tomto počítači jako uživatel operačního systému, který na něm spouští připojení Chettyho: může číst a měnit jeho soubory a spouštět na něm příkazy. Soukromé konverzace a vzpomínky se automaticky nesdílejí.',
    computerMembersOwnerOnly: 'Členy počítače spravuje jen jeho vlastník.',
    inviteDenied: 'K pozvání členů potřebujete oprávnění ke sdílení, které uděluje administrátor.',
  },
  users: {
    projectDeleting: 'Projekt se maže. Přístup k němu nyní nelze měnit.',
    existingProjects: 'Existující projekty',
    newPersonalProject: 'Nový osobní projekt',
    presets: {
      detachConfirm: "Změnit právo",
      apply: "Přepsat všem v předvolbě",
      title: "Předvolby účtů",
      button: "Předvolby účtů",
      new: "Nová předvolba",
      name: "Název předvolby",
      create: "Vytvořit předvolbu",
      delete: "Smazat předvolbu",
      deleteTitle: "Smazat předvolbu účtů?",
      deleteBody: "Smazat „{name}“ a odpojit {n} účtů? Účty si ponechají současná práva a osobní nastavení.",
      deleteError: "Předvolbu se nepodařilo smazat.",
      choice: "Předvolba",
      accountsHint: "Kolik účtů předvolbu právě používá.",
      accounts: "Účty",
      identity: "Předvolba",
      nameHint: "Název, pod kterým se předvolba nabízí u účtů.",
      nameTaken: "Předvolba s tímto názvem už existuje.",
      intro: "Předvolba určuje oprávnění a výchozí chování účtů, které ji používají.",
      choiceHint: "Účet přebírá oprávnění a nastavení z předvolby, dokud některé z nich nezmění.",
      none: "Žádná",
      newAccount: "Předvolba pro nové účty",
      newAccountHint: "Nové lidské účty dostanou tuto předvolbu. Bez předvolby začínají bez práv.",
      empty: "Zatím nejsou vytvořeny žádné předvolby účtů.",
      loadError: "Předvolby účtů se nepodařilo načíst.",
      search: "Hledat předvolby",
      section: "Sekce předvolby",
      rights: "Práva",
      behavior: "Chování",
      behaviorHint: "Nevyplněné hodnoty se dědí z výchozího nastavení instance. Osobní nastavení účtu má přednost.",
      projectsHint: "Tyto Projekty jsou minimem členství připojených účtů. Další členství zůstávají.",
      accountCount: "Připojené účty: {n}",
      inherit: "Dědit výchozí hodnotu instance",
      inherited: "Z výchozího nastavení instance",
      detachTitle: "Odpojit účet od předvolby?",
      detachBody: "Tato změna práva odpojí účet od předvolby „{name}“. Další úpravy předvolby se na účet nebudou vztahovat.",
      applyTitle: "Přepsat nastavení účtům v předvolbě?",
      applyBody: "Smazat vlastní hodnotu „{field}“ u {n} účtů připojených k předvolbě „{name}“? Účty budou dědit hodnotu předvolby.",
      retainedProjects: "Poslední aktivní Projekt zůstal těmto účtům: {projects}",
    },
    defaults: {
      button: 'Výchozí nastavení uživatelů',
      title: 'Výchozí nastavení uživatelů',
      intro: "Základní chování účtů. Vlastní hodnoty a chování předvolby mají přednost.",
      navLabel: 'Sekce výchozích nastavení',
      navSearch: 'Hledat sekce',
      navNoMatches: 'Žádná výchozí nastavení tomuto hledání neodpovídají.',
      ownCount: 'Účty s vlastní hodnotou: {n}',
      apply: 'Přepsat všem',
      applyTitle: 'Přepsat všem?',
      applyBody: "Smazat vlastní hodnotu „{field}“ u {n} účtů? Budou dědit hodnotu předvolby, pokud ji má, jinak výchozí nastavení instance.",
      applied: 'Účty přebírající výchozí hodnotu: {n}',
      loadError: 'Výchozí hodnoty se nepodařilo načíst.',
      missingModel: 'Model už není nabízen',
      noChoice: 'Bez modelu',
      autoCompactAtHint: 'Podíl okna kontextu, při kterém se konverzace zhušťuje.',
      advisorStyleHint: 'Tón, kterým agent píše, když tento účet nechce nic jiného.',
      localeHint: 'Jazyk, ve kterém začíná rozhraní i odpovědi agenta.',
      rulesHint: 'Pravidla nástrojů, výchozí YOLO a jak se odpovídá na dotaz bez dozoru. Všechno je to jeden záznam: účet ho buď má celý vlastní, nebo celý přebírá.',
      pluginsEmpty: 'Žádný nainstalovaný plugin nenabízí osobní nastavení.',
      sectionModels: 'Modely',
      sectionMemory: 'Paměť',
      sectionSkills: 'Skills',
      sectionStyle: 'Styl a instrukce',
      sectionLanguage: 'Jazyk',
      sectionRules: 'Pravidla a YOLO',
      sectionPlugins: 'Pluginy',
    },
    projectRequired: 'Účet vyžaduje alespoň jeden aktivní projekt.',
    lastActiveProject: 'Nejprve těmto účtům přiřaďte jiný aktivní projekt. Jinak by ztratily svůj poslední aktivní projekt:',
    projectInactive: 'Vybraný projekt již není aktivní. Vyberte jiný projekt.',
    projectsLoadError: 'Nepodařilo se načíst projekty.',
    noActiveProjects: 'Žádný aktivní projekt není k dispozici. Vyberte nový osobní projekt.',
    workspaceEyebrow: 'Přehled přístupů',
    workspaceIntro: 'Účty, role, přístup k projektům a oprávnění k modelům i nástrojům na jednom místě.',
    workspaceReady: 'Adresář je synchronizovaný',
    metricUsers: 'uživatelů',
    metricAdmins: 'administrátorů',
    searchPlaceholder: 'Hledat uživatele…',
    searchLabel: 'Hledat uživatele',
    searchClear: 'Vymazat hledání uživatelů',
    openUser: 'Otevřít uživatele {name}',
    manageProjects: 'Spravovat přístup k projektům',
    manageModels: 'Spravovat povolené modely',
    managePlugins: 'Spravovat přidělené pluginy',
    manageTools: 'Spravovat přístup k nástrojům',
    noMatches: 'Žádný uživatel neodpovídá hledání',
    tableLabel: 'Adresář uživatelů',
    role: 'Role',
    createdAt: 'Vytvořeno',
    webActivityOnline: 'Online v administraci',
    webActivityAgo: 'Naposledy zde před {time}',
    webActivityDate: 'Naposledy zde {date}',
    webActivityNever: 'Zatím bez návštěvy administrace',
    sectionAccount: 'Účet',
    sectionPermissions: 'Oprávnění',
    detailSections: 'Sekce účtu',
    fromPreset: 'Z předvolby',
    projectDeletingState: 'Odstraňuje se',
    loadError: 'Nepodařilo se načíst uživatele',
    empty: 'Žádní uživatelé',
    emptyDescription: 'Pro začátek vytvořte první účet.',
    fieldUsername: 'Uživatelské jméno',
    fieldName: 'Zobrazované jméno',
    usernameTaken: 'Toto uživatelské jméno je již obsazené',
    addUser: 'Přidat uživatele',
    newUser: 'Nový uživatel',
    create: 'Vytvořit',
    delete: 'Smazat',
    createError: 'Uživatele se nepodařilo vytvořit.',
    createInvalid: 'Zadejte platné uživatelské jméno a heslo o délce alespoň osm znaků.',
    deleteError: 'Uživatele se nepodařilo smazat.',
    deleteLastUser: 'Poslední uživatelský účet nelze smazat.',
    deleteAdmin: 'Před smazáním uživateli odeberte roli administrátora.',
    deletePairedComputers: 'Účet má spárované počítače. Nejprve musí jejich vlastník potvrdit odstranění jejich Projektů, poté lze účet smazat.',
    deleteActiveProcesses: 'Uživatel má stále aktivní procesy. Před smazáním účtu je ukončete.',
    deleteCleanupError: 'Uživatele nelze smazat, protože se nepodařilo vyčistit data pluginů.',
    userNotFound: 'Uživatel již neexistuje.',
    adminRequired: 'Tato akce vyžaduje oprávnění administrátora.',
    cannotDemoteLastAdmin: 'Poslednímu administrátorovi nelze roli odebrat.',
    confirmDeleteTitle: 'Smazat {name}?',
    confirmDeleteDesc: 'Uživatele a všechna jeho data trvale smažete: nastavení, vzpomínky, osobnost i přístup k projektům. Tuto akci nelze vrátit.',
    projects: 'Projekty',
    admin: 'Administrátor',
    member: 'Člen',
    chatbot: 'Chatbot',
    chatbotHint: 'K tomuto účtu se nelze přihlásit běžným způsobem. Přihlášený administrátor do něj může vstoupit, účet ale nemůže získat roli administrátora.',
    makeAdmin: 'Povýšit na administrátora',
    removeAdmin: 'Odebrat administrátora',
    confirmMakeAdminTitle: 'Udělit uživateli {name} roli administrátora?',
    confirmMakeAdminDesc: 'Získá přístup ke správě uživatelů, nastavení instance i ke všem akcím dostupným pouze administrátorům.',
    confirmRemoveAdminTitle: 'Odebrat uživateli {name} administrátorský přístup?',
    confirmRemoveAdminDesc: 'Okamžitě ztratí přístup ke správě uživatelů, nastavení instance i ke všem akcím dostupným pouze administrátorům.',
    confirmSelfDemotionDesc: 'Okamžitě ztratíte přístup k části Uživatelé, nastavení instance i ke všem akcím dostupným pouze administrátorům. Roli vám může znovu udělit pouze jiný administrátor.',
    allowedModels: 'Povolené modely',
    allModels: 'Všechny modely',
    allModelsHint: 'Všechny modely, které tato instalace nabízí, včetně později přidaných.',
    modelGrantHint: 'Vyberte modely, které smí uživatel spouštět. Bez výběru nesmí spouštět žádný model.',
    noModelsGranted: 'Žádný povolený model',
    modelNotOffered: 'Není nabízen',
    updateError: 'Nepodařilo se uložit změnu',
    ctxImpersonate: 'Přihlásit se jako',
    impersonateError: 'Přihlášení jako uživatel se nezdařilo',
    impersonatingAs: 'Prohlížíte aplikaci jako {name}',
    stopImpersonating: 'Zpět na svůj účet',
    stopImpersonateError: 'Návrat na váš účet se nezdařil',
    grantedPlugins: 'Povolené pluginy',
    grantedPluginsHint: 'Části systému, například plány a skilly, se zpřístupňují jednotlivým uživatelům. Bez udělení přístupu je uživatel nemůže používat.',
    grantedPluginsCount: 'Povoleno {n} z {total}',
    grantedPluginsSelected: 'Povoleno: {n}',
    grantedPluginsEmpty: 'Žádný plugin se nepovoluje jednotlivým uživatelům.',
    tools: 'Nástroje',
    toolsHint: 'Nástroje dostupné uživateli v jeho vlastním chatu. Zaškrtnuté nástroje pluginů jste mu udělili. Nový účet je nemá, dokud mu je administrátor nepřidělí. Vestavěné nástroje lze také zapínat a vypínat. Automatická paměť vyžaduje povolený MemorySearch pro vybavování a MemoryAdd pro ukládání. Nedostupný nástroj zpřístupníte udělením příslušného pluginu. Přístup ke sdíleným kanálům Discordu určují pravidla rolí pluginu, ne tento seznam.',
    toolsEmpty: 'Žádné nástroje k dispozici',
    statMemories: 'Paměti',
    statSessions: 'Relace',
    statTopModel: 'Nejčastější model',
    noMemories: 'Bez pamětí',
    noSessions: 'Zatím žádné relace',
    noModel: 'Zatím žádný model',
    statTopModelHint: 'Model, který účet používá nejčastěji.',
    statSessionsHint: 'Počet konverzací, které účet vedl.',
    statMemoriesHint: 'Kolik vzpomínek si o účtu asistent uchovává.',
    createdAtHint: 'Kdy byl účet založen.',
    roleHint: 'Administrátoři spravují instanci, členové pracují v přidělených projektech.',
    fieldUsernameHint: 'Přihlašovací jméno účtu. Musí být jedinečné.',
    fieldNameHint: 'Jméno, pod kterým se účet zobrazuje v seznamech a konverzacích.',
    projectsNone: 'Účtu zatím není přidělený žádný projekt.',
    addProject: 'Přidat projekt',
    removeProject: 'Odebrat přístup',
    removeProjectTitle: 'Odebrat přístup k projektu?',
    removeProjectBody: 'Účet ztratí přístup k projektu {project} včetně jeho prostředí, souborů a uložených přihlašovacích údajů.',
    groupAccess: 'Modely a nástroje',
    groupActivity: 'Aktivita',
    groupIdentity: 'Identita',
  },
  managePicker: {
    manage: 'Spravovat',
    searchPlaceholder: 'Hledat…',
    all: 'Vše',
    none: 'Žádný',
    selectedCount: '{n} vybráno',
    saveChanges: 'Uložit změny',
    noResults: 'Žádné výsledky',
    filterByGroup: 'Filtrovat podle skupiny',
    modelsCount: 'Modely: {n} · poskytovatelé: {p}',
    allModelsCount: 'Povoleny všechny modely · dostupných: {n}',
    modelsSelected: 'Vybrané modely: {n}',
    projectsCount: 'Přiřazeno projektů: {n} z {total}',
    projectsSelected: 'Vybrané projekty: {n}',
    projectsSubtitle: 'Projekty, ke kterým má uživatel přístup.',
    toolsCount: 'Povoleno nástrojů: {n} z {total} · pluginů: {p}',
    toolsSelected: 'Vybrané nástroje: {n}',
    toolsSubtitle: 'Povolit nebo zakázat nástroje uživatelského účtu.',
    familyGrant: 'Povoleno vzorem',
    familyGrantHint: 'Nástroj je součástí povolené skupiny. Chcete-li jej zakázat, upravte povolený vzor v nastavení účtu.',
    notGranted: 'nepřiděleno',
    notGrantedHint: 'Uživatel nemá přístup k pluginu, který tento nástroj poskytuje, a nemůže ho proto spustit. Zpřístupníte ho udělením pluginu.',
    toolGroupElowen: 'Chetty',
    toolGroupMemory: 'Paměť',
  },
  vault: {
    share: "Sdílet",
    shareItem: "Sdílení položky {name}",
    sharedWith: { one: "Sdíleno s {count} uživatelem", few: "Sdíleno s {count} uživateli", many: "Sdíleno s {count} uživateli" },
    sharedBy: "Sdílí {name}",
    shareSearch: "Vyhledat uživatele",
    addAccess: "Sdílet s {name}",
    revokeAccess: "Odebrat přístup: {name}",
    title: "Trezor",
    hint: "Agent vidí pouze názvy a popisky a zapisuje {{vault:NAME}}; uložené hodnoty se již nikdy nezobrazí.",
    listTitle: "Vaše položky",
    add: "Přidat položku",
    describe: "Upravit popisek",
    replace: "Nahradit hodnotu",
    deleteTitle: "Smazat tuto položku?",
    deleteBody: "Položka {name} již nebude agentovi dostupná a její zaznamenané použití se smaže.",
    name: "Název",
    nameHint: "A–Z, 0–9 a _, začíná písmenem, nejvýše 64 znaků.",
    description: "Popisek",
    descriptionHint: "Popište, k čemu má agent položku použít (1–500 znaků).",
    value: "Hodnota",
    valueHint: "Alespoň 4 znaky, nejvýše 64 KiB. Hodnota se uloží přesně tak, jak ji zadáte.",
    multiline: "Víceřádková hodnota",
    empty: "Zatím žádné položky",
    emptyHint: "Přidejte přihlašovací údaj, který agent použije bez zobrazení jeho hodnoty.",
    updated: "Poslední změna",
    listHint: "Agent vidí názvy a popisky, uložené hodnoty se znovu nezobrazují. Vlastní i sdílené položky používá pomocí odkazu vault:NAME ve dvojitých složených závorkách. Název musí být ve vašem trezoru jedinečný. Sdílejte jen s lidmi, kterým důvěřujete: příjemce může hodnotu prostřednictvím nástroje vynést. Odebrání sdílení zablokuje další použití, ale nevezme hodnotu již běžícímu procesu. Při úniku údaj také změňte u jeho poskytovatele.",
    shareConflict: "Tento uživatel již má položku se stejným názvem.",
    shareFailed: "Sdílení se nepodařilo změnit.",
    shareLoadFailed: "Sdílení se nepodařilo načíst.",
    lastUsed: "Naposledy použito",
    never: "Nikdy",
    usageByPerson: "Použití podle osob",
    deletedActor: "Smazaný účet #{id}",
    statsLoadError: "Použití se nepodařilo načíst",
    chartTitle: "Použití po dnech",
    chartUses: "Použití",
    totals: { one: "{n} použití", few: "{n} použití", many: "{n} použití" },
    exists: "Položka s tímto názvem již existuje.",
    notFound: "Tato položka již neexistuje. Načtěte seznam znovu.",
    unavailable: "Trezor není dostupný. Zkuste to prosím později.",
    chatbot: "Trezor není pro účty chatbotů dostupný.",
    failed: "Položku se nepodařilo uložit. Zkuste to prosím znovu.",
    validation: "Zkontrolujte název, popisek a hodnotu podle pravidel u polí.",
  },
  apiTokens: {
    sectionHint: 'Osobní API tokeny umožňují vašim nástrojům ovládat agenta přes HTTP, s vaším oprávněním.',
    listTitle: 'Vaše tokeny',
    listHint: 'Každý token se přihlašuje jako vy, s vaším oprávněním.',
    create: 'Nový token',
    createTitle: 'Nový API token',
    name: 'Název',
    namePlaceholder: 'CI pipeline',
    expires: 'Platnost do',
    expiresHelp: 'Token přestane fungovat na konci tohoto dne v UTC. Ponechte prázdné pro token, který platí, dokud ho nesmažete.',
    expiresPast: 'Datum vypršení platnosti nesmí být v minulosti.',
    expiresNever: 'Bez omezení',
    createSubmit: 'Vytvořit token',
    createError: 'Token se nepodařilo vytvořit',
    revealedTitle: 'Zkopírujte si token',
    revealedHint: 'Zobrazuje se pouze nyní. Chetty si ukládá jen jeho otisk, takže ho později už nelze vypsat.',
    copy: 'Kopírovat',
    copied: 'Zkopírováno',
    done: 'Hotovo',
    columns: {
      lastUsed: 'Naposledy použit',
      expires: 'Platnost do',
    },
    never: 'Nikdy',
    costUnknown: 'Cena neznámá',
    emptyTitle: 'Zatím žádné tokeny',
    emptyDescription: 'Vytvořte token a volejte agenta ze svých skriptů nebo z CI.',
    loadError: 'Tokeny se nepodařilo načíst',
    statsLoadError: 'Spotřebu se nepodařilo načíst',
    chartTitle: 'Běhy a náklady po dnech',
    chartTurns: 'Běhy',
    chartAnswered: 'Odpovězeno',
    chartErrors: 'Selhalo',
    chartCost: 'Náklady',
    chartEmpty: 'V tomto období nic zaznamenáno',
    chartCostUnknown: 'Některé běhy v tomto období nehlásily náklady, takže jejich součet není znám, ne že je nula.',
    totals: '{requests} požadavků · {turns} běhů · {answered} odpovězeno · {failed} selhalo · {tokens} tokenů · {cost}',
    limitsTitle: 'Limity',
    limitsHint: 'Každý limit je nepovinný. Limit přepnutý na bez omezení se nevynucuje.',
    limitsError: 'Limity se nepodařilo uložit',
    unlimited: 'Bez omezení',
    limits: {
      dailyCostMicrousd: 'Náklady/den',
      monthlyCostMicrousd: 'Náklady/měsíc',
      requestsPerMinute: 'Požadavky/min',
      maxConcurrentTurns: 'Souběžně',
    },
    limitHints: {
      dailyCostMicrousd: 'Den se počítá v UTC. Jakmile zaznamenané náklady dosáhnou této částky, běhy se odmítnou. Odmítají se i v den, kdy některý běh nehlásil náklady, protože útratu nelze ověřit.',
      monthlyCostMicrousd: 'Měsíc se počítá v UTC. Jakmile zaznamenané náklady dosáhnou této částky, běhy se odmítnou až do začátku dalšího měsíce. Odmítají se i v měsíci, kdy některý běh nehlásil náklady, protože útratu nelze ověřit.',
      requestsPerMinute: 'Platí pro každý požadavek ověřený tímto tokenem, ať žádá cokoli.',
      maxConcurrentTurns: 'Kolik běhů může tento token mít současně spuštěných.',
    },
    regenerateTitle: 'Vytvořit novou hodnotu tokenu?',
    regenerateBody: '„{name}“ zůstane se stejným názvem, limity i zaznamenanou spotřebou, ale dostane novou hodnotu: ta současná okamžitě přestane fungovat a vše, co ji používá, se musí aktualizovat.',
    regenerate: 'Vytvořit novou hodnotu',
    regenerateError: 'Novou hodnotu tokenu se nepodařilo vytvořit.',
    delete: 'Smazat',
    deleteTitle: 'Smazat tento token?',
    deleteBody: 'Vše, co používá „{name}“, přestane okamžitě fungovat a jeho zaznamenaná spotřeba se smaže.',
    deleteError: 'Token se nepodařilo smazat',
    callTitle: 'Volání agenta',
    callHint: 'Pošlete token jako bearer hlavičku na /api/v1/agent/runs tohoto hostu. Odpověď uvádí svou konverzaci; předáním jejího identifikátoru jako conversationId v ní pokračujete. S "stream": true dostáváte průběh jako server-sent events.',
  },
  elowenCli: {
    sectionHint: 'Propojte své počítače s Chettym. Agent na nich pracuje se soubory a příkazy.',
    approveTitle: 'Schválit přihlášení',
    accountApproveTitle: 'Schválit přihlášení CLI na serveru',
    accountApproveHint: 'Terminál získá osobní API token s přístupem k vašemu účtu. Počítač se nepáruje. Přístup můžete zrušit v Účet → API tokeny.',
    accountApproved: 'Přihlášení CLI na serveru bylo schváleno',
    terminal: 'Terminál',
    approveHint: 'Zařízení získá plný přístup k vašemu účtu.',
    device: 'Zařízení',
    code: 'Kód',
    approve: 'Schválit',
    deny: 'Zamítnout',
    approved: 'Zařízení bylo schváleno',
    denied: 'Přihlášení bylo zamítnuto',
    decideError: 'Rozhodnutí se nepodařilo uložit',
    codeExpired: 'Platnost kódu vypršela',
    codeExpiredHint: 'Spusťte na zařízení znovu elowen login.',
    codeDecided: 'O tomto přihlášení už bylo rozhodnuto',
    codeLoadError: 'Žádost o přihlášení se nepodařilo načíst',
    installTitle: 'Instalace',
    installHint: 'Zkopírovaný příkaz spusťte v terminálu v Linuxu nebo macOS.',
    installHintWindows: 'Zkopírovaný příkaz vložte do PowerShellu ve Windows.',
    installHintMac: 'Zkopírovaný příkaz spusťte v aplikaci Terminál v macOS.',
    installHintLinux: 'Zkopírovaný příkaz spusťte v terminálu v Linuxu.',
    installerLabel: 'Operační systém',
    installerUnix: 'macOS a Linux',
    installerWindows: 'Windows',
    installSelfOnly: 'Počítač může připojit jen uživatel sám.',
    copyInstall: 'Kopírovat instalační příkaz',
    enrollmentLoadError: 'Platnost instalačního příkazu se nepodařilo načíst',
    copyCountdown: 'Zkopírováno · {time}',
    copyAvailableAt: 'Instalační příkaz byl zkopírován. Znovu jej můžete zkopírovat v {time}.',
    copied: 'Instalační příkaz byl zkopírován',
    installError: 'Instalační příkaz se nepodařilo vytvořit',
    devicesTitle: 'Moje počítače',
    connected: 'Připojeno',
    neverConnected: 'Zatím nepřipojeno',
    computerName: 'Název',
    system: 'Systém',
    client: 'Klient',
    emptyTitle: 'Zatím žádné počítače',
    emptyDescription: 'Spusťte instalační příkaz na počítači, který chcete připojit.',
    loadError: 'Vaše počítače se nepodařilo načíst',
    offline: 'Offline',
    clientVersion: 'klient {version}',
    lastOnline: 'Naposledy online',
    statsLoadError: 'Využití se nepodařilo načíst',
    chartTitle: 'Běhy a příkazy po dnech',
    chartTurns: 'Běhy',
    chartCommands: 'Příkazy',
    chartErrors: 'Selhalo',
    chartCost: 'Náklady',
    chartCostUnknown: 'Některé běhy v tomto období nehlásily náklady, takže jejich součet není znám, ne že je nula.',
    costUnknown: 'Cena neznámá',
    totals: '{turns} běhů · {commands} příkazů · {files} upravených souborů · {tokens} tokenů · {cost}',
    loadTitle: 'Aktuální zátěž',
    loadUnknown: 'Žádné aktuální měření. Zobrazí se, když je počítač připojen.',
    cores: { one: '{n} jádro', few: '{n} jádra', many: '{n} jader' },
  },
  account: {
    effectsTitle: 'Vizuální efekty',
    effectsHint: 'Ovládá animace a přechody na tomto zařízení. Režim Automaticky se řídí nastavením operačního systému.',
    effectsAuto: 'Automaticky',
    effectsFull: 'Plný rozsah',
    effectsReduced: 'Omezené',
    effectsOff: 'Vypnuté',
    title: 'Můj účet',
    navigationLabel: 'Sekce účtu',
    navigationSearch: 'Hledat v účtu',
    navigationNoMatches: 'Žádné nastavení účtu tomuto hledání neodpovídá.',
    profileHint: 'Spravujte svou identitu, výchozí nastavení a propojené účty.',
    name: 'Jméno',
    email: 'E-mail',
    uploadAvatar: 'Nahrát avatar',
    saveError: 'Uložení selhalo',
    password: 'Heslo',
    passwordHint: 'Změňte si přihlašovací heslo. Nové heslo musí mít alespoň 8 znaků.',
    currentPassword: 'Současné heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrzení nového hesla',
    changePassword: 'Změnit heslo',
    passwordChanged: 'Heslo změněno',
    passwordMismatch: 'Nová hesla se neshodují',
    passwordWrong: 'Současné heslo není správné',
    passwordError: 'Změna hesla selhala',
    uiScale: 'Měřítko rozhraní',
    uiScaleReset: 'Obnovit',
    tabProfile: 'Účet',
    tabApiTokens: 'API tokeny',
    tabComputers: 'Počítače',
    tabSecurity: 'Zabezpečení',
    tabNotifications: 'Oznámení',
    tabCli: 'Modely',
    apiDocs: 'Dokumentace API',
    tabTerminal: 'Terminál',
    tabMemory: 'Paměť',
    tabPersonality: 'Osobnost',
    personalPluginConfig: 'Osobní nastavení pluginu',
    platformLinkConflict: 'Tato identita je již propojena s jiným účtem.',
    linkedAccounts: 'Propojené účty',
    linkDisconnect: 'Odpojit',
    detailsTitle: 'Osobní údaje',
    detailsHint: 'Jak se zobrazujete v pracovním prostoru a kam vám chodí e-maily.',
    appearanceTitle: 'Vzhled',
    appearanceHint: 'Předvolby zobrazení pro toto zařízení.',
    passwordRequirement: 'Použijte alespoň 8 znaků.',
  },
  accountMemory: {
    recallTitle: 'Automatické vyhledávání vzpomínek',
    recallToggle: 'Vyhledávat v paměti po každé zprávě',
    liveRecallTitle: 'Vyhledávání při přípravě odpovědi',
    liveRecallToggle: 'Znovu vyhledat vzpomínky během přípravy odpovědi',
    saveTitle: 'Automatické ukládání',
    saveToggle: 'Ukládat nové vzpomínky po každé odpovědi',
    learnSkillsTitle: 'Učení skillů',
    learnSkillsToggle: 'Učit se skilly z dokončené práce',
    saveError: 'Nastavení paměti se nepodařilo uložit.',
    review: {
      last: 'Naposledy {date}',
      none: 'Zatím neproběhl žádný průchod',
      outcome: { nothing: 'nic nenavrženo', saved: 'uloženo: {names}', rejected: 'návrhy zamítnuty', failed: 'selhalo', aborted: 'vypršel čas' },
      totals: 'celkem {parts}',
      runs: { one: '{n} průchod', few: '{n} průchody', many: '{n} průchodů' },
      saved: { one: '{n} uložený skill', few: '{n} uložené skilly', many: '{n} uložených skillů' },
      failed: { one: '{n} selhání', few: '{n} selhání', many: '{n} selhání' },
      next: { one: 'další průchod za {n} krok', few: 'další průchod za {n} kroky', many: 'další průchod za {n} kroků' },
    },
    dreaming: {
      abortCause: {
        disabled: 'Zastaveno po vypnutí údržby paměti.',
        noProgress: 'Údržba byla ukončena, protože dávka nezkontrolovala žádné další vzpomínky.',
        user: 'Zastaveno uživatelem.',
        accountDeleted: 'Zastaveno kvůli odstranění účtu.',
        daemonPause: 'Přerušeno při pozastavení služby.',
        parentTeardown: 'Zastaveno při ukončení nadřazené konverzace.',
        treeAbort: 'Zastaveno společně s nadřazeným úkolem.',
        recovery: 'Zastaveno při obnově služby.',
      },
      operationTitle: 'Údržba paměti',
      reviewing: 'Zkontrolováno {reviewed} z {total} vzpomínek',
      showHistory: 'Zobrazit celou historii',
      hideHistory: 'Skrýt historii',
      title: 'Automatická údržba paměti',
      hint: 'Slučuje podobné poznámky, opravuje zastaralé údaje a zkracuje paměti pro další použití.',
      toggle: 'Automatická údržba paměti',
      off: 'Dokud je tato volba vypnutá, neběží nic automaticky.',
      model: 'Model údržby',
      modelHint: 'Který model vzpomínky slučuje. Výchozí volba přebírá model konverzace, ze které údržba vychází.',
      sameModel: 'Stejný model jako konverzace',
      unavailable: 'Nedostupný',
      overview: 'Proběhlé údržby',
      overviewHint: 'Kdy která údržba proběhla a co změnila. Po rozbalení uvidíte stav každé vzpomínky před změnou a po ní.',
      runNow: 'Spustit nyní',
      deleteRun: 'Odstranit z historie',
      deleteTitle: 'Odstranit záznam údržby?',
      deleteBody: 'Tento záznam bude odstraněn z historie údržby. Vaše vzpomínky a jejich historie změn zůstanou zachovány.',
      deleteError: 'Záznam údržby se nepodařilo odstranit.',
      stop: 'Zastavit',
      empty: 'Zatím neproběhla žádná údržba',
      emptyHint: 'První údržba se spustí sama, až bude účet dostatečně v klidu, nebo hned poté, co ji spustíte ručně.',
      noChanges: 'Tato údržba nezměnila žádnou vzpomínku.',
      loadError: 'Údržbu paměti se nepodařilo načíst.',
      runsError: 'Proběhlé údržby se nepodařilo načíst.',
      changesError: 'Změny této údržby se nepodařilo načíst.',
      openMemory: 'Otevřít paměti',
      before: 'Před',
      after: 'Po',
      memory: 'Vzpomínka #{id}',
      older: 'Starší',
      newer: 'Novější',
      trigger: { auto: 'automaticky', manual: 'ručně' },
      status: { running: 'probíhá', completed: 'dokončeno', failed: 'selhalo', aborted: 'zastaveno', interrupted: 'přerušeno' },
      counts: 'přidáno {added} · upraveno {updated} · sloučeno {merged} · smazáno {deleted} · zkontrolováno {reviewed}/{batch}',
      refusal: {
        model_not_allowed: 'Zvolený model není pro tento účet povolený.',
        model_unavailable: 'Zvolený model už není nabízen.',
        memory_tools_not_granted: 'Tento účet nesmí zapisovat do paměti, proto údržba nemůže běžet.',
        memory_writes_denied_by_rule: 'Zápis do paměti blokuje pravidlo oprávnění, proto údržba nemůže běžet.',
        no_conversation: 'Údržba vychází z některé z vašich konverzací a zatím žádná není k dispozici.',
        spend_limit: 'Účet dosáhl limitu útraty.',
      },
    },
  },
  personality: {
    intro: 'Nastavte, jak má Chetty komunikovat a spolupracovat s vámi.',
    styleLabel: 'Styl komunikace',
    styleProfessional: 'Profesionální',
    styleFriendly: 'Přátelský',
    styleConcise: 'Stručný',
    styleDetailed: 'Podrobný',
    bodyLabel: 'Pokyny pro agenta',
    bodyPlaceholder: 'Napište vlastní pokyny pro Chetty…',
    bodyHint: 'Vlastní pokyny, jak se má Chetty chovat a spolupracovat s vámi. Platí všude.',
    bodyEdit: 'Upravit pokyny',
    bodyAdd: 'Přidat pokyny',
    saveError: 'Pokyny se nepodařilo uložit',
  },
  memory: {
    embeddingTestError: 'Test vloženého modelu se nepodařil.',
    // Seznam
    workspaceIntro: 'Trvalé informace, rozhodnutí a preference, které může Chetty využít v dalších konverzacích.',
    synchronized: 'Paměť synchronizována',
    metricDecisions: 'Rozhodnutí',
    metricFacts: 'Fakta',
    searchPlaceholder: 'Hledat v paměti…',
    searchClear: 'Zrušit hledání',
    openRow: 'Otevřít paměť: {excerpt}',
    filterStatus: 'Stav',
    filterKind: 'Druh',
    statusActive: 'Aktivní',
    statusArchived: 'Archivované',
    statusDeleted: 'Smazané',
    statusAll: 'Vše',
    allKinds: 'Všechny druhy',
    empty: 'Zatím žádné vzpomínky.',
    emptyHint: 'Přidejte fakt, který si má asistent pamatovat, nebo je nechte zaznamenávat během práce.',
    emptySearch: 'Vašemu hledání neodpovídá žádná vzpomínka.',
    newMemory: 'Nová vzpomínka',
    detailTitle: 'Detail vzpomínky',
    // Pole detailu
    fieldBody: 'Vzpomínka',
    fieldBodyPlaceholder: 'Trvalý, samostatně srozumitelný fakt…',
    fieldKind: 'Druh',
    fieldKindPlaceholder: 'např. user, feedback, project, reference',
    fieldImportance: 'Důležitost',
    fieldVitality: 'Vitalita',
    // Využití
    usage: 'Využití',
    useCount: 'Použito {n}×',
    neverUsed: 'Nikdy nepoužito',
    usedAt: 'Použito',
    // Vývoj vitality (graf v detailu)
    vitalityChart: 'Vývoj vitality',
    vitalitySeriesLabel: 'řada',
    vitalitySeriesMeasured: 'naměřeno',
    vitalitySeriesForecast: 'předpověď',
    vitalityEvictOn: 'Přesune se do koše {date}',
    vitalityForecastHint: 'Čárkovaná čára počítá s tím, že se vzpomínka už znovu nevybaví.',
    vitalityNoHistory: 'Tato vzpomínka byla použita ještě před začátkem zaznamenávání historie. Proto se zobrazuje jen předpověď.',
    // Časové značky
    createdAt: 'Vytvořeno',
    updatedAt: 'Upraveno',
    sourceLabel: 'Zdroj',
    detailsHeading: 'Podrobnosti',
    // Akce
    edit: 'Upravit',
    delete: 'Smazat',
    restore: 'Obnovit',
    merge: 'Sloučit',
    save: 'Uložit',
    done: 'Hotovo',
    cancel: 'Zrušit',
    create: 'Vytvořit',
    // Oznámení
    bodyRequired: 'Text vzpomínky je povinný',
    // Potvrzení smazání
    deleteConfirmTitle: 'Smazat vzpomínku?',
    deleteConfirmBody: 'Vzpomínka se přesune do koše a asistent si ji přestane vybavovat. Později ji můžete obnovit.',
    // Sloučení
    mergeTitle: 'Sloučit vzpomínky',
    mergeHint: 'Vybrané vzpomínky se spojí do jedné nové. Původní se přesunou do koše.',
    mergeBodyLabel: 'Sloučená vzpomínka',
    mergeSelected: 'Vybráno: {n}',
    mergeConfirm: 'Sloučit',
    mergeNeedsTwo: 'Ke sloučení vyberte alespoň dvě vzpomínky.',
    // Trvalé smazání a koš
    purge: 'Trvale smazat',
    purgeConfirmTitle: 'Smazat natrvalo?',
    purgeConfirmBody: 'Tímto se vzpomínka trvale odstraní. Nelze ji obnovit.',
    purgeConfirm: 'Trvale smazat',
    emptyTrash: 'Vysypat koš',
    emptyTrashConfirmTitle: 'Vysypat koš?',
    emptyTrashConfirm: 'Trvale smaže všechny vzpomínky v koši. Tuto akci nelze vrátit zpět.',
    // Card order (filter panel)
    sortLabel: 'Řazení',
    sortDirection: 'Směr',
    sortDescending: 'Sestupně',
    sortAscending: 'Vzestupně',
    // Hromadný výběr
    selectPage: 'Vybrat tuto stránku',
    selectRow: 'Vybrat paměť: {excerpt}',
    clearSelection: 'Zrušit výběr',
    selectedCount: 'Vybráno: {n}',
    bulkDelete: 'Smazat vybrané',
    bulkDeleteConfirmTitle: 'Smazat vybrané vzpomínky?',
    bulkDeleteConfirmBody: 'Přesunout vybrané vzpomínky do koše ({n})? Později je můžete obnovit.',
    bulkRestore: 'Obnovit vybrané',
    // Historie
    auditHeading: 'Historie',
    auditEmpty: 'Zatím žádná historie.',
    actionAdd: 'Přidáno',
    actionUpdate: 'Upraveno',
    actionDelete: 'Smazáno',
    actionRestore: 'Obnoveno',
    actionMerge: 'Sloučeno',
    eventModel: 'Model',
    // Uživatelská údržba
    maintenanceTitle: 'Údržba paměti',
    maintenanceIntro: 'Obnovte data pro vyhledávání nebo uspořádejte své vzpomínky. Operace běží na pozadí a pokračují i při chybě u jednotlivých položek.',
    maintenanceReindex: 'Znovu vytvořit index vzpomínek',
    maintenanceReindexRow: 'Index paměti',
    maintenanceReindexHint: 'Znovu vytvoří data pro vyhledávání všech aktivních vzpomínek ve vašem účtu.',
    maintenanceRecategorize: 'Znovu roztřídit vzpomínky',
    maintenanceRecategorizeRow: 'Třídění paměti',
    maintenanceRecategorizeHint: 'Model pro třídění přiřadí vaše vzpomínky do vašich kategorií.',
    maintenanceCategorizationUnconfigured: 'Než vzpomínky uspořádáte, nastavte v Nastavení model pro třídění.',
    maintenanceRun: 'Spustit',
    maintenanceRunAll: 'Spustit pro vše',
    maintenanceAll: 'Znovu roztřídit všechny vzpomínky',
    maintenanceAllConfirmTitle: 'Znovu roztřídit všechny vzpomínky?',
    maintenanceAllConfirmBody: 'Kategorizační model zkontroluje každou aktivní vzpomínku ve vašem účtu. Ruční změny provedené během operace zůstanou zachovány.',
    maintenanceFailed: 'Údržba paměti selhala.',
    maintenanceRunning: 'Probíhá',
    maintenanceDone: 'Dokončeno',
    maintenanceError: 'Selhalo',
    maintenanceInterrupted: 'Přerušeno restartem',
    maintenanceInterruptedChip: 'Přerušeno',
    maintenanceCounts: 'Úspěšně: {succeeded}; selhalo: {failed}.',
    maintenanceAcknowledge: 'Potvrdit výsledek',
    maintenanceIdle: 'Připraveno',
    maintenanceFailures: 'Neaktualizované položky: {n}',
    // Nastavení embeddingu
    embeddingProvider: 'Poskytovatel embeddingů',
    embeddingProviderPlaceholder: 'např. openai',
    embeddingModel: 'Model embeddingů',
    embeddingDimensions: 'Dimenze',
    embeddingUnconfigured: 'Nenastaveno',
    embeddingSaveError: 'Uložení nastavení embeddingu selhalo',
    embeddingTest: 'Otestovat',
    embeddingTesting: 'Testuji…',
    embeddingTestOk: 'Test úspěšný — {dimensions} dimenzí.',
    embeddingUnconfiguredError: 'Nejprve nastavte poskytovatele embeddingu.',
    reindexUnconfigured: 'Před reindexací nastavte poskytovatele embeddingu.',
    // Kategorie
    categoryFilter: 'Kategorie',
    categoryAll: 'Všechny kategorie',
    categoryUncategorized: 'Bez kategorie',
    categoryChipNone: 'Bez kategorie',
    groupByCategory: 'Seskupit dle kategorie',
    categoriesTitle: 'Kategorie',
    categoriesEmpty: 'Zatím žádné kategorie.',
    categoryNew: 'Nová kategorie',
    categoryName: 'Název',
    categoryNamePlaceholder: 'např. Preference',
    categoryDescription: 'Popis',
    categoryDescriptionPlaceholder: 'Co do této kategorie patří…',
    categoryProject: 'Rozsah projektu',
    categoryProjectGlobal: 'Globální (všechny konverzace)',
    categoryProjectsLoading: 'Načítání projektů…',
    categoryProjectsError: 'Projekty se nepodařilo načíst.',
    categoryColor: 'Barva',
    categoryIcon: 'Ikona',
    categoryIconSuggest: 'Navrhnout ikonu',
    categoryCreate: 'Vytvořit',
    categoryDelete: 'Smazat kategorii',
    categoryDeleteConfirmTitle: 'Smazat kategorii?',
    categoryDeleteConfirmBody: 'Kategorie se odebere a zmizí ze všech vzpomínek, které ji používají. Samotné vzpomínky zůstanou.',
    categoryNameRequired: 'Název kategorie je povinný',
    categoryNameExists: 'Kategorie s tímto názvem již existuje.',
    categorySaveError: 'Uložení kategorie selhalo',
    memoryCount: '{n}',
    sharedBadge: 'sdílené · {project}',
    sharedBy: 'Sdílel {author}',
    categoryShared: 'sdílená',
    categorySharedHint: 'Jde o sdílenou paměť projektu. Její popis ovlivňuje třídění pro celý tým. Měnit ji může jen administrátor a projekt už nelze změnit.',
    // Záložky pohledu
    viewBrain: 'Mapa',
    viewList: 'Seznam',
    // Neuronový mozek paměti
    brainCore: 'Paměť',
    brainEmpty: 'Zatím není co mapovat.',
    brainEmptyHint: 'S přibývajícími vzpomínkami se zde zobrazí jejich mapa.',
    brainCategoryCount: '{n} vzpomínek',
  },
  pills: {
    showMore: "+{n} dalších",
    showLess: "Zobrazit méně",
  },
  categorization: {
    configured: "Nastaveno",
    notConfigured: "Nenastaveno",
    saveError: "Nastavení kategorizace se nepodařilo uložit.",
  },
  brain: {
    routerChoice: 'Router',
    routerRemoveMember: 'Odebrat z routeru',
    routerRequirement: 'Vyberte alespoň dva účty od nejméně dvou poskytovatelů.',
    routerEmpty: 'Vybrané účty nemají společné modely.',
    routerPreviewError: 'Společné modely se nepodařilo načíst.',
    routerPriceUnknown: 'Cena není známa',
    routerUnknown: 'není známo',
    routerMemberLimits: 'Limity a ceny upravujte u modelů členských poskytovatelů.',
    routerLimits: 'Kontext: {context}, výstup: {output}',
    routerPrices: 'USD za milion tokenů: vstup {input}, výstup {output}',
    routerReferenced: 'Účet používá router. Před odstraněním upravte jeho členy.',
    maxSteps: "Max kroků",
    maxStepsHint: "Nejvyšší počet kol s modelem pro jeden požadavek. Chrání před zacyklením. Rozsah 100–1 000 po 100, výchozí 200.",
    subagents: {
      forkParentContext: "Sdílet kontext",
      forkParentContextHint: 'Pokud volání Delegate neurčí jinak, sub-agent začne s touto konverzací: dostane stejný systémový prompt, stejné nástroje i celou historii. Poskytovatel tak může použít uložený začátek kontextu, který stojí méně než nový vstup. Mezipaměť se sdílí jen tehdy, když se přístup sub-agenta nijak neomezí. Proto mu nelze nastavit vlastní sadu nástrojů, režim jen pro čtení ani typ sub-agenta. Při použití jiného modelu se mezipaměť nesdílí.',
    },
    limits: {
      title: "Limity a opětovné připojování",
      manage: "Upravit limity",
      hint: "Limity asistenta a jednotná pravidla opakování požadavků na model a připojení.",
      toolOutputMaxLines: 'Výstup: řádky',
      toolOutputMaxLinesHint: "Kolik řádků výstupu nástroje zobrazí rozbalený náhled, než se starší řádky skryjí. Rozsah {min}–{max}, výchozí {default}.",
      toolOutputMaxChars: 'Výstup: tokeny',
      toolOutputMaxCharsHint: "Přibližný strop počtu tokenů rozbaleného výstupu nástroje; delší výstup se ořízne. Počítá se se 4 znaky na token. Rozsah ≈{min}–{max} tokenů, výchozí ≈{default}.",
      toolResultInlineBytes: 'Inline limit',
      toolResultInlineBytesHint: 'Limit pro zobrazení výsledků nástrojů a výsledků předaných pomocí Delegate nebo Workflow. Co ho překročí, dorazí jen v omezeném náhledu; celý obsah zůstane dostupný přes Read. Hodnota je v bajtech. Rozsah 30 000–180 000 B, výchozí 120 000 B.',
      toolResultGroupBudgetBytes: 'Limit na tah',
      toolResultGroupBudgetBytesHint: "Celkový limit paralelních výsledků nástrojů a dokončených delegovaných výsledků v jednom tahu. Největší výsledky se odloží na disk, dokud se blok nevejde. Hodnota je v bajtech a nikdy neklesne pod limit zobrazení. Rozsah 100 000–300 000 B, výchozí 200 000 B.",
      compactionFailureLimit: 'Selhání',
      compactionFailureLimitHint: 'Po kolika neúspěšných pokusech za sebou přestane konverzace automaticky zkracovat kontext. Další pokus by spotřeboval volání modelu, které nemůže uspět. Příliš nízká hodnota zastaví zkracování i po krátkém výpadku poskytovatele. Ruční příkaz „/compact“ zůstává vždy dostupný. Rozsah 1–10, výchozí 3.',
      retryMaxRetries: 'Počet pokusů',
      retryMaxRetriesHint: 'Kolikrát se po prvním pokusu automaticky zopakuje požadavek na model nebo jiný požadavek, pokud přechodná chyba dovoluje opakování. První pokus se nepočítá. 0 znamená jediný pokus bez automatického opakování. Spárované počítače a připojení platforem se znovu připojují bez omezení počtu, se stejným časováním. Rozsah {min}–{max}, výchozí {default}.',
      retryBaseDelayMs: 'Zpoždění',
      retryBaseDelayMsHint: 'Prodleva před prvním opakováním v sekundách, společná pro opakování požadavků na model i dalších požadavků a obnovu připojení. Další prodlevy se zdvojnásobují až do 60 s, bez náhodných odchylek. Minimální prodleva vyžadovaná serverem může být delší. Rozsah {min}–{max} s, výchozí {default}.',
      compactionRetries: 'Zopakování',
      compactionRetriesHint: 'Kolikrát se požadavek, který zkracuje kontext, pošle znovu po přechodné chybě nebo odmítnuté odpovědi, než se místo něj spustí vestavěné shrnutí. 0 znamená jediné odeslání bez opakování. Rozsah {min}–{max}, výchozí {default}.',
      elicitationTimeoutMs: 'Limit otázky',
      elicitationTimeoutMsHint: "Jak dlouho čeká odložená otázka AskUserQuestion na odpověď, než se vyřeší jako „bez odpovědi“. Po vypršení ji nelze zodpovědět v žádném chatu ani kanálu. Rozsah 0,5 min až 6 h, výchozí 6 h.",
      memoryRecallCount: 'Načtené',
      memoryRecallCountHint: "Kolik relevantních vzpomínek se vloží do kontextu každého tahu. Více = bohatší kontext, ale vyšší spotřeba tokenů. Rozsah 1–20, výchozí 10.",
      memoryRecallBytes: 'Limit načtení',
      memoryRecallBytesHint: "Přibližný rozpočet tokenů pro vzpomínky vložené na začátku tahu; vybavování přestane přidávat po jeho dosažení. Rozpočet se počítá v bajtech UTF-8, tedy ve stejné jednotce jako vybavování během práce, a zobrazení odhaduje tokeny přibližně jako 4 bajty na token. Rozsah ≈1 000–10 000 tokenů, výchozí ≈5 000.",
      memoryRecallWaitMs: 'Čekání',
      memoryRecallWaitMsHint: 'Jak dlouho nejvýše čeká první odpověď na vybavení vzpomínek na začátku tahu. Pokud hledání trvá déle, odpověď začne bez nich a nalezené vzpomínky se přidají při dalším kroku, případně při příští zprávě. Hodnota 0 nečeká vůbec. Rozsah {min}–{max} s, výchozí {default} s.',
      memoryLiveRecallPasses: 'Živá hledání',
      memoryLiveRecallPassesHint: 'Bezpečnostní limit počtu hledání ve vzpomínkách na pozadí během jednoho tahu, tedy vybavování během práce. Brání nekonečnému vytváření embeddingů při dlouhé smyčce nástrojů, která nenajde nic užitečného. Hodnota 0 vybavování během práce vypne. Rozsah 0–20, výchozí 10.',
      memoryLiveRecallCount: 'Dávka',
      memoryLiveRecallCountHint: "Nejvyšší počet vzpomínek, které smí jedno vyhledání na pozadí vložit najednou, tedy v jedné dávce vybavování během práce. Menší dávky drží každý krok soustředěný; hodnota 0 vybavování během práce vypne. Rozsah 0–10, výchozí 2.",
      memoryLiveRecallBytes: 'Rozpočet tahu',
      memoryLiveRecallBytesHint: "Celkový rozpočet v bajtech, který všechny průběžně vložené dávky sdílejí v jednom tahu. Hlasový hovor má navíc celkový rozpočet vzpomínek; zobrazení odhaduje tokeny přibližně jako 4 bajty na token. Rozsah ≈2 500–10 000 tokenů, výchozí ≈5 000.",
      voiceMemoryBytes: 'V hovoru',
      voiceMemoryBytesHint: 'Celkový rozpočet vzpomínek pro celý hlasový hovor, včetně úvodu a průběžného vybavování. Po předání práce asistentovi se neobnovuje. Hodnota 0 vzpomínky v hovoru vypne. Ukládá se v bajtech včetně rámování; zobrazení odhaduje 4 bajty na token. Rozsah ≈{min}–{max} tokenů, výchozí ≈{default}.',
      goalTurnBudget: 'Počet tahů',
      goalTurnBudgetHint: 'Výchozí počet samostatných tahů, které /goal provede, než se pozastaví a požádá vás o potvrzení. V režimu YOLO pokračuje. Rozsah {min}–{max}, výchozí {default}.',
      goalMaxTurns: 'Strop tahů',
      goalMaxTurnsHint: 'Nejvyšší povolený počet samostatných tahů cíle. I v režimu YOLO se zde smyčka pozastaví, aby cíl nespotřeboval neomezené množství tokenů. Rozsah {min}–{max}, výchozí {default}.',
      channelSessionCap: 'Živé relace',
      channelSessionCapHint: "Kolik živých kanálových konverzací (např. Discord vláken) zůstává v paměti, než se nejdéle nepoužitá zahodí (její historie zůstává v databázi). Rozsah 4–256, výchozí 32.",
      clamped: "Uloženo jako {value} — zadaná hodnota byla mimo povolený rozsah.",
      filterPlaceholder: 'Filtrovat limity',
      noMatches: 'Filtru neodpovídá žádný limit',
      groupToolOutput: 'Výstup nástrojů a výsledky',
      groupCompaction: 'Zkracování kontextu',
      groupRetries: 'Opakování a čekání',
      groupMemory: 'Paměť',
      groupGoals: 'Cíle',
      groupChannels: 'Kanály',
      groupSubagents: 'Sub-agenti',
      minuteUnit: "min",
      secondUnit: "s",
      tokenUnit: "tokenů",
    },
    runtime: {
      title: 'Běh',
      manage: "Upravit běhové prostředí",
      hint: 'Nastavení běhu: místní příkazový řádek, relevance vzpomínek, odložené nástroje, retence záznamů a kontrola spojení chatu. Každá hodnota se omezí na rozumný rozsah. Výchozí hodnoty ponechte, pokud nemáte důvod je měnit.',
      localShellTimeoutMs: 'Timeout shellu',
      localShellTimeoutMsHint: "Jak dlouho smí běžet příkaz spuštěný v CLI přes „!“, než bude ukončen. Běží na stroji, kde běží CLI, nikoli mezi nástroji asistenta. Rozsah 10–300 s, výchozí 30 s.",
      codeModeDefaultYieldTimeMs: 'Čekání exec',
      codeModeDefaultYieldTimeMsHint: 'Jak dlouho příkaz exec čeká bez vlastní pragmy, než vrátí průběžný výsledek. Příkaz wait má vlastní dobu čekání. Delší čekání šetří odpovědi modelu při dlouhých skriptech. Rozsah 10–600 s, výchozí 10 s.',
      codeModeMaxOutputTokens: 'Max. výstup',
      codeModeMaxOutputTokensHint: 'Režim code: pevný limit textu v každém výsledku příkazů exec a wait. Omezuje také hodnoty max_output_tokens a max_tokens, aby skript nezaplnil kontext. Rozsah 1 000–50 000 tokenů, výchozí 10 000.',
      memorySemanticFloorPerMille: 'Práh relevance',
      memorySemanticFloorPerMilleHint: "Práh relevance: minimální sémantická podobnost, při které se vzpomínka považuje za související s dotazem; cokoli pod ní se do vybavování ani do vyhledávání v paměti nedostane. Vyšší hodnota = přísnější výběr a méně vybavených vzpomínek. Skutečně související dvojice se obvykle pohybují nad 0,50. Rozsah {min}–{max}, výchozí {default}.",
      memoryDuplicatePerMille: 'Práh zápisu',
      memoryDuplicatePerMilleHint: 'Práh duplicity při ukládání: při této podobnosti automatické ukládání považuje novou vzpomínku za přeformulování již uložené a nahradí ji. Vzpomínku uloženou asistentem zachová a pouze upozorní na podobnost. Nižší hodnota omezuje duplicity, ale zvyšuje riziko přepsání jiné informace. Po změně embedding modelu nebo výrazném nárůstu počtu vzpomínek práh znovu ověřte. Rozsah 0,50–0,98, výchozí 0,93.',
      memoryParaphrasePerMille: 'Práh čtení',
      memoryParaphrasePerMilleHint: 'Práh duplicity při vybavování: při této podobnosti už další vzpomínka nepřidá novou informaci, a proto se do promptu nezařadí. Zabrání tomu, aby dva záznamy o stejné věci zabraly dvě z mála dostupných míst. Chyba zde pouze vynechá jeden výsledek, proto může být hodnota volnější než u ukládání. Rozsah 0,50–0,98, výchozí 0,70.',
      memoryImportanceWeightPerMille: 'Důležitost',
      memoryImportanceWeightPerMilleHint: "Váha důležitosti při vybavování: jakou částí se na pořadí vybavených vzpomínek podílí ručně nastavená důležitost. Zbytek po odečtení této a následující hodnoty připadá na shodu s dotazem, takže zvýšením obou snižujete vliv samotné otázky. Rozsah 0–30 %, výchozí 10 %.",
      memoryVitalityWeightPerMille: 'Váha vitality',
      memoryVitalityWeightPerMilleHint: "Váha vitality při vybavování: jakou částí se na pořadí podílí vitalita, tedy jak často a jak nedávno byla vzpomínka použita. Pozor: vitalita roste právě z vybavování, takže vysoká hodnota vytváří smyčku, ve které se stále dokola vybavuje totéž a zbytek paměti se ke slovu nedostane. Rozsah 0–30 %, výchozí 10 %.",
      memoryCuratorMaxOps: 'Zápisy paměti',
      memoryCuratorMaxOpsHint: "Kolik vzpomínek smí automatické ukládání po jedné výměně nejvýše přidat, upravit nebo smazat. Hodnota 0 automatické ukládání zcela vypne; ruční nástroje paměti fungují dál. Vyšší hodnota zaplňuje paměť rychleji, než ji stíháte kontrolovat. Rozsah 0–6, výchozí 2.",
      memoryDreamingMinHours: 'Po hodinách',
      memoryDreamingMinHoursHint: "Slučování vzpomínek: jak dlouho musí být paměť bez údržby, než může začít další automatické slučování vzpomínek. Slučování porovnává vzpomínky z více konverzací, takže kratší interval znamená víc průchodů a vyšší náklady. Rozsah {min}–{max} h, výchozí {default}.",
      memoryDreamingMinSessions: 'Po konverzaci',
      memoryDreamingMinSessionsHint: "Slučování vzpomínek: kolik dalších konverzací účtu musí od posledního průchodu obsahovat dokončenou výměnu, než může začít další automatické slučování. Jedna vytížená konverzace ještě neznamená, že si uložené vzpomínky odporují. Rozsah {min}–{max}, výchozí {default}.",
      skillReviewMaxOps: 'Zápisy skillů',
      skillReviewMaxOpsHint: "Kolik zápisů skillů (vytvoření nebo vylepšení skillu) smí jedna kontrola navrhnout. Omezuje navržené zápisy, ne volání modelu. Hodnota 0 učení skillů vypne pro všechny; ruční nástroje skillů fungují dál. Skilly, které člověk napsal nebo upravil, se nikdy nemění. Rozsah {min}–{max}, výchozí {default}.",
      skillReviewMaxCorrections: 'Opravy JSON',
      skillReviewMaxCorrectionsHint: "Další volání modelu v téže kontrole, pokud nelze přečíst JSON nebo má obálka návrhů nesprávný tvar. Neopakuje neplatné jednotlivé návrhy ani chyby poskytovatele. Hodnota 0 opravy vypne. Každé další volání se běžně účtuje. Rozsah {min}–{max}, výchozí {default}.",
      skillReviewEveryToolCalls: 'Kontrola po N',
      skillReviewEveryToolCallsHint: "Kontrola skillů po každých N voláních nástrojů. Počítá se napříč výměnami: jakmile dokončené způsobilé výměny účtu dosáhnou celkem tolika úspěšných volání nástrojů, zkontroluje se kontext dokončené konverzace. Nižší hodnota najde víc postupů a stojí víc volání modelu. Rozsah {min}–{max}, výchozí {default}.",
      skillReviewMinToolCalls: 'Nejméně volání',
      skillReviewMinToolCallsHint: "Nejméně volání nástrojů pro kontrolu skillů. Počítá se v rámci jedné dokončené výměny: výměna s menším počtem úspěšných volání nástrojů je na postup příliš jednoduchá, takže se nekontroluje ani nezapočítává do intervalu kontroly. Zvyšte ji, pokud se má učit jen z delších úkolů. Rozsah {min}–{max}, výchozí {default}.",
      eventRetentionDays: 'Log aktivity',
      eventRetentionDaysHint: "Jak dlouho se záznamy o aktivitě v časové ose uchovávají, než je hodinový úklid odstraní. Rozsah 1–365 dní, výchozí 30 dní.",
      providerRequestRetentionDays: 'Diagnostika',
      providerRequestRetentionDaysHint: 'Jak dlouho zůstávají přesná těla požadavků na poskytovatele dostupná pro diagnostiku problémů. Úklid vždy odstraní celou diagnostiku relace, nikdy jen část požadavku, a konverzaci ponechá beze změny. Rozsah 1–90 dní, výchozí 14 dní.',
      providerRequestRetentionMiB: 'Limit úložiště',
      providerRequestRetentionMiBHint: 'Celkový limit úložiště pro přesnou diagnostiku požadavků poskytovatelům v novém formátu. Po jeho překročení úklid odstraní nejstarší celé diagnostické relace. Konverzace i zachované požadavky zůstanou nedotčené. Starší záznamy se řídí výše uvedeným časovým limitem. Rozsah 64–16384 MiB, výchozí 1024 MiB.',
      originIpRetentionDays: 'IP adresy',
      originIpRetentionDaysHint: "Jak dlouho zůstane zaznamenaná IP adresa klienta čitelná v přehledu spotřeby podle původu, než ji hodinový úklid nahradí zástupnou hodnotou. Součty tokenů a nákladů zůstanou zachovány, zmizí pouze adresa. Samotný záznam se odstraní později, podle retence protokolu aktivity výše. Rozsah 1–365 dní, výchozí 30 dní.",
      streamSilenceLimitMs: 'Nečinnost',
      streamSilenceLimitMsHint: 'Jak dlouho může datový tok chatu na otevřené stránce zůstat bez zprávy nebo signálu démona, než prohlížeč označí spojení za nefunkční a připojí se znovu. Spodní hranice je záměrně 35 s: signál přichází každých 30 s, takže kratší limit by označil za nefunkční i zdravý nečinný tok. Rozsah 35–300 s, výchozí 75 s.',
      streamReviveSilenceLimitMs: 'Po probuzení',
      streamReviveSilenceLimitMsHint: 'Stejná nečinnost, měřená při probuzení stránky, například po odemknutí obrazovky nebo návratu na panel. Spící stránka nespouští časovače, takže předchozí kontrola neproběhla a spojení se posuzuje podle času, obvykle přísněji. Ze stejného důvodu platí spodní hranice 35 s jako u předchozího limitu. Rozsah 35–300 s, výchozí 45 s.',
      toastDurationMs: 'Oznámení',
      toastDurationMsHint: "Jak dlouho zůstane oznámení v pravém horním rohu webové aplikace na obrazovce, než samo zmizí. Najetím myší se odpočet pozastaví a zavřít ho lze vždy ručně, takže tato hodnota určuje jen to, jak dlouho čeká samo od sebe. Rozsah 2–15 s, výchozí 4,5 s.",
      stepContextEveryToolCalls: 'Připomínky',
      stepContextEveryToolCallsHint: 'Jak často se během tahu připomínky pluginů přidají. Běžné připomínky počítají volání nástrojů v jednom tahu. Seznam úkolů počítá zprávy asistenta od poslední změny úkolu i od poslední připomínky. Paralelní volání se počítají jako jedna zpráva asistenta a zprávy obsahující pouze přemýšlení se nepočítají. Uložené hodnoty zůstávají. Připomínky se přidávají do konverzace bez přepisování mezipaměti promptu. Vypnutí příslušného pluginu vypne jeho připomínky.',
      planModeExploreAgents: 'Průzkum',
      planModeExploreAgentsHint: "Agenti průzkumu: kolik průzkumných sub-agentů jen pro čtení nabídne režim Plánování nejvýše spustit souběžně, zatímco asistent zkoumá kód. Kolik jich skutečně spustí, rozhodne asistent, obvykle jednoho. Hodnota 0 nechá průzkum na asistentovi samotném. Platí jen tam, kde jsou sub-agenti k dispozici. Rozsah {min}–{max}, výchozí {default}.",
      planModePlanAgents: 'Návrh',
      planModePlanAgentsHint: "Agenti návrhu: kolik plánovacích sub-agentů jen pro čtení nabídne režim Plánování nejvýše spustit souběžně, aby změnu navrhli každý z jiného pohledu. Kolik jich skutečně spustí, rozhodne asistent a výsledný plán zapíše sám. Hodnota 0 nechá návrh jen na asistentovi. Platí jen tam, kde jsou sub-agenti k dispozici. Rozsah {min}–{max}, výchozí {default}.",
      subagentRunnerEnabled: 'V procesech',
      subagentRunnerEnabledHint: "Delegované tahy poběží ve vlastních procesech, takže systém rozloží práci mezi jádra a rozhraní zůstane svižné. Vypnuto je spouští uvnitř démona. Změna platí hned, bez restartu.",
      clamped: 'Uloženo jako {value}: zadaná hodnota byla mimo povolený rozsah.',
      filterPlaceholder: 'Filtrovat nastavení',
      noMatches: 'Filtru neodpovídá žádné nastavení',
      groupExecution: 'Spouštění příkazů',
      groupMemory: 'Paměť',
      groupSkills: 'Skilly',
      groupPlanning: 'Sub-agenti',
      groupChat: 'Chat a oznámení',
      groupRetention: 'Retence',
      secondUnit: "s",
      dayUnit: { one: "den", few: "dny", many: "dní" },
      tokenUnit: "tokenů",
    },
    toolLoading: {
      title: "Načítání nástrojů",
      manage: "Spravovat nástroje",
      hint: "Zvolte, které definice nástrojů zůstanou v promptu celé; ostatní se načtou na vyžádání. Změny platí pro nové a znovu vytvořené konverzace.",
      globalTitle: "Pravidla načítání nástrojů",
      globalHint: "Ponechte definice nástrojů mimo prompt, dokud nejsou potřeba. Místní ToolSearch prohledává názvy, popisy a parametry podle slov a při nastaveném embeddingovém modelu také podle významu. Existující konverzace si zachovají aktuální sadu nástrojů.",
      enabled: "Odložené načítání",
      enabledHint: "Vypnuto ponechá všechny definice nástrojů v promptu. Vaše volby pro nástroje zůstanou uložené a po opětovném zapnutí se znovu použijí.",
      threshold: "Práh",
      thresholdHint: "Nástroje bez výslovné volby, kromě základních nástrojů, se načtou na vyžádání, když jejich počet překročí tuto hodnotu. Rozsah 1–100, výchozí 10.",
      search: "Hledat nástroje",
      searchPlaceholder: "Hledat nástroje nebo pluginy",
      clearSearch: "Vymazat hledání",
      resultCount: {
        one: "{n} nástroj",
        few: "{n} nástroje",
        many: "{n} nástrojů",
      },
      default: "Výchozí",
      immediate: "Ihned",
      deferred: "Na vyžádání",
      groupMode: "Režim načítání pro {group}",
      toolMode: "Režim načítání pro {tool}",
      plugin: "Plugin",
      builtIn: "Vestavěné",
      empty: 'Hledání neodpovídá žádnému nástroji.',
      loadError: "Katalog nástrojů se nepodařilo načíst.",
      saveError: "Nastavení načítání nástrojů se nepodařilo uložit.",
      reason: {
        'global-disabled': "Globální nastavení je vypnuté",
        core: "Základní nástroj",
        'tool-override': "Volba nástroje",
        'source-override': "Volba pluginu",
        'source-default': "Výchozí volba",
        threshold: "Automatické pravidlo",
      },
    },
    retention: {
      title: 'Retence paměti',
      manage: 'Upravit uchovávání',
      hint: 'Jak dlouho si nepoužívaná vzpomínka zachová svou hodnotu, než se přesune do koše. Přesun lze vrátit. Slábne každá úroveň důležitosti, čím vyšší, tím pomaleji. Kolik vzpomínek se smí automaticky přesunout za 24 hodin, určuje denní limit.',
      enabled: 'Automaticky',
      enabledHint: "Hlavní vypínač. Vypnuto = žádná paměť se automaticky nepřesune do koše, bez ohledu na hodnoty níže. Ve výchozím stavu zapnuto.",
      graceDays: 'Ochranná lhůta',
      graceDaysHint: 'Nové vzpomínky se po tuto dobu neodstraňují, ani když se nepoužívají. Mohou se tak ještě vybavit. Rozsah 0–365 dní, výchozí hodnota 14.',
      vitalityFloor: 'Práh hodnoty',
      vitalityFloorHint: 'Aktivní vzpomínka, jejíž hodnota klesne pod tento práh, se přesune do koše. Přesun lze vrátit. Vyšší hodnota znamená důkladnější úklid. Rozsah 1–90, výchozí hodnota 10.',
      dailyDeletionLimit: 'Denní limit',
      dailyDeletionLimitHint: 'Kolik vzpomínek jednoho účtu se smí automaticky přesunout do koše za libovolných 24 hodin. Ostatní počkají na další úklid. Rozsah 1–200, výchozí hodnota 5.',
      groupCleanup: 'Úklid paměti',
      halfLifeSection: 'Poločas rozpadu',
      halfLifeRow: 'Důležitost {n}',
      halfLifeLevel: 'Doba do poklesu na polovinu, důležitost {n}',
      halfLifeHint: "Za kolik dní klesne hodnota nepoužívané vzpomínky na polovinu. Čím nižší hodnota, tím rychleji vzpomínka slábne a dosáhne prahu. Rozsah 0,1–365 dní, výchozí hodnoty 1/3/7/14/21/30/45/60/90/180.",
    },
    contextWindow: "Kontext",
    contextWindowHint: "Kolik konverzace a promptu model přijme.",
    modelLimits: "Limity modelu",
    modelLimitsEdit: "Upravit limity modelu",
    modelLimitOutOfBounds: "Hodnota musí být číslo od {min} do {max}.",
    modelOverrideInherited: "Zděděno",
    modelVision: "Obrázky",
    modelVisionHint: "Zda model umí číst tahy s obrázky.",
    modelVisionYes: "Ano",
    modelVisionNo: "Ne",
    modelPrice: "Cena / 1M tokenů (USD)",
    modelPriceInput: "Vstup",
    modelPriceOutput: "Výstup",
    modelPriceCacheRead: "Čtení cache",
    modelPriceCacheWrite: "Zápis cache",
    modelPriceHelp: "Cena od poskytovatele nebo z katalogu. Skutečně účtovaná cena, pokud ji poskytovatel vrátí, má přednost.",
    modelImageResize: "Zmenšení obrázků",
    modelImageWidth: "Max. šířka",
    modelImageWidthHint: "Největší šířka obrázku v pixelech.",
    modelImageHeight: "Max. výška",
    modelImageHeightHint: "Největší výška obrázku v pixelech.",
    modelImageBytes: "Max. objem",
    modelImageBytesHint: "Největší velikost obrázku po zakódování.",
    modelImageQuality: "Kvalita JPEG",
    modelImageQualityHint: "Kvalita JPEG při zmenšení obrázku.",
    modelImageResizeHelp: "Obrázky se zmenšují před uložením do konverzace. Již uložené obrázky se nemění.",
    maxOutputTokens: "Max. výstup",
    maxOutputTokensHint: "Kolik smí model napsat v jedné odpovědi. Nesmí přesáhnout kontext.",
    maxOutputTokensTooLarge: "Toto kontextové okno umožňuje nejvýše {max} výstupních tokenů.",
    modelsHintPicker: 'Načteno z adresy API. Kliknutím vyberte modely. Pokud žádný nevyberete, použijí se všechny.',
    pickModelsTitle: "Modely - {provider}",
    pickModelsHint: 'Vyberte, které modely z tohoto účtu může Chetty nabízet. Pokud žádný nevyberete, nabídnou se pouze textové modely. Ostatní druhy vyberte výslovně.',
    modelsUnavailable: 'Již není v katalogu',
    filterModelsByKind: 'Filtrovat modely podle druhu',
    modelOutputKinds: { text: 'Text', embeddings: 'Vektory', image: 'Obrázky', audio: 'Zvuk', video: 'Video', transcription: 'Přepis', speech: 'Řeč', decisions: 'Rozhodování', rerank: 'Přeřazení' },
    imageModelDefault: 'Výchozí model poskytovatele',
    addAccount: 'Přidat účet',
    account: 'Účet',
    noAccounts: 'Zatím není propojený žádný účet.',
    paused: 'Pozastaveno',
    pause: 'Pozastavit',
    resume: 'Obnovit',
    relogin: 'Přihlásit znovu',
    deleteAccount: 'Odstranit účet',
    deleteAccountConfirm: 'Odstranit účet {account} i jeho uložené nastavení? Přihlášení a předvolby se zruší; pozastavení je na rozdíl od toho zachová.',
    kindsError: 'Nepodařilo se načíst podporované služby. Zkuste to znovu, ať můžete přidat poskytovatele.',
    spendLimitAction: 'Limit útraty',
    accountCount: { one: '{n} účet', few: '{n} účty', many: '{n} účtů' },
    accountUsage: 'Čerpání účtů',
    settings: 'Nastavení',
    detailSections: 'Části nastavení poskytovatele',
    tabGeneral: 'Obecné',
    tabConnection: 'Připojení',
    tabAdvanced: 'Pokročilé',
    connected: 'Připojeno',
    accountActive: 'Aktivní',
    providerId: 'ID poskytovatele',
    providerIdHint: 'Identifikátor, na který odkazují modely, oprávnění a přiřazené role. Volí se jednou při vytvoření poskytovatele a nikdy se nemění.',
    advancedNone: 'Tento poskytovatel nemá žádná pokročilá nastavení.',
    routing: {
      title: 'Směrování',
      on: 'Směrování zapnuto',
      off: 'Směrování vypnuto',
      enabled: 'Automaticky vybírat účet',
      enabledHint: 'Vypnuto: každá konverzace používá výchozí účet a nic samo nepřeskakuje. Zapnuto: vybere se účet s nejnižším čerpáním, běžící konverzace si účet ponechá a vyčerpaný účet se nahradí jiným způsobilým účtem.',
      defaultAccount: 'Výchozí účet',
      defaultAccountHint: 'Účet, který používá vypnuté směrování, a jeden z kandidátů při zapnutém směrování. Prochází stejnými kontrolami jako každý jiný účet, takže pozastavený nebo nepovolený výchozí účet znamená nedostupného poskytovatele, ne obcházení volby.',
      noDefault: 'Bez výchozího účtu',
      idleRebalance: 'Přesouvat neaktivní konverzace',
      idleRebalanceHint: 'Přesunout nečinnou konverzaci na méně čerpaný účet. Měří se od posledního modelového požadavku; dlouho běžící nástroj ani stream nejsou nečinnost.',
      idleMinutes: 'Přesunout po nečinnosti',
      idleMinutesHint: 'Jak dlouho musí být konverzace nečinná, než se smí přesunout. Vyhodnocuje se při dalším požadavku, nikdy buzením během nečinnosti.',
      minGain: 'Minimální zlepšení',
      minGainHint: 'Nejmenší zlepšení v nejsilněji čerpaném kvótovém okně, které ospravedlní dobrovolný přesun, aby konverzace nepřeskakovaly kvůli drobnému kolísání.',
      minutes: '{n} min',
      hours: '{n} h',
      days: '{n} d',
      points: '{n} p. b.',
    },
    usageWeekly: 'týdně',
    usageWindow: 'okno',
    usageResets: 'Obnoví se {time}',
    usageResetsUtc: 'Free modely, denní limit, obnoví se {time} (00:00 UTC)',
    usageDaily: 'denně',
    usageMonthly: 'měsíčně',
    usageBalance: 'Zůstatek',
    usageBalanceHint: 'Zůstatek: {amount}',
    usageLimit: 'Limit',
    usageKeyLimitHint: 'Limit klíče {amount}',
    usageFreeModels: 'Free',
    usageSpend: 'Útrata',
    accounts: 'Propojené účty',
    providers: 'Poskytovatelé AI',
    addProvider: 'Přidat poskytovatele',
    removeProvider: 'Odebrat poskytovatele',
    removeProviderConfirm: 'Odebrat {provider} a jeho uložené nastavení? Akci nelze vrátit zpět.',
    providerLabel: 'Název',
    baseUrl: 'Adresa API',
    baseUrlHintOpenai: 'Včetně verze, např. https://ai.example.com/v1',
    baseUrlHintAnthropic: 'Nechte prázdné pro https://api.anthropic.com',
    probeFailed: 'Endpoint neodpověděl: {reason}',
    apiKey: 'API klíč',
    apiKeyKeepHint: 'Nechte prázdné, pokud chcete ponechat uložený klíč.',
    wireApi: 'Wire API',
    wireApiMessages: 'Anthropic',
    modelApi: 'API',
    modelApiReset: 'Resetovat API',
    modelApiParameterReset: 'Resetovat detekci parametru {parameter}',
    modelApiUnavailable: 'Stav API není dostupný.',
    temperature: 'Teplota',
    temperatureInvalid: 'Zadejte číslo od 0 do 2, nebo pole nechte prázdné, aby se použila výchozí hodnota modelu.',
    temperatureHint: 'Určuje, jak moc model mění formulace. Nižší hodnota znamená stálejší odpovědi, vyšší nápaditější. Nechte pole prázdné, aby se hodnota neposílala a model použil vlastní výchozí nastavení. Platí jen pro tohoto poskytovatele, protože některé modely jiné hodnoty nepřijímají. Kimi K3 a Claude Opus 4.7 a novější přijímají pouze výchozí hodnotu.',
    compatibility: {
      title: 'Kompatibilita',
      safeHint: 'Auto přebírá nastavení modelu. Hodnoty měňte pouze podle dokumentace poskytovatele.',
      safeDefaults: 'Automatické nastavení',
      customSummary: '{n} vlastní nastavení',
      on: 'Zapnuto',
      off: 'Vypnuto',
      temperatureOverride: 'Vlastní teplota',
      reset: 'Obnovit automatické nastavení',
      supportsLongCacheRetention: 'Cache 24 h',
      supportsLongCacheRetentionHint: 'Odesílá prompt_cache_retention a stabilní klíč mezipaměti. Nepodporované koncové body mohou odmítnout celý požadavek.',
      supportsDeveloperRole: 'Role developer',
      supportsDeveloperRoleHint: 'Pro instrukce modelu používá roli developer. U přeposílacích služeb, které přijímají jen klasickou roli system, nechte tuto volbu vypnutou.',
      supportsUsageInStreaming: 'Statistiky',
      supportsUsageInStreamingHint: 'Vyžádá součty tokenů v poslední události přenosu pomocí stream_options.',
      supportsStrictMode: 'Přísný režim',
      supportsStrictModeHint: 'Označí schémata funkcí jako přísná. Zapněte pouze tehdy, když koncový bod podporuje přísný režim OpenAI.',
      supportsStore: 'Ukládání',
      supportsStoreHint: 'Odesílá store: false. Některé kompatibilní koncové body toto pole specifické pro OpenAI neznají.',
      supportsReasoningEffort: 'Úvaha',
      supportsReasoningEffortHint: 'Pokud model podporuje uvažování, umožní odeslat zvolenou úroveň jako reasoning_effort.',
      maxTokensField: 'Limit tokenů',
      maxTokensFieldHint: 'Vyberte pole požadavku, kterým tento koncový bod omezuje délku odpovědi modelu.',
    },
    wireApiAuto: 'Auto',
    wireApiResponses: 'Responses',
    wireApiCompletions: 'Chat Completions',
    models: 'Modely',
    modelsHintAuto: 'Zadejte jedno ID modelu na řádek. Pokud seznam necháte prázdný, automaticky se načtou modely z /models tohoto koncového bodu.',
    modelCount: 'Počet modelů: {n}',
    modelsAuto: 'Modely se vypisují automaticky',
    keySet: 'Klíč je nastaven',
    hostedSearchUnsupported: 'Hledání nástrojů není podporováno',
    hostedSearchUnverified: 'Hledání nástrojů není ověřeno',
    codeModeTitle: 'Režim kódu',
    codeModeHelp: 'Model dostane jediný nástroj `exec`, jehož vstupem je JavaScript, a na ostatní nástroje sahá zevnitř skriptu. Navazující volání se tak vyřídí v jednom tahu místo jednoho kola modelu za každé. Každé volání dál prochází stejnými oprávněními a schvalováním jako přímé volání. Platí pro všechny modely tohoto poskytovatele. Nejlépe s ním pracují modely trénované na tento způsob práce (GPT-5.6 a novější); u jiného modelu si napřed porovnejte skutečnou úlohu, než ho necháte zapnutý.',
    responsesStatefulTitle: 'Stavové odpovědi',
    responsesStatefulHelp: 'Poskytovatel ukládá odpovědi na svých serverech a další požadavky navazují na předchozí. Může to zvýšit využití mezipaměti. Dobu uchování určuje poskytovatel.',
    hostedSearchTitle: 'Vestavěné hledání nástrojů',
    hostedSearchHelp: 'Poskytovatel hledá nástroje ve svém katalogu, takže se celý katalog neposílá v promptu. Když tuto volbu vypnete, použije se místní ToolSearch, který hledá podle slov v názvech, popisech a parametrech. Každé místní hledání zabere modelu jedno kolo navíc. Vestavěné hledání vyžaduje také zapnutou volbu „Odkládat externí nástroje“.',
    toolStatusError: 'Nepodařilo se načíst stav spouštění nástrojů u níže uvedených poskytovatelů.',
    testProvider: 'Otestovat připojení',
    testOk: 'Test proběhl úspěšně, model: {model}',
    testFailed: 'Test selhal',
    testUnreachable: 'Test se nepodařilo provést. Zkontrolujte, zda je služba Chetty dostupná, a zkuste to znovu.',
    saveError: 'Uložení poskytovatelů selhalo',
    providerSaveError: 'Poskytovatele se nepodařilo uložit. Zkontrolujte adresu koncového bodu a přihlašovací údaje a zkuste to znovu.',
    noProviders: 'Zatím nejsou nastaveni žádní poskytovatelé. Přidejte jednoho, aby jej mohl asistent používat.',
    notConnected: 'Nepřipojeno',
    connect: 'Připojit',
    disconnect: 'Odpojit',
    disconnectConfirm: 'Odpojit {provider}? Chetty přestane tento účet používat, dokud jej znovu nepřipojíte.',
    connectedToast: 'Účet připojen',
    connectFailed: 'Připojení účtu selhalo',
    connectError: 'Přihlášení se nepodařilo spustit.',
    connectUnknownAccount: 'Tento účet už v konfiguraci není. Zavřete dialog a přidejte účet znovu.',
    connectInProgress: 'Přihlášení tohoto účtu už probíhá. Dokončete nebo zavřete to probíhající a zkuste to znovu.',
    connectTitle: 'Připojit účet',
    connectStarting: 'Spouštění přihlášení…',
    connectUserCode: 'Zadejte tento kód',
    connectCodePlaceholder: 'Vložte kód nebo adresu přesměrování',
    connectMethod: 'Způsob přihlášení',
    connectBrowser: 'Prohlížeč',
    connectCopyCode: 'Přes kód',
    connectCopyCodeHint: 'Otevřete autorizační odkaz, přihlaste se a vložte kód zobrazený službou Claude.',
    connectSubmitError: 'Kód se nepodařilo odeslat. Zkuste to prosím znovu.',
    connectCodeError: 'Přihlášení se nezdařilo. Kód může být nesprávný nebo již neplatný. Zavřete toto okno a spusťte přihlášení znovu.',
    connectSubmitCode: 'Odeslat',
    connectWaiting: 'Čeká se na dokončení přihlášení…',
    keyAccount: {
      minimaxKeyHint: 'Vložte Subscription Key z mezinárodního účtu MiniMax (M Plan). Běžný klíč pro platbu podle spotřeby ani čínský účet nepoužívejte. Klíč se uloží na tomto serveru a již se nezobrazí.',
      connectTitle: 'Připojit {provider}',
      editTitle: 'Připojení: {provider}',
      editConnection: 'Upravit připojení',
      accountLabel: 'Název účtu',
      accountLabelHint: 'Pod tímto názvem je účet uvedený. Přejmenování nemění ID ani historii.',
      endpointHint: 'Adresa, kterou pro tuto službu určuje katalog.',
      keyHint: 'Vložte klíč API ze svého účtu {provider}. Je uložen na tomto serveru a již se nezobrazuje.',
      format: 'Formát API',
      formatHint: 'Auto vybírá API pro každý model. Výběrem formátu nastavíte API pro celý provider.',
    },
    types: {
      'openai': 'Kompatibilní s OpenAI',
      'anthropic': 'Anthropic API',
      'oauth-anthropic': 'Účet Claude',
      'oauth-openai-codex': 'Účet ChatGPT',
      'oauth-github-copilot': 'GitHub Copilot',
      'oauth-kimi': 'Účet Kimi',
      'oauth-xai': 'Účet xAI',
      'oauth-meta': 'Účet Meta',
      'oauth-opendesign': 'Účet Opendesign',
      'oauth-openrouter': 'Účet Openrouter',
    },
    stats: {
      button: "Statistiky",
      trackedSince: "Sledováno od {day}",
      refreshError: "Statistiky se nepodařilo obnovit. Zobrazené údaje mohou být zastaralé.",
      rangeHelp: "Dny se počítají v UTC a období vždy zahrnuje celé dny.",
      kpiTokens: "Tokeny",
      kpiCost: "Ceníková cena",
      kpiRequests: "Požadavky",
      kpiCache: "Zásahy cache",
      kpiCacheHelp: "Podíl vstupu, který poskytovatel přečetl ze své cache, místo aby jej dostal znovu.",
      costHelpSubscription: "Ceníková cena je částka, kterou by stejné tokeny stály podle cen za token, které Chetty pro tyto modely zná. Účty s předplatným se neúčtují za token, proto jde o ekvivalent, nikoli o skutečný poplatek. Model bez známé ceny se počítá jako $0.00.",
      costHelpComputed: "Ceníková cena se počítá z cen modelů, které Chetty zná, proto se může lišit od vaší faktury. Model bez známé ceny nebo model zdarma se počítá jako $0.00.",
      costHelpReported: "OpenRouter hlásí cenu každého požadavku, proto je tato částka tím, co si účtoval, nikoli odhadem.",
      costUnavailable: "Nedostupné",
      allowanceTitle: "Limit využití",
      allowanceNone: "Limit není hlášen",
      allowanceNoneHelp: "Tento poskytovatel nehlásí limit využití, který by Chetty mohl přečíst, proto se neukazuje žádné procento.",
      usersTitle: "Kdo to používal",
      usersHelp: "Podíl každé osoby na tokenech, které Chetty v daném období poslal tomuto poskytovateli, připsaný tomu, kdo tah zadal. Nejde o podíl na limitu poskytovatele.",
      usersOthers: "Ostatní",
      modelsTitle: "Modely",
      trendTitle: "Po dnech",
      chartTokens: "Tokeny",
      chartCost: "Ceníková cena",
      chartsAriaLabel: "Tokeny a ceníková cena po dnech",
      breakdownTitle: "Rozpis tokenů",
      tokensIn: "Vstup",
      tokensOut: "Výstup",
      cacheRead: "Čtení z cache",
      cacheWrite: "Zápis do cache",
      reasoning: "Uvažování",
      breakdownHelp: "Tokeny uvažování jsou již započteny ve výstupu.",
      empty: "V tomto období žádné využití",
      emptyNever: "Pro tohoto poskytovatele zatím nic nebylo zaznamenáno",
      loadError: "Statistiky se nepodařilo načíst",
      subscriptionTitle: "Předplatné",
      subscriptionUnavailable: "Aktuální okna se právě nepodařilo načíst.",
      quotaTitle: "Podíl předplatného využitý za den",
      quotaHelp: "Poskytovatelé hlásí jen aktuální okno, proto si ho Chetty průběžně zapisuje: dřívější dny nelze zpětně získat, využití před prvním měřením a mezi posledním měřením a obnovením okna se nezaznamená a za dny, kdy Chetty neběžel, údaj chybí. První zaznamenaný den se proto počítá jen od svého prvního měření. Údaje platí pro celý účet, včetně použití mimo Chettyho.",
      quotaRecordingStarted: "Zaznamenávání předplatného právě začalo. Graf se bude v příštích dnech postupně plnit.",
      quotaEmptyRange: "V tomto období nebylo nic zaznamenáno. Zaznamenávání začalo {day}.",
      quotaGapNote: "V některé dny chyběly hodiny měření, protože Chetty neběžel nebo poskytovatel nebyl dostupný. Využití za tu dobu je připsáno ke dni, kdy bylo poprvé vidět.",
      quotaSince: "Zaznamenáváno od {day}",
      quotaTotal: "Za toto období",
      quotaTotalHelp: "Součet dnů v grafu. 100 % je jedno celé okno ({window}), takže za delší období může hodnota přesáhnout 100 %.",
      quotaBusiest: "Nejvytíženější den",
      quotaBusiestGap: "může zahrnovat i dřívější dny",
      quotaSeriesConsumed: "Využito za den (okno: {window})",
      quotaChartAria: "Podíl předplatného využitý za den",
      tokensSectionTitle: "Tokeny přes Chettyho",
      tokensSectionHelp: "Tokeny, které Chetty poslal tomuto poskytovateli. Jde o vlastní počítání Chettyho a není to totéž jako procenta předplatného výše, která platí pro celý účet.",
    },
  },
  plugins: {
    bundled: 'Vestavěný',
    user: 'Uživatelský',
    tools: 'Nástroje',
    skills: 'Skilly',
    platforms: 'Platformy',
    enable: 'Zapnout',
    disable: 'Vypnout',
    pendingToast: 'Změna je uložená. Projeví se při příštím spuštění démona.',
    restartingToast: 'Změna je uložená. Chetty se teď restartuje, aby ji načetla.',
    grantsTitle: 'Zapnout plugin {name}?',
    grantsIntro: 'Tento plugin žádá o přístup, který přetrvá i po skončení odpovědi. Zapnutím mu udělíte:',
    grantsConfirm: 'Zapnout a udělit',
    grantTools: 'Měnit nástroje dostupné agentovi včetně nahrazení stávajících',
    grantControl: 'Používat rozhraní pluginu {control}',
    grantToolAuthority: 'Používat profil oprávnění {authority} pro nástroje odpovídající vzoru {pattern}',
    grantManagedProjectRead: 'Číst soubory spravovaných projektů',
    grantOwnOutputRead: 'Číst uložené výstupy vlastní konverzace',
    grantProjectFileRead: 'Číst soubory projektů přes rozhraní pro binární data',
    grantProjectFileWrite: 'Zapisovat soubory projektů přes rozhraní pro binární data',
    grantProjectTransfer: 'Přenášet soubory mezi přístupnými projekty',
    grantSkillLoad: 'Načítat skilly pomocí nástrojů odpovídajících vzoru {pattern}',
    grantServerAutomation: 'Spouštět automatizované úlohy na serveru',
    grantTerminalTimeouts: 'Číst nastavení časových limitů terminálu',
    grantAgentDirectory: 'Číst adresář definic sub-agentů',
    grantWorkflowEngine: 'Používat workflow engine',
    authorityGranted: 'Uděleno',
    authorityMissing: 'Chybí souhlas',
    grantPrompt: 'Nahradit systémový prompt a promptové šablony',
    grantEvents: 'Zapisovat do protokolu aktivity',
    grantWorkflowDag: 'Měnit běžící workflow sub-agentů',
    grantConversations: 'Zakládat konverzace v přidělených účtech a spouštět v nich agenta na náklady účtu',
    dependencyHelp: 'Funguje jen se zapnutými doplňky {plugins}.',
    dependencyOn: 'Tento doplněk vyžaduje, abyste nejprve zapnuli doplněk {plugin}, který poskytuje {control}.',
    dependencyMissing: 'Tento doplněk vyžaduje jiný doplněk poskytující {control}, žádný však není nainstalován.',
    dependencyInUse: 'Tento doplněk poskytuje {control}, který doplněk {plugin} stále potřebuje. Nejprve vypněte {plugin}.',
    toggleError: 'Změna pluginu selhala',
    updateInProgress: 'Probíhá aktualizace. Před změnou tohoto pluginu prosím vyčkejte na její dokončení.',
    empty: 'Žádné pluginy nenalezeny',
    searchPlaceholder: 'Hledat pluginy…',
    categoryFilter: 'Kategorie',
    catAll: 'Vše',
    catPlatforms: 'Platformy',
    catTools: 'Nástroje',
    catMemory: 'Paměť',
    catAutomation: 'Automatizace',
    catUi: 'Rozhraní',
    catSecurity: 'Zabezpečení',
    catDevelopment: 'Vývoj',
    healthOk: 'V pořádku',
    healthError: 'Chyba',
    noMatches: 'Žádné odpovídající pluginy',
    noMatchesHint: 'Zkuste jiný hledaný výraz nebo kategorii.',
    install: 'Instalovat',
    installing: 'Instaluje se…',
    installError: 'Instalace pluginu selhala',
    installQueued: 'Instalace pluginu začala. Chetty se za chvíli krátce restartuje a plugin pak bude připravený.',
    updateQueued: 'Aktualizace pluginu začala. Chetty se za chvíli krátce restartuje a pak poběží nová verze.',
    updateAllQueued: 'Aktualizace pluginů začala. Chetty se za chvíli krátce restartuje a pak poběží nové verze.',
    repairQueued: 'Oprava pluginu začala. Chetty se za chvíli krátce restartuje a plugin pak bude zase v pořádku.',
    uninstall: 'Odinstalovat',
    uninstallConfirm: 'Opravdu odinstalovat plugin „{name}“? Jeho soubory i uložená data budou odstraněny.',
    uninstallError: 'Odinstalování pluginu selhalo',
    remove: 'Odebrat',
    removeConfirm: 'Odebrat vestavěný plugin „{name}“? Zmizí ze seznamu a přestane se načítat. Soubory zůstanou a plugin můžete kdykoli obnovit v části Dostupné pluginy.',
    removedError: 'Odebrání pluginu selhalo',
    restore: 'Obnovit',
    restoreError: 'Obnovení pluginu selhalo',
    removedSection: 'Odebrané vestavěné pluginy',
    updateAvailable: 'K dispozici je novější verze',
    updateError: 'Aktualizace pluginu selhala',
    updateAll: 'Aktualizovat všechny pluginy',
    updateAllConfirm: 'Aktualizovat všechny pluginy s dostupnou novější verzí? Aktualizace proběhne společně a restartuje Chettyho. Vypnuté pluginy zůstanou vypnuté.',
    marketplaceEmpty: 'Zatím nejsou dostupné žádné další pluginy',
    marketplaceError: 'Katalog pluginů se nepodařilo načíst',
    detail: 'Detail',
  },
  pluginDetail: {
    workspaceNav: 'Pracovní prostor pluginu',
    tabSetup: 'Propojení',
    tabBehavior: 'Chování',
    tabCapabilities: 'Schopnosti',
    tabActivity: 'Aktivita',
    tabAdvanced: 'Pokročilé',
    setupChecklist: 'Kontrola propojení',
    setupChecklistHint: 'Povinné údaje, které plugin potřebuje ke spuštění.',
    setupMissing: 'Chybí {n}',
    setupNoRequired: 'Tento plugin nemá žádné povinné kroky propojení.',
    statusTitle: 'Stav',
    statusHint: 'Co plugin potřebuje k fungování. Kontrola probíhá průběžně.',
    statusOk: 'Vše funguje',
    statusProblem: 'Vyžaduje pozornost: {n}',
    statusCopy: 'Kopírovat',
    overviewVersion: 'Verze',
    overviewSource: 'Zdroj',
    statusDisabled: 'Vypnuto',
    config: 'Konfigurace',
    behaviorEmpty: 'Tento plugin nemá žádná další nastavení chování.',
    configEmpty: 'Tento plugin nemá žádná nastavení.',
    tools: 'Nástroje',
    toolsHint: 'Nástroje, které tento plugin přidává asistentovi.',
    toolsEmpty: 'Tento plugin neregistruje žádné nástroje.',
    skills: 'Skilly',
    platforms: 'Platformy',
    hooks: 'Háky',
    hooksHint: 'Háky, které tento plugin registruje při běhu asistenta.',
    hooksEmpty: 'Tento plugin neregistruje žádné háky.',
    hookExecutions: 'Nedávná spuštění',
    hookExecutionsHint: 'Každé spuštění háku tohoto pluginu, jeho výsledek a doba trvání.',
    outcomeOk: 'Aplikováno',
    outcomeThrew: 'Selhalo',
    outcomeTimeout: 'Vypršel čas',
    outcomeRejected: 'Odmítnuto',
    permissions: 'Oprávnění',
    capabilities: 'Deklarované schopnosti',
    capabilitiesDeny: 'Ve výchozím stavu zakázáno: plugin smí jen to, co zde deklaruje. Chybějící schopnost znamená, že danou akci nemůže provést.',
    capMutates: 'Smí měnit',
    capNetwork: 'Síť',
    capNetworkOn: 'Odchozí přístup',
    capReads: 'Čte',
    capAuthorities: 'Souhlasy s pravomocemi',
    permissionsHint: 'Co tento plugin potřebuje a jak je citlivý.',
    requiresEnv: 'Vyžadované proměnné prostředí',
    requiresConfig: 'Vyžadovaná konfigurace',
    requiresNone: 'Tento plugin nevyžaduje žádné zvláštní prostředí ani konfiguraci.',
    riskLow: 'Nízké riziko',
    riskMedium: 'Střední riziko',
    riskHigh: 'Vysoké riziko',
    data: 'Uložená data',
    dataPath: 'Umístění',
    dataSize: 'Velikost',
    dataFiles: '{n} souborů',
    dataPartial: 'Měření je neúplné: procházení narazilo na limit, uvedené součty jsou proto nejnižší možné.',
    dataUnreadable: '{n} položek nešlo změřit. Disk prostředí patří jeho stroji a tato služba do něj nevidí.',
    dataEmpty: 'Tento plugin zatím neuložil žádná data.',
    dataClear: 'Vymazat data',
    dataClearConfirm: 'Smazat všechna uložená data tohoto pluginu? Tuto akci nelze vzít zpět.',
    dataClearError: 'Vymazání dat pluginu selhalo',
    logs: 'Logy',
    logsHint: 'Nejnovější řádky logu z tohoto pluginu.',
    logsEmpty: 'Žádné nedávné záznamy v logu.',
  },
  agents: {
    tokens: 'Tokeny',
    steeredInto: 'během práce dostal nové pokyny',
    steerQueued: 'Čeká na převzetí',
    steerDelivered: 'Pokyn doručen',
    steerDropped: 'Pokyn nedoručen',
  },
  brainChat: {
    skillLabel: 'Skill',
    archiveWaiting: 'Čeká se na odpověď. Před zavřením ji zadejte.',
    archiveFailed: 'Konverzaci se nepodařilo archivovat.',
    archiveConflict: 'Konverzace se změnila. Před dalším pokusem ji načtěte znovu.',
    compacting: 'Probíhá shrnutí konverzace…',
    ux: {
      recalledInputsLabel: 'Vrácené zprávy',
      recalledInputsCount: 'Čeká na obnovení: {count}',
      restoreRecalledInput: 'Obnovit zprávu',
      messageCopy: "Kopírovat zprávu",
      codeCopy: "Kopírovat kód",
      regenerate: "Vygenerovat znovu",
      editResend: "Upravit a znovu odeslat",
      editMessage: "Upravit zprávu",
      reissueConfirm: "Znovu spustit tuto výměnu?",
      reissueWarning: "Původní odpověď bude nahrazena. Již provedené akce se nevrátí zpět a nástroje se mohou spustit znovu.",
      reissueUnconfirmed: "Výsledek odeslání není potvrzen. Nejprve obnovte stav konverzace.",
      attachmentsKept: "Původní přílohy budou zachovány.",
      approvalConversation: "Povolit v této konverzaci",
      approvalConversationHint: "Povolit „{pattern}“ pro tento účet a prostředí v této konverzaci, i po restartu.",
      approvalInstead: "Ne, místo toho…",
      approvalInstruction: "Co má model udělat místo toho?",
      approvalSubmitInstead: "Odmítnout a předat pokyn",
      approvalFeedbackRequired: "Zadejte pokyn o délce 1 až 2000 znaků.",
      approvalConversationOutcome: "Povoleno v této konverzaci",
      approvalFeedbackOutcome: "Odmítnuto s pokynem",
      revokeConsents: "Zrušit souhlasy",
      revokeConsentsHint: "Zruší se pouze vaše uložené souhlasy v této konverzaci.",
      consentsRevoked: "Souhlasy pro tuto konverzaci byly zrušeny.",
      deliveryNow: "Předat nyní",
      deliveryChanged: "Předáno, Chetty si zprávu přečte hned v dalším kroku.",
      deliveryUnavailable: "Tuto zprávu již nelze předat nyní. Stav fronty byl obnoven.",
      searchTitle: "Hledat v konverzaci",
      searchPlaceholder: "Hledaný text (alespoň 2 znaky)…",
      searchEmpty: "Žádné odpovídající zprávy.",
      searchFailed: "Zprávy se nepodařilo vyhledat.",
      searchNext: "Další shoda",
      searchPrevious: "Předchozí shoda",
      searchMore: "Načíst další shody",
      searchCount: "Načtené shody: {count}",
      searchLatest: "Zpět k nejnovějším",
      shortcutsTitle: "Klávesové zkratky",
      shortcutsCommands: "Příkazy",
      shortcutsScope: "Zkratky platí pouze při práci v chatu. Mimo chat se klávesy prohlížeče nemění.",
      shortcutChange: "Změnit",
      shortcutCapture: "Stiskněte klávesy…",
      shortcutUnbound: "Nenastaveno",
      shortcutInvalid: "Neplatný zápis zkratky.",
      shortcutConflict: "Tuto zkratku používá akce „{action}“.",
      shortcutReserved: "Tuto kombinaci nelze použít ve webovém chatu.",
      shortcutSaveError: "Zkratky se nepodařilo uložit.",
      replyAction: "Odpovědět",
      cancelReply: "Zrušit odpověď",
      typingOne: "{name} píše…",
      typingMany: "Píší: {names}",
      answeringUser: "Odpovídá uživateli: {name}",
      unreadDivider: "Nové zprávy",
      jumpToUnread: "Přejít na nové zprávy",
      muteConversation: "Ztlumit oznámení",
      unmuteConversation: "Zapnout oznámení",
      conversationMuted: "Oznámení konverzace jsou ztlumena.",
      conversationUnmuted: "Oznámení konverzace jsou zapnuta.",
      conversationMuteFailed: "Nastavení oznámení se nepodařilo uložit.",
      globalReplyMuteHint: "Oznámení odpovědí jsou stále ztlumena v nastavení účtu.",
      shortcutActions: {
        leader: "Předpona zkratek",
        mode_toggle: "Přepnout režim",
        reasoning_cycle: "Úroveň přemýšlení",
        stash: "Odložit zprávu",
        rewind: "Vrátit zprávu",
        rename: "Přejmenovat konverzaci",
        subagent_cycle: "Přepnout agenta",
        subagent_stop: "Zastavit agenta",
        telemetry_toggle: "Statistiky",
        queue_steer: "Odeslat z fronty",
        queue_remove: "Odebrat z fronty",
        stop: "Zastavit běh",
        reconnect: "Obnovit připojení",
        help: "Otevřít nápovědu",
        theme_picker: "Změnit vzhled",
        model_picker: "Vybrat model",
        sessions_picker: "Vybrat konverzaci",
        search: "Hledat v konverzaci",
      },
    },
    promptHistoryError: 'Historii promptů se nepodařilo načíst nebo uložit v tomto prohlížeči.',
    leaderPending: 'Ctrl+X: čeká na další klávesu',
    suggestionHint: 'Tab nebo mezerník vloží návrh; Enter odešle zprávu.',
    viewLabel: 'Interaktivní zobrazení',
    viewLoading: 'Načítání zobrazení…',
    viewError: 'Odpověď se nepodařilo potvrdit. Zkuste volbu znovu.',
    historyLoadError: 'Konverzace se nepodařilo načíst.',
    loadingOlder: 'Načítání starších zpráv',
    olderLoadError: 'Starší zprávy se nepodařilo načíst.',
    attach: 'Přiložit soubor',
    attachRemove: 'Odebrat přílohu',
    attachmentAlt: 'Přiložený obrázek',
    attachmentOpen: 'Otevřít v plné velikosti',
    attachmentGone: 'Obrázek už není k dispozici',
    imageAttached: 'Obrázek v konverzaci',
    messageBlocks: 'Položky zmíněné v odpovědi',
    fileDownload: 'Stáhnout',
    attachFailed: 'Soubor se nepodařilo nahrát a nebyl přiložen.',
    uploadProgress: 'Nahrávání souboru {name}',
    uploadPercent: '{percent} %',
    uploadCancel: 'Zrušit nahrávání souboru {name}',
    attachedFile: 'přiložený soubor',
    attachOnly: '(příloha)',
    deleteChat: 'Smazat konverzaci',
    deleteChatConfirmTitle: 'Smazat tuto konverzaci?',
    deleteChatConfirmDescription: 'Tímto trvale smažete „{title}“ a celou historii zpráv. Pokud je konverzace právě otevřená, chat se přepne na jinou. Akci nelze vrátit zpět.',
    deleteChatError: 'Konverzaci se nepodařilo smazat. Nic se nezměnilo.',
    bulkDelete: 'Smazat vybrané',
    bulkDeleteConfirmTitle: 'Smazat vybrané konverzace?',
    bulkDeleteConfirmBody: 'Tímto trvale smažete {n} konverzací a jejich historii zpráv. Pokud je mezi nimi právě otevřená konverzace, chat se přepne na jinou. Akci nelze vrátit zpět.',
    bulkDeletePartial: 'Smazáno konverzací: {done}, {failed} se nepodařilo smazat.',
    bulkDeleteFailed: 'Vybrané konverzace se nepodařilo smazat. Nic se nezměnilo.',
    selectedCount: 'Vybráno: {n}',
    clearSelection: 'Zrušit výběr',
    selectRow: 'Vybrat konverzaci: {title}',
    context: 'kontext',
    newChat: 'Nová konverzace',
    searchPlaceholder: 'Hledat v konverzacích…',
    searchError: 'Hledání se nepodařilo dokončit',
    searchOpenError: 'Tuto konverzaci nelze otevřít',
    newChatError: 'Novou konverzaci se nepodařilo založit.',
    abortError: 'Odpověď se nepodařilo zastavit.',
    conversationBusy: 'Konverzace právě čeká na dokončení jiné akce. Zkuste zprávu odeslat později.',
    sendError: 'Zprávu se nepodařilo odeslat. Koncept zůstal v editoru.',
    sendErrorPreviousConversation: 'Zpráva do předchozí konverzace nebyla odeslána. Její text čeká v konceptu té konverzace.',
    freshConversation: 'Předchozí konverzace nebyla aktivní. Pokračujeme v nové.',
    readOnly: 'Tato konverzace probíhá na jiné platformě nebo v úloze. Zde ji můžete jen sledovat.',
    readOnlyExit: 'Zpět do chatu',
    childFocusCommandDisabled: 'Tento příkaz patří do hlavní konverzace. Nejprve opusťte zobrazení sub-agenta.',
    untitled: 'Bez názvu',
    placeholder: 'Napište zprávu, nebo zadejte / pro příkazy',
    placeholderShort: 'Zpráva…',
    send: 'Odeslat',
    stop: 'Zastavit',
    rewindHelp: 'F9: zastavit odpověď, potom odebírat poslední zprávy',
    rewindEmpty: 'Žádná další zpráva k odebrání.',
    rewindActionsRemain: 'Historie konverzace byla odebrána. Již provedené akce zůstávají platné.',
    rewindFailed: 'Historii se nepodařilo změnit.',
    clearCompacting: 'Kontext konverzace se právě zkracuje. Zkuste to znovu, až to skončí.',
    clearSettling: 'V konverzaci probíhá práce. Zastavte ji nebo počkejte na dokončení.',
    clearQueued: 'Ve frontě čeká zpráva. Odeberte ji nebo počkejte na odeslání.',
    clearPendingQuestion: 'Nejprve odpovězte na čekající otázku nebo ji zavřete.',
    clearDelegationRunning: 'Běží podřízený agent nebo workflow. Zastavte jej nebo počkejte na dokončení.',
    clearProcessRunning: 'Běží proces na pozadí. Zastavte jej v panelu procesů.',
    clearActiveGoal: 'Nejprve pozastavte nebo zrušte aktivní cíl.',
    clearResultPending: 'Čeká se na doručení výsledku podřízené práce. Zkuste to znovu po jeho doručení.',
    rewindCompacting: 'Kontext konverzace se právě zkracuje. Zkuste to znovu, až to skončí.',
    rewindSettling: 'Odpověď se ještě ukládá. Zkuste to za chvíli znovu.',
    rewindQueued: 'Ve frontě čeká zpráva. Počkejte, až se odešle, a zkuste to znovu.',
    rewindPendingQuestion: 'Nejprve odpovězte na čekající otázku, nebo ji zavřete.',
    rewindActiveGoal: 'Nejprve pozastavte nebo zrušte aktivní cíl.',
    rewindUnsettledTurn: 'Poslední tah ještě neskončil. Zkuste to za chvíli znovu.',
    rewindSubagentRunning: 'Tato odpověď spustila sub-agenta, který stále běží. Nejprve ho zastavte, nebo počkejte, až doběhne.',
    rewindWorkflowRunning: 'Tato odpověď spustila workflow, které stále běží. Nejprve ho zastavte, nebo počkejte, až doběhne.',
    rewindResultPending: 'Výsledek práce spuštěné touto odpovědí ještě nebyl doručen. Zkuste to znovu, až dorazí.',
    modelSwitchQueued: 'Po aktuální odpovědi se model přepne.',
    modelPicker: 'Model',
    modelPickerLoading: 'Načítání modelů…',
    modelPickerEmpty: 'Žádný dostupný model',
    modelPickerError: 'Modely se nepodařilo načíst',
    modelPickerRetry: 'Zkusit znovu',
    projectPickerFailed: 'Cíl spuštění se nepodařilo změnit',
    projectPickerHost: 'Bez projektu',
    newConversationProject: {
      title: 'Kde má tato konverzace běžet?',
      empty: 'Pro tento účet není dostupný žádný projekt.',
    },
    modelActive: 'Aktivní model',
    modelReasoning: 'Náročnost uvažování',
    askWaiting: 'Chetty čeká na vaše odpovědi',
    approvalWaiting: 'Je potřeba schválení',
    approvalRunCommand: 'Spustit tento příkaz?',
    approvalRunTool: 'Povolit spuštění nástroje „{tool}“?',
    approvalOnce: 'Povolit jednou',
    approvalAlways: 'Povolit vždy',
    approvalAlwaysHint: 'vždy povolit „{pattern}“',
    approvalDeny: 'Zamítnout',
    approvalWarningNote: 'Upozornění: tento příkaz {note}.',
    approvalWarnings: {
      gitResetHard: 'může zahodit necommitnuté změny',
      gitForcePush: 'může přepsat historii vzdáleného repozitáře',
      gitCleanForce: 'může trvale smazat nesledované soubory',
      gitDiscardWorktree: 'může zahodit změny v pracovním stromu',
      gitStashDrop: 'může trvale odstranit odložené změny',
      gitBranchForceDelete: 'může vynuceně smazat větev',
      gitNoVerify: 'může přeskočit kontrolní hooky',
      gitCommitAmend: 'může přepsat poslední commit',
      rmRecursiveForce: 'může násilně odstranit soubory včetně podsložek',
      rmRecursive: 'může odstranit soubory včetně podsložek',
      rmForce: 'může vynuceně odstranit soubory',
      sqlDropTable: 'může odstranit nebo vyprázdnit databázové objekty',
      sqlDeleteAll: 'může smazat všechny řádky databázové tabulky',
      kubectlDelete: 'může smazat prostředky Kubernetes',
      terraformDestroy: 'může zničit infrastrukturu spravovanou Terraformem',
      mkfs: 'může smazat souborový systém',
      deviceOverwrite: 'může přepsat surové diskové zařízení',
      chmodWorldWritable: 'může zpřístupnit soubory k zápisu komukoli',
      killEveryProcess: 'může ukončit všechny procesy tohoto účtu',
      forkBomb: 'může vyčerpat tabulku procesů',
    },
    askOther: 'Vlastní odpověď',
    askOtherPlaceholder: 'Napište vlastní odpověď',
    askSubmit: 'Odeslat odpověď',
    askRecommended: 'Doporučeno',
    askMulti: 'vyberte jednu nebo více',
    askPreview: 'Náhled',
    askDetailBody: 'Celý text',
    askProgress: '{answered} z {total} zodpovězeno',
    askSending: 'Odesílám…',
    askRetry: 'Zkusit znovu',
    askReadOnly: 'Na tuto otázku lze odpovědět jen v hlavní konverzaci.',
    askExpired: 'Otázka už není dostupná k zodpovězení.',
    askExpiredRecord: 'Otázka vypršela bez odpovědi.',
    askAllowedOnce: 'Povoleno jednou',
    askAllowedAlways: 'Povoleno vždy',
    askDenied: 'Zamítnuto',
    askQuestionOf: 'Otázka {current} z {total}',
    askError: 'Odpověď se nepodařilo odeslat. Zkuste to znovu.',
    toolOutputExpand: 'Zobrazit celý výstup',
    toolOutputCollapse: 'Zobrazit méně',
    diffLabel: 'Rozdíl změn',
    diffExpand: 'Zobrazit zbývajících {n} řádků rozdílu',
    diffCollapse: 'Zobrazit méně řádků rozdílu',
    diffRowAdded: 'přidaný řádek',
    diffRowRemoved: 'odebraný řádek',
    cardFallback: 'Karta',
    eventModel: 'model',
    eventWireApi: 'Model nyní komunikuje přes {api}.',
    // Účet vlastní konverzace: který účet ji obsluhuje a proč se přesunula. Daemon rozsah hlídá sám —
    // cizí nebo odejmutý předchozí účet dorazí bez jména — takže tady jiný pojmenovat nelze.
    accountMoved: 'přesunuto: {reason}',
    accountMovedFrom: 'z účtu {account}: {reason}',
    accountChangeReason: {
      paused: 'účet je pozastavený',
      'not-authorized': 'účet na tuto konverzaci nemá oprávnění',
      'no-credential': 'účet nemá přihlášení',
      'model-unavailable': 'model tam není dostupný',
      'quota-limited': 'kvóta je vyčerpaná',
      'spend-limit': 'účet je omezen měsíčním limitem útraty',
      'already-attempted': 'už byl použitý',
      regenerated: 'přihlášení bylo obnovené',
      reconfigured: 'účet byl překonfigurovaný',
      rebalanced: 'zátěž se vyvážila',
    },
    eventMode: 'režim',
    eventMembershipJoined: '{name} je nově v konverzaci',
    eventMembershipLeft: '{name} už není v konverzaci',
    eventMembershipRemoved: '{name} už není v konverzaci · odebrání: {actor}',
    eventMembershipRemovedAnonymous: '{name} už není v konverzaci',
    eventPlanDismissed: 'Plán odmítnut',
    eventPlanHeldComputer: 'Plán zůstal na počítači {name} a v tomto kroku není k dispozici. Přesune se sem, jakmile bude možné přenos dokončit.',
    eventPlanHeldProject: 'Plán zůstal v projektu {name} a v tomto kroku není k dispozici. Přesune se sem, jakmile bude možné přenos dokončit.',
    eventPlanHeldServer: 'Plán zůstal na serveru Chetty a v tomto kroku není k dispozici. Přesune se sem, jakmile bude možné přenos dokončit.',
    eventRenamed: 'přejmenováno',
    eventCwd: 'cwd',
    eventOfflineTarget: 'Počítač {computer} je offline. Konverzace nyní běží na serveru: {project}.',
    eventSubagentDone: 'sub-agent dokončil práci',
    eventSubagentFailed: 'sub-agent selhal',
    eventWorkflowDone: 'workflow dokončen',
    eventWorkflowFailed: 'workflow selhal',
    eventWorkflowStopped: 'workflow zastaven',
    eventDreaming: { one: 'Slučování pamětí vylepšilo {n} vzpomínku', few: 'Slučování pamětí vylepšilo {n} vzpomínky', many: 'Slučování pamětí vylepšilo {n} vzpomínek' },
    eventNodes: 'uzlů',
    eventReasoning: 'uvažování',
    eventInterruptedUser: 'Přerušeno uživatelem',
    eventInterruptedTool: 'Přerušeno uživatelem během práce nástroje',
    eventInterruptedStepLimit: 'Zastaveno: tah dosáhl limitu {n} kroků',
    eventInterruptedParent: 'Zastaveno nadřazeným agentem',
    eventError: 'Chyba',
    eventErrorProviderRetries: 'Požadavek na poskytovatele selhal i po automatickém opakování. Zkuste to prosím znovu.',
    eventErrorCompactionStopped: 'Automatické zkracování kontextu selhalo {n}× po sobě, proto je v této konverzaci vypnuté. Začněte novou konverzaci, nebo spusťte /compact sami, až bude příliš velký obsah pryč.',
    eventErrorCompactionUnreachable: 'Automatické zkracování nedokáže zmenšit tuto konverzaci pod svůj práh: i po zkrácení má kontext asi {floor} tokenů, tedy nejméně {trigger} tokenů, při kterých se zkracování spouští. Automatické zkracování je tu proto vypnuté; /compact dál funguje a spolehlivým řešením je nová konverzace.',
    nativeCheckpointConversionFailed: 'Konverzaci se nepodařilo převést na čitelnou historii. Přihlaste se k původnímu účtu ChatGPT, ověřte povolení původního modelu a zkuste změnu znovu.',
    clientSessionStopped: 'Zpráva nebyla odeslána, protože toto okno bylo nahrazeno nebo zastaveno. Odešlete ji prosím znovu.',
    localTargetOffline: 'Počítač této konverzace je offline. Připojení Chettyho na tomto počítači neběží; spusťte ho tam a zkuste to znovu.',
    localWorkDirMissing: 'Pracovní adresář této konverzace na jejím počítači už neexistuje. Obnovte adresář, nebo začněte novou konverzaci v existujícím adresáři.',
    eventErrorModelSwitchFailed: 'Přepnutí modelu selhalo: {error}',
    commandCompacted: 'Konverzace byla zkrácena',
    commandNotCompactedAlready: 'Nezkráceno: konverzace už je zkrácená, od posledního shrnutí nepřibylo nic nového',
    commandNotCompactedNothing: 'Nezkráceno: zatím není co zkracovat',
    commandGoalSet: 'Cíl nastaven: {goal}',
    commandGoalDraft: 'Koncept cíle uložen: {goal}',
    commandGoalPaused: 'Cíl pozastaven',
    commandGoalResumed: 'Cíl obnoven',
    commandGoalCleared: 'Cíl zrušen',
    commandGoalNone: 'Žádný aktivní cíl',
    commandGoalStatus: 'Cíl {status} · {used}/{budget} {turns}',
    commandGoalSubgoals: 'Dílčí cíle {done}/{total}',
    commandGoalPausedReason: 'Pozastaveno: {reason}',
    commandGoalEvidence: 'Doklad: {evidence}',
    goalState: { active: 'aktivní', draft: 'koncept', paused: 'pozastaven', done: 'splněn' },
    commandFastOn: 'Rychlý režim je pro tento model zapnutý',
    commandFastOff: 'Rychlý režim je pro tento model vypnutý',
    commandFastUnavailable: 'Rychlý režim pro tento model není k dispozici',
    commandRestart: 'Restartuje se démon Chetty…',
    shellExit: 'návratový kód {code}',
    shellKilledTimeout: 'zastaveno: vypršel časový limit',
    shellKilledAbort: 'zastaveno',
    shellKilledOverflow: 'zastaveno: příliš velký výstup',
    shellOutput: 'Výstup příkazu',
    commandFailedRestartUnavailable: 'Restart není v tomto nasazení k dispozici',
    commandFailedNotRunning: 'Konverzace zatím neběží. Nejprve pošlete zprávu a pak to zkuste znovu.',
    contextCompacted: 'Kontext zkrácen',
    proposedPlan: 'Navržený plán',
    planImplement: 'Implementovat plán',
    planDecision: 'Plán čeká na vaše rozhodnutí. Můžete ho také dál zpřesňovat zprávami.',
    planRefine: 'Zpřesnit dál',
    planDecisionError: 'Rozhodnutí o plánu se nepodařilo potvrdit. Zkuste to znovu.',
    modeSwitchError: 'Režim konverzace se nepodařilo změnit. Zkuste to znovu.',
    statusReadError: 'Stav konverzace se nepodařilo načíst.',
    workMode: { build: 'Realizace', plan: 'Plánování', workflow: 'Postup' },
    actions: 'Možnosti',
    actionsTitle: 'Možnosti, režim: {mode}',
    workModeGroup: 'Režim práce',
    commandHints: {
      plan: 'Nejdřív promyslet postup, zatím bez úprav',
      build: 'Provádět změny pomocí nástrojů',
      workflow: 'Řídit úkol jako graf sub-agentů',
      compact: 'Shrnout konverzaci a uvolnit místo v kontextu',
      rename: 'Přejmenovat tuto konverzaci',
      new: 'Začít novou konverzaci',
      model: 'Přepnout model',
    },
    /** A picker command a plugin published that this build has no renderer for. A refusal, not a result:
     *  nothing opened, and the reader is told where the command does work. */
    renameTitle: 'Přejmenovat konverzaci',
    commandField: {
      open: 'Otevřít pole příkazů',
      title: 'Pole příkazů',
      compact: 'Zhustit',
      rename: 'Přejmenovat',
      newChat: 'Nová konverzace',
      model: 'Model',
    },
    queued: 'Ve frontě',
    removeFromQueue: 'Odebrat z fronty',
    queueRemoveError: 'Zprávu se nepodařilo odebrat. Stále čeká ve frontě na doručení.',
    queueDetachCapacity: 'Dosažen limit procesů na pozadí.',
    queueDetachUnavailable: 'Běžící práci nelze přesunout na pozadí.',
    toolRunning: 'Probíhá',
    reasoningLabel: 'Uvažování',
    turnDuration: 'Doba běhu',
    workLive: 'Pracuji…',
    workDuration: 'Doba práce: {duration}',
    workLog: 'Průběh práce',
    workStopped: 'Zastaveno',
    workStoppedAfter: 'Zastaveno po {duration}',
    workFailed: 'Selhalo',
    workFailedAfter: 'Selhalo po {duration}',
  },
  chat: {
    historyTitle: 'Konverzace',
    openHistory: 'Všechny konverzace',
    openRegister: 'Všechny konverzace',
    registerHint: 'Úplný přehled konverzací z webu, CLI, kanálů i úloh agentů.',
    moreOptions: 'Další možnosti',
    showStats: 'Zobrazit statistiky',
    hideStats: 'Skrýt statistiky',
    todos: 'Úkoly',
    emptyHistory: 'Zatím žádné konverzace',
    rename: 'Přejmenovat',
    renamePlaceholder: 'Název konverzace',
    renameError: 'Konverzaci se nepodařilo přejmenovat',
    conversationNamePlaceholder: 'Automatický název',
    pin: 'Připnout konverzaci',
    unpin: 'Odepnout konverzaci',
    pinError: 'Připnutí konverzace se nepodařilo změnit',
    fork: 'Větvit konverzaci',
    forkError: 'Konverzaci se nepodařilo rozvětvit',
    exportHtml: 'Exportovat jako HTML',
    exportJsonl: 'Exportovat jako JSONL',
    exportError: 'Export se nepodařil',
    moreActions: 'Další akce',
    roleYou: 'Vy',
    roleElowen: 'Chetty',
    activityIdle: 'Nedávno neproběhla žádná aktivita',
    activityWorking: 'Probíhá práce',
    activityPermission: 'Čeká na schválení',
    activityQuestion: 'Čeká na odpověď',
    activityBackground: 'Probíhá práce na pozadí',
    activityDone: 'Dokončeno',
    activityDoneScheduled: 'Naplánovaná úloha dokončena',
    activityFailed: 'Běh se nezdařil',
    activityUnread: 'Nepřečtený výsledek',
    participants: 'Členové',
    membersCount: 'Členové {count}',
    inviteHeading: 'Pozvat…',
    removeMemberLabel: 'Odebrat z konverzace: {name}',
    participantsLoadFailed: 'Účastníky se nepodařilo načíst.',
    participantChangeFailed: 'Účastníky se nepodařilo změnit.',
    inviteConfirm: 'Pozvat',
    inviteConfirmTitle: 'Pozvat do této konverzace?',
    inviteConfirmBody: 'Uvidí celou historii.',
    invited: '{name} byl(a) pozván(a).',
    alreadyParticipant: 'Už je v konverzaci',
    noInvitable: 'Nikoho dalšího nelze pozvat.',
    invitableLoadFailed: 'Lidi k pozvání se nepodařilo načíst.',
    clearFilter: 'Vymazat filtr',
    noPeopleMatch: 'Filtru neodpovídá nikdo.',
    inviteFailed: {
      notShareable: 'Tuto konverzaci nelze sdílet.',
      generic: 'Pozvánku se nepodařilo odeslat.',
    },
    leaveConversation: 'Opustit konverzaci',
    leaveConfirm: 'Opustit tuto konverzaci?',
    leaveConfirmBody: 'Ruční pozvání bude zrušeno. Přístup zajištěný pluginem zůstane zachován.',
    removedFromConversation: 'Byl(a) jste odebrán(a) z této konverzace.',
    conversationUnavailable: 'Konverzace není dostupná.',
    ownerOnlyControl: 'Může měnit jen majitel konverzace.',
    ownerDecidesPlan: 'O plánu rozhoduje majitel konverzace.',
    queuedBy: 'Ve frontě od {name}',
    replyTo: 'Odpověď na',
    jumpToMessage: 'Přejít na původní zprávu',
    messageUnavailable: 'Zpráva už není k dispozici.',
    react: 'Reagovat',
    reactionUp: 'Palec nahoru',
    reactionDown: 'Palec dolů',
    reactedBy: 'Reagovali: {names}',
    reactionFailed: 'Reakci se nepodařilo uložit.',
    mentionPlaceholder: 'Zmínit někoho',
    mentionOwnerOnly: 'Pozvat může jen majitel konverzace.',
    mentionNotParticipantError: 'Zmíněný účet už není v konverzaci.',
    mentionsYou: 'Zmiňuje vás',
    mentionChip: 'Zmínka:',
    mentionAgentHint: 'Odpoví na tuto zprávu',
    ownerBadge: 'Majitel',
    agentGroup: 'Sdílená konverzace',
    pauseAgent: 'Pozastavit agenta',
    pauseAgentHint: 'Lidé si píší, agent zatím neodpovídá',
    resumeAgent: 'Spustit agenta',
    resumeAgentHint: 'Agent odpoví na další zprávu a uvidí vše',
    agentPaused: 'Agent je pozastavený. Zprávy uvidí po spuštění, nebo hned, když ho zmíníte přes @Chetty.',
    agentPauseFailed: 'Stav agenta se nepodařilo změnit.',
  },
  telemetry: {
    title: 'Telemetrie',
    contextUsed: 'Využito',
    contextTokens: 'Tokeny',
    cost: 'Cena',
    resize: 'Šířka panelu telemetrie',
    open: 'Zobrazit telemetrii',
    close: 'Skrýt telemetrii',
    collapse: 'Sbalit panel telemetrie',
    expand: 'Rozbalit panel telemetrie',
    statusRunning: 'Probíhá práce',
    statusIdle: 'Nečinný',
    empty: 'Zatím nejsou k dispozici žádná data.',
    limits: 'Limity',
    goal: 'Cíl',
    goalTurns: { one: 'tah', few: 'tahy', many: 'tahů' },
    goalSubgoals: 'Podcíle',
    goalProgress: 'Průběh: {text}',
    tasks: 'Úkoly',
    tasksOpen: 'Otevřít seznam úkolů',
    taskWaiting: 'čeká na {ids}',
    workflow: 'Workflow',
    branch: 'větev',
  },
  workflowModal: {
    elapsed: 'Doba běhu',
    graph: 'Graf uzlů workflow',
    wave: 'Vlna {n}',
    gone: 'Toto workflow už není v živém přehledu.',
    statusPending: 'čeká',
    statusRunning: 'běží',
    statusDone: 'hotovo',
    statusError: 'selhalo',
    deps: 'Závisí na',
    depsNone: 'bez závislostí',
    result: 'Výsledek',
    error: 'Chyba',
    activity: 'Průběh',
    working: 'Pracuje…',
    failed: 'Uzel selhal.',
    notStarted: 'Uzel zatím nezačal.',
    noOutput: 'Nebyl uveden žádný výstup.',
    openConversation: 'Otevřít konverzaci',
    openUnavailable: 'Dostupné po spuštění uzlu.',
    followLive: 'Sledovat průběh',
    followLiveHint: 'Výběrem běžícího uzlu obnovíte sledování.',
    backToGraph: 'Graf',
    feeds: 'Navazuje',
    task: 'Úloha',
    model: 'Model',    status: 'Stav',

    reasoning: 'Uvažování',
    tokens: 'Tokeny',
    speed: 'Rychlost',
    time: 'Čas',
    waveCount: '{n} souběžně',
    finishedOf: 'Dokončeno {done} z {total}',
    runStopped: 'Zastaveno',
    reconnecting: 'Živé aktualizace jsou pozastavené, obnovuje se spojení…',
    planBuilding: 'Plán se zatím připravuje.',
    keysMove: 'Šipky: pohyb',
    keysOpen: 'Enter: otevřít',
    keysClose: 'Esc: zavřít',
    stop: 'Zastavit workflow',
    stopConfirm: 'Zastavit toto workflow a jeho běžící uzly?',
    stopFailed: 'Workflow se nepodařilo zastavit.',
    terminalNode: '{id}: {status}',
    resultFailed: 'Úplný výsledek uzlu se nepodařilo načíst.',
    resultReleased: 'Zobrazuje se zkrácený náhled; úplný výsledek už není v živém přehledu. Celý jej najdete v konverzaci uzlu.',

  },
  access: {
    statusConnected: 'Připojeno',
    statusMissing: 'Chybí povinné údaje',
    statusReconnect: 'Nutné znovu připojit',
    statusUnset: 'Nenastaveno',
    emptyTitle: 'Žádné přístupy',
    emptyDescription: 'Žádný zapnutý plugin nevyžaduje klíč, token ani heslo.',
    reconnectHint: 'Uložený údaj už nelze přečíst. Zadejte jej znovu.',
    loadFailed: 'Přístupové údaje tohoto pluginu se nepodařilo načíst.',
    cardDescription: 'Klíče a hesla tohoto pluginu se nastavují na jednom místě, v Nastavení → Přístupy.',
    open: 'Otevřít v Přístupech',
  },
  pluginCfg: {
    roleAdmin: 'Přístup administrátora',
    roleAdminHint: 'Označuje důvěryhodnou roli administrátora platformy. Projekty a oprávnění k nástrojům se dál přebírají z propojeného účtu Chettyho.',
    roleAdminBadge: 'Administrátor',
    sectionConnection: 'Připojení a přístupové údaje',
    sectionConnectionHint: 'Tokeny, ID a adresy koncových bodů. Ukládají se na serveru a znovu se nezobrazují.',
    sectionBehavior: 'Chování',
    back: 'Pluginy',
    invalidJson: 'Před uložením této změny zadejte platný JSON.',
    numberRange: 'Povolený rozsah: {min}–{max}.',
    editorEmpty: 'Prázdné',
    editorLines: '{n} řádků',
    editorItems: '{n} položek',
    secretSet: 'Uloženo',
    secretUnreadable: 'Nečitelné, zadejte znovu',
    secretKeepHint: 'Uložená hodnota zůstane beze změny, dokud ji nenahradíte. Nahrazení prázdnou hodnotou ji smaže.',
    secretReplace: 'Nahradit',
    secretReplaceHint: 'Uloží se po opuštění pole nebo klávesou Enter. Prázdné pole uloženou hodnotu smaže, klávesa Esc nahrazení zruší.',
    secretPlaceholder: 'Zadejte hodnotu',
    secretReplacementPlaceholder: 'Zadejte náhradu',
    noProviders: 'Není k dispozici žádný vhodný poskytovatel. Přidejte ho v Nastavení → Chetty AI.',
    catalogProjects: 'Projekty',
    catalogPlugins: 'Pluginy, které lze přidělit',
    timezoneServerDefault: 'Výchozí časové pásmo serveru',
    timezoneBrowserDetected: 'Časové pásmo zjištěné prohlížečem',
    timezoneCatalog: 'Časová pásma',
    timezoneSaved: 'Uložená hodnota',
    timezoneCustom: 'Vlastní časové pásmo IANA',
    timezoneCustomPlaceholder: 'např. Pacific/Kiritimati',
    userMissing: 'Účet nenalezen',
    usersLoadFailed: 'Účty se nepodařilo načíst',
    tokenListAdd: 'Přidat do pole {label}',
    tokenListItems: 'Položky pole {label}',
    tokenListRemove: 'Odebrat {value}',
    tokenListBrowse: 'Procházet adresáře',
    tokenListPlaceholder: 'Hodnota, poté Enter',
    noRoles: 'Zatím žádné role',
    noRolesHint: 'Uživatelé bez namapované role jsou ignorováni.',
    roleNew: 'Nová role',
    roleId: 'ID role',
    roleName: 'Název',
    rolePrompt: 'Prompt pro roli',
    addRole: 'Přidat roli',
    removeRole: 'Odebrat roli',
    removingRole: 'Odebírání…',
    removeRoleTitle: 'Odebrat pravidlo role „{name}“?',
    removeRoleDescription: 'Uložením tohoto pravidla se změní oprávnění uživatelů s rolí „{name}“. Mohou ztratit přístup nebo administrátorská oprávnění.',
    valueRefused: 'Server tuto hodnotu odmítl. Zkontrolujte zadané údaje a zkuste to znovu.',
    roleActivationPending: 'Pravidlo role je uložené. Aktivace oprávnění počká na dokončení právě probíhající práce.',
  },
  terminal: {
    saveError: 'Nepodařilo se uložit nastavení terminálu.',
    fontTitle: 'Písmo',
    fontSize: 'Velikost',
    fontFamily: 'Typ písma',
    fonts: { system: 'Systémové', menlo: 'Menlo / Consolas', ibm: 'IBM Plex Mono', courier: 'Courier' },
    cursorTitle: 'Kurzor',
    cursorStyle: 'Styl',
    cursorBlink: 'Blikání kurzoru',
    cliTitle: 'CLI chat',
    showThoughts: 'Zobrazovat řádky s uvažováním (Thought) v CLI',
    showThoughtsHelp: 'Řádky s uvažováním modelu v přepisu konverzace. Rychlé přepnutí: /reasoning show.',
    promptHistoryDepth: 'Historie promptů',
    promptHistoryDepthHelp: 'Kolik odeslaných promptů si chat uchovává pro vyvolání šipkou nahoru. CLI ukládá historii pro každý projekt na tomto počítači, web pro Váš účet v tomto prohlížeči napříč konverzacemi. Hloubka se přenáší s účtem. Rozsah 20–1 000, výchozí hodnota 100.',
    lineUnit: 'řádků',
    cursorBlock: 'Blok',
    cursorBar: 'Čára',
    cursorUnderline: 'Podtržítko',
    historyTitle: 'Historie',
    scrollback: 'Řádky',
    scrollbackHelp: 'Kolik řádků historie si terminál pamatuje.',
    colorsTitle: 'Barvy',
    colorsHelp: 'Automatický režim použije tmavou paletu terminálu. Vlastní režim použije vaši paletu.',
    themeMode: 'Barevné téma',
    themeAuto: 'Automaticky',
    themeCustom: 'Vlastní',
    loadPreset: 'Načíst předvolbu',
    presetPlaceholder: 'Vyberte předvolbu…',
    palette: {
      background: 'Pozadí', foreground: 'Text', cursor: 'Kurzor', cursorAccent: 'Zvýraznění kurzoru', selectionBackground: 'Výběr',
      black: 'Černá', red: 'Červená', green: 'Zelená', yellow: 'Žlutá', blue: 'Modrá', magenta: 'Purpurová', cyan: 'Azurová', white: 'Bílá',
      brightBlack: 'Jasná černá', brightRed: 'Jasná červená', brightGreen: 'Jasná zelená', brightYellow: 'Jasná žlutá', brightBlue: 'Jasná modrá', brightMagenta: 'Jasná purpurová', brightCyan: 'Jasná azurová', brightWhite: 'Jasná bílá',
    },
  },
  cli: {
    // Account → Models. The shared role vocabulary (Model roles, Inherit, Inherited) is read from
    // `settings.modelRoles`, so both pages say the same words for the same thing.
    modelRolesHint: 'Který model používají vaše konverzace.',
    chatRuntimeTitle: 'Chod konverzace',
    promptSuggestions: 'Návrhy další zprávy',
    promptSuggestionsHint: 'Po dokončení odpovědi nabídne návrh ve webu i CLI. Používá další placený požadavek na model návrhů další zprávy; bez výslovné volby to je pomocný model.',
    chatRuntimeHint: 'Jak se konverzace chová. Žádná z těchto voleb nevybírá model.',
    // A stored pick the catalog no longer offers. The runtime does not honour it — the spawn chain
    // skips a refused selection and compaction discards a stale one — so the row names what runs.
    unavailableBadge: 'Nedostupný',
    unavailableSummary: '{model} není dostupný. Použije se {fallback}.',
    unavailableNoFallback: 'bez náhradního modelu',
    projectPinFallback: 'Pro tento projekt se použije náhradní model {fallback}.',
    inheritUnknown: 'Zděděno',
    unreadableTitle: 'Některá uložená nastavení nelze přečíst',
    unreadableDesc: 'Tato uložená nastavení jsou poškozená a zobrazují se jako prázdná: {names}. Změny v nich se odmítnou, dokud je neobnovíte.',
    unreadableReset: 'Obnovit nečitelná nastavení',
    unreadableResetTitle: 'Obnovit nečitelná nastavení?',
    unreadableResetDesc: 'Poškozené hodnoty se odstraní a nelze je získat zpět. Vaše volby pro ně začnou od prázdných.',
    unreadableResetConfirm: 'Obnovit',
    unreadableResetPending: 'Obnovuji',
    unreadableKeys: {
      autoCompactAtByModel: 'Prahy shrnutí podle modelu',
      projectModelPreferences: 'Modely podle projektu',
      fastModels: 'Modely s rychlým režimem',
    },
    primaryModelLabel: 'Hlavní model',
    visionModelLabel: 'Záložní model pro obrázky',
    visionInherit: 'Převzít: {model} (čte obrázky)',
    visionNoFallback: 'Bez náhradního modelu: obrázky se nebudou zpracovávat',
    visionNoFallbackBadge: 'Bez náhradního modelu',
    compactModelLabel: 'Model pro zkrácení kontextu',
    projectModelsTitle: 'Modely podle projektu',
    projectModelsCount: 'Projektů: {n}',
    projectModelsNone: 'Žádné',
    projectModelsEmpty: 'Zatím žádný projekt nemá vlastní model.',
    projectModelsClear: 'Zrušit model připnutý k projektu {project}',
    instanceModelsTitle: 'Modely instance',
    openSettings: 'Otevřít nastavení',
    thinkingLabel: 'Úroveň uvažování',
    thinkingDefault: 'Výchozí',
    autoCompact: 'Automaticky zkracovat kontext',
    autoCompactToggle: 'Automaticky zkracovat dlouhé konverzace',
    autoCompactAt: 'Zkrátit při zaplnění kontextu',
    compactByModelTitle: 'Zkrácení kontextu podle modelu',
    compactByModelGlobal: 'Výchozí práh',
    compactByModelGlobalHint: 'Podíl okna kontextu, při kterém se konverzace zkrátí. Použije se u každého modelu, který má níže vlastní hodnotu.',
    compactByModelOwn: 'vlastní',
    compactByModelFilter: 'Filtrovat modely',
    compactByModelNone: 'Tomuto filtru neodpovídá žádný model',
    fastModeTitle: 'Rychlý režim',
    fastModeUnavailable: 'Rychlý režim není pro vaše modely dostupný',
    fastModeRoutes: 'Rychlý režim funguje s přihlášením přes ChatGPT, s API klíči OpenAI a Azure OpenAI a s API klíčem Anthropic, pro modely, které katalog uvádí s touto funkcí. Modely v předplatném Claude ho nepodporují.',
    yoloTitle: 'Režim YOLO',
    yoloToggle: 'Automaticky schvalovat požadavky na použití nástrojů (YOLO)',
    yoloWarning: 'Po zapnutí se ve všech nových relacích automaticky schválí požadavky na použití nástrojů a spuštění příkazů. Pravidla výslovně zakazující akci zůstávají v platnosti. Používejte obezřetně.',
    yoloConfirmTitle: 'Povolit režim YOLO?',
    yoloConfirm: 'Povolit YOLO',
    unattendedTitle: 'Běhy bez dohledu',
    unattendedAllow: 'Povolit',
    unattendedDeny: 'Blokovat',
    permTitle: 'Oprávnění příkazů',
    permToolsTitle: 'Pravidla nástrojů',
    permEmpty: 'Zatím žádná pravidla. Zobrazí se tu příkazy, které v chatu schválíte volbou „Povolit vždy“.',
    permPatternPlaceholder: 'např. git status*',
    permAdd: 'Přidat',
    permDeleteTitle: 'Smazat toto pravidlo?',
    permAllow: 'Povolit',
    permAsk: 'Zeptat se',
    permDeny: 'Zakázat',
    permMore: 'a dalších {n}',
    saveError: 'Uložení nastavení selhalo',
  },
  alerts: {
    bellLabel: 'Upozornění',
    panelTitle: 'Upozornění',
    markAllRead: 'Označit vše jako přečtené',
    markRead: 'Označit jako přečtené',
    dismiss: 'Skrýt',
    emptyTitle: 'Žádná upozornění',
    emptyDescription: 'Nová upozornění se zobrazí zde.',
    loadError: 'Upozornění se nepodařilo načíst.',
    saveError: 'Nastavení se nepodařilo uložit.',
    prefsTitle: "Oznámení",
    kinds: "Druhy oznámení",
    kindsHint: "Vyberte, co se zobrazí ve zvonku a na přihlášených zařízeních. Ztlumené druhy nedorazí nikam. Nové druhy jsou ve výchozím stavu zapnuté.",
    enabledCount: "Zapnuto {n} z {total}",
    manage: "Spravovat oznámení",
  },
  push: {
    title: "Toto zařízení",
    deviceToggle: "Push oznámení",
    deniedStatus: "Zablokováno",
    denied: "Povolte oznámení v nastavení webu v prohlížeči a poté se sem vraťte.",
    unsupported: "Nepodporováno",
    error: "Oznámení se nepodařilo nastavit.",
    homeScreen: "Přidejte Chetty na plochu",
    homeScreenHint: "V Safari zvolte Sdílet → Přidat na plochu. Poté otevřete Chetty z ikony na ploše a povolte oznámení.",
    updateRequired: "Aktualizujte iOS",
    updateRequiredHint: "Oznámení z plochy vyžadují iOS nebo iPadOS 16.4 či novější.",
    reenable: "Znovu zapnout",
    reenableHint: "Po změně klíče oznámení znovu připojte toto zařízení.",
    impersonationHint: "Oznámení zařízení nelze měnit při zastupování jiného účtu.",
  },
  assetEditor: {
    search: 'Hledat…',
    emptySearch: 'Filtru nic neodpovídá',
    filterAll: 'Vše',
    filterUser: 'Vlastní',
    filterBuiltin: 'Vestavěné',
    colName: 'Název',
    colSource: 'Zdroj',
    openRow: 'Otevřít položku: {name}',
    selectRow: 'Vybrat položku: {name} ({scope})',
    selectedCount: 'Vybráno: {n}',
    clearSelection: 'Zrušit výběr',
    bulkEnable: 'Povolit vybrané',
    bulkDisable: 'Zakázat vybrané',
    bulkDelete: 'Smazat vybrané',
    bulkDeleteTitle: 'Smazat vybrané položky?',
    bulkDeleteBody: 'Smazat vybrané položky ({n})? Tuto akci nelze vrátit.',
  },
  desktop: {
    viewerConnection: 'Připojení obrazovky',
    controlConnection: 'Připojení ovládání',
    moreActions: 'Další možnosti',
    pictureQuality: 'Kvalita',
    pictureSpeed: 'Rychlost',
    dismissNarration: 'Skrýt zprávu agenta',
    enlarge: 'Zvětšit náhled',
    closeView: 'Zavřít náhled',
    takeControl: 'Převzít ovládání',
    returnToAgent: 'Vrátit agentovi',
    controlledElsewhere: 'Ovládáno v jiném okně',
    statusClosed: 'Ukončeno',
    statusViewerLimit: 'Příliš mnoho diváků',
    statusDisconnected: 'Odpojeno',
    statusStalled: 'Náhled se neobnovuje',
    statusHandoverPending: 'Čeká se na dokončení aktuální akce',
    statusYouControl: 'Ovládáte vy',
    statusUserControl: 'Ovládá uživatel',
    statusWaitingForUser: 'Čeká se na váš vstup',
    statusAgentControl: 'Ovládá agent',
    statusConnecting: 'Připojování',
    connecting: 'Připojuje se obraz obrazovky\u2026',
    unavailable: 'Živý náhled není k dispozici',
    openToView: 'Otevřete obrazovku, abyste ji viděli živě.',
    agentWaiting: 'Agent čeká, až mu vrátíte ovládání',
    requestFailed: 'Požadavek na plochu selhal.',
  },
  pluginUi: {
    eyebrow: 'Rozšíření',
    unavailableTitle: 'Rozhraní není k dispozici',
    manage: 'Spravovat pluginy',
    pickerUnavailable: '/{command} z pluginu {plugin} zde nelze zobrazit.',
    notGranted: 'Tento doplněk není k dispozici. Může být vypnutý, chybět nebo nemusíte mít přidělený přístup. Administrátor může zkontrolovat nastavení pluginů a oprávnění účtu.',
    incompatible: 'Tento plugin vyžaduje novější verzi aplikace. Pro použití jeho rozhraní aktualizujte server.',
    loadFailed: 'Rozhraní pluginu se nepodařilo načíst. Zkontrolujte záznamy pluginu v Nastavení → Pluginy.',
    pageMissing: 'Plugin nemá na této adrese žádnou stránku.',
    settingsUnavailable: 'Plugin pro tuto sekci neposkytuje žádný panel nastavení.',
    crashed: 'V rozhraní pluginu došlo k chybě. Zbytek aplikace to neovlivňuje.',
  },
  help: {
    embeddingDimensions: "Ponechte prázdné pro výchozí velikost vektoru daného modelu.",
    embeddingProvider: 'Klíč API se přebírá od vybraného poskytovatele modelu (Nastavení → Modely).',
    embeddingIntro: 'Převádí vzpomínky na vektory, aby je šlo vyhledávat podle významu. Platí pro celý pracovní prostor.',
    rolePrompt: 'Další pokyny, které se přidávají do konverzací této role.',
    projectNotes: "Kontext dostupný asistentovi při práci v tomto projektu.",
    projectPath: "Absolutní cesta k projektu na disku.",
    projectSlug: "Krátký identifikátor, např. chetty.",
    computerName: 'Název, pod kterým se tento počítač zobrazuje v projektech a ve výběru projektu v chatu.',
    accountPlatformLinks: 'Propojte chatovací účet, aby asistent na dané platformě rozpoznal vaše zprávy a zpřístupnil vám vaše nástroje a oprávnění. Zobrazí se jen platformy, ke kterým je tato instance připojená.',
    accountUiScale: "Rozhraní se přizpůsobí šířce okna. Tímto posuvníkem nastavíte jeho velikost oproti normálu (výchozí je 100 %) pro toto zařízení.",
    memoryRecall: "Po odeslání vaší zprávy se automaticky prohledá paměť a nejrelevantnější vzpomínky se přidají jako kontext k odpovědi.",
    memoryLiveRecall: 'Asistent může během práce znovu vyhledat vzpomínky podle toho, co právě dělá: které soubory otevírá, jaké nástroje spouští a na jaké chyby narazí. Bez této možnosti vychází jen z vaší úvodní zprávy, která nemusí vystihovat další průběh práce.',
    memorySave: "Po odpovědi asistenta se z konverzace na pozadí uloží nové trvalé poznatky do vaší paměti.",
    skillLearning: "Chetty se čas od času na pozadí podívá na poslední výměnu a uloží opakovaně použitelný postup jako váš osobní skill, dostupný stejně jako skilly, které si uložíte sami. Později smí vylepšovat jen skilly, které sám napsal; jakmile skill upravíte, zůstane váš. Ve výchozím stavu je vypnuto.",
    cliAutoCompact: "Když se konverzace blíží limitu kontextu modelu, shrne ji a uvolní místo.",
    cliPrimaryModel: 'Každá vaše nová konverzace začne s tímto modelem. Pokud ponecháte nastavení na převzaté hodnotě, použije se výchozí model instance.',
    cliProjectModels: 'Když v projektu Git přepnete model, zapamatuje se pro daný projekt a použije se ve všech dalších konverzacích v něm. Zrušením volby vrátíte projekt k vašemu hlavnímu modelu.',
    cliInstanceModels: 'Role platné pro celou instanci, tedy pomocný model, denní přehled a embedding, se nastavují v Nastavení → Modely. Pouze pro administrátory.',
    cliThinking: 'Jak důkladně model přemýšlí, než odpoví. Vyšší úroveň znamená pečlivější, ale pomalejší odpovědi. Při volbě Výchozí rozhodne model. Platí pro výše uvedený hlavní model.',
    cliVisionModel: 'Použije se u zpráv s obrázky, které hlavní model neumí přečíst. Pokud ponecháte nastavení na převzaté hodnotě, obrázky zpracuje hlavní model. Pokud je přečíst neumí, zobrazí se to u dané volby.',
    cliCompactModel: 'Model pro automatické shrnutí konverzace i ruční příkaz /compact. Může využívat jiného poskytovatele než model chatu, například levnějšího. Pokud pole necháte prázdné, shrnutí vytvoří model dané konverzace.',
    cliFastMode: 'Vyberte modely, které používají rychlý režim, ve všech konverzacích i sub-agentech. Příkaz /fast ho zapne nebo vypne pro model aktuální konverzace.',
    cliCompactByModel: 'Velikost kontextu se u jednotlivých modelů liší, takže stejné procento odpovídá různému množství. Nastavte mez zkrácení kontextu pro každý vybraný model zvlášť. Ostatní použijí výše nastavenou výchozí hodnotu.',
    cliUnattendedAsks: 'Výzvy ke schválení se zobrazují jen v chatu, kde může někdo odpovědět, tedy na webu nebo v příkazovém řádku. U běhů bez dozoru, například u plánovaných úloh, v kanálech platforem a u sub-agentů, nemá kdo odpovědět. Pravidla „ask“ se proto buď automaticky povolí (výchozí nastavení), nebo zablokují (přísný režim). Výslovná pravidla allow/deny platí dál. YOLO přísné blokování nepřekoná.',
    cliPermissions: 'Pravidla pro příkazy terminálu, které asistent spouští. Znak * zastupuje libovolný text. Příklady: „git status*“ → Povolit spustí příkaz bez dotazu, „rm *“ → Zakázat příkaz vždy zablokuje. Pozdější pravidlo má přednost před dřívějším, rozhoduje poslední shoda. Nové pravidlo se přidá na konec; při opětovném přidání se tam přesune i existující vzor. Příkaz terminálu, který žádné pravidlo nezachytí, se spustí bez dotazu. Zobrazí se zde také příkazy, které jste v chatu schválili volbou „Povolit vždy“.',
    pushEnable: 'Upozorníme vás, když je odpověď hotová nebo něco vyžaduje vaši pozornost, i když je aplikace zavřená.',
    tokenTtl: "Po kolika dnech vyprší přihlašovací token (vynutí nové přihlášení)",
    pushContact: 'Adresa pro podpis push oznámení, na které vás push služba může kontaktovat ohledně této instance. Musí být skutečná a dostupná, jinak Apple oznámení odmítne. Nechte pole prázdné, chcete-li použít veřejnou adresu této instance.',
    pluginsManage: 'Vestavěné pluginy jsou součástí aplikace, uživatelské se instalují z tržiště. Zapnutí, vypnutí a odebrání pluginu restartuje Chettyho. Odebraný vestavěný plugin se skryje a přestane načítat; kdykoli ho můžete obnovit v nabídce Dostupné. Odinstalací uživatelského pluginu se smažou i jeho soubory.',
    pluginEnable: 'Zapnutí nebo vypnutí se spojí s dalšími změnami v krátkém klidovém okně a poté restartuje Chettyho. Rozpracovaná práce se uloží a po restartu pokračuje. Čeká se pouze na práci, ve které nelze pokračovat. Nezodpovězené otázky se ztratí.',
  },
} as const;
